// Este arquivo foi gerado automaticamente pelo script Python.
// Contém dados de spawn de monstros agrupados por ID.

function MapaMonstro(ID) {

  let maps = monsterSpawnData[ID];

  if(maps == null) {
    return [{
      "location": "Nenhum Mapa Encontrado",
      "quantity": 'Monstro de Quest, Evento ou Instância',
      "monsterName": "Poring"
    }]
  }

  return(maps)
}

export { MapaMonstro };


const monsterSpawnData = {
  1002: [
    {
      "location": "prt_fild08",
      "quantity": 110,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08a",
      "quantity": 110,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08b",
      "quantity": 110,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08c",
      "quantity": 110,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08d",
      "quantity": 110,
      "monsterName": "Poring"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Poring"
    },
    {
      "location": "xmas_dun01",
      "quantity": 12,
      "monsterName": "Poring"
    },
    {
      "location": "gef_fild00",
      "quantity": 34,
      "monsterName": "Poring"
    },
    {
      "location": "gef_fild07",
      "quantity": 20,
      "monsterName": "Poring"
    },
    {
      "location": "pay_fild01",
      "quantity": 38,
      "monsterName": "Poring"
    },
    {
      "location": "pay_fild03",
      "quantity": 25,
      "monsterName": "Poring"
    },
    {
      "location": "pay_fild04",
      "quantity": 16,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild01",
      "quantity": 42,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild06",
      "quantity": 32,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 2,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 5,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Poring"
    }
  ],
  1063: [
    {
      "location": "prt_fild08",
      "quantity": 100,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08a",
      "quantity": 100,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08b",
      "quantity": 100,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08c",
      "quantity": 100,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08d",
      "quantity": 100,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Lunatic"
    },
    {
      "location": "gef_fild04",
      "quantity": 25,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild01",
      "quantity": 196,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild06",
      "quantity": 32,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 2,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 5,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 10,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 10,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 10,
      "monsterName": "Lunatic"
    },
    {
      "location": "prt_fild08",
      "quantity": 10,
      "monsterName": "Lunatic"
    }
  ],
  1007: [
    {
      "location": "prt_fild08",
      "quantity": 100,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08a",
      "quantity": 100,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08b",
      "quantity": 100,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08c",
      "quantity": 100,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08d",
      "quantity": 100,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Fabre"
    },
    {
      "location": "gef_fild00",
      "quantity": 34,
      "monsterName": "Fabre"
    },
    {
      "location": "gef_fild04",
      "quantity": 25,
      "monsterName": "Fabre"
    },
    {
      "location": "gef_fild07",
      "quantity": 20,
      "monsterName": "Fabre"
    },
    {
      "location": "pay_fild01",
      "quantity": 38,
      "monsterName": "Fabre"
    },
    {
      "location": "pay_fild03",
      "quantity": 130,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild01",
      "quantity": 42,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild06",
      "quantity": 149,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 10,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 2,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 5,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Fabre"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Fabre"
    }
  ],
  2398: [
    {
      "location": "prt_fild08",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "prt_fild08a",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "prt_fild08b",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "prt_fild08c",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "prt_fild08d",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "new_1-3",
      "quantity": 30,
      "monsterName": "Little Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Little Poring"
    }
  ],
  1085: [
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_maze01",
      "quantity": 2,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_maze03",
      "quantity": 2,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_maze03",
      "quantity": 3,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "bra_fild01",
      "quantity": 5,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "ein_fild07",
      "quantity": 12,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "ein_fild08",
      "quantity": 13,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "ein_fild09",
      "quantity": 13,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild02",
      "quantity": 6,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "gef_fild09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "mjolnir_09",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "pay_fild02",
      "quantity": 4,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "pay_fild03",
      "quantity": 6,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "pay_fild06",
      "quantity": 8,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_fild10",
      "quantity": 16,
      "monsterName": "Red Mushroom"
    },
    {
      "location": "prt_fild11",
      "quantity": 10,
      "monsterName": "Red Mushroom"
    }
  ],
  1084: [
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "un_bunker",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "bra_dun01",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "bra_dun02",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gef_dun00",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gef_dun00",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gef_dun01",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "iz_dun00",
      "quantity": 6,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "iz_dun01",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "iz_dun02",
      "quantity": 15,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "lou_dun01",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "orcsdun01",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "orcsdun01",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "orcsdun02",
      "quantity": 5,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "pay_dun00",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "pay_dun01",
      "quantity": 7,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "pay_dun02",
      "quantity": 7,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "prt_maze01",
      "quantity": 2,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "prt_maze03",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "prt_maze03",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Black Mushroom"
    },
    {
      "location": "prt_fild07",
      "quantity": 3,
      "monsterName": "Black Mushroom"
    }
  ],
  2404: [
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n1",
      "quantity": 7,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 4,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 4,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n1",
      "quantity": 10,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n1",
      "quantity": 7,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 4,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Dead Plankton"
    },
    {
      "location": "treasure_n2",
      "quantity": 4,
      "monsterName": "Dead Plankton"
    }
  ],
  1078: [
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "gon_dun01",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun00",
      "quantity": 15,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun01",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun02",
      "quantity": 4,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun02",
      "quantity": 4,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 15,
      "monsterName": "Red Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 15,
      "monsterName": "Red Plant"
    },
    {
      "location": "ein_fild04",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ein_fild06",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ein_fild07",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ein_fild08",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ein_fild09",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "gef_fild05",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "lhz_fild01",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "lhz_fild03",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Red Plant"
    },
    {
      "location": "mjolnir_05",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ra_fild12",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "um_fild02",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "um_fild04",
      "quantity": 5,
      "monsterName": "Red Plant"
    },
    {
      "location": "ve_fild01",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ve_fild02",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "ve_fild03",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 15,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild02",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild03",
      "quantity": 15,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild04",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild06",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild07",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild08",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild09",
      "quantity": 10,
      "monsterName": "Red Plant"
    },
    {
      "location": "yuno_fild11",
      "quantity": 10,
      "monsterName": "Red Plant"
    }
  ],
  1080: [
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "glast_01",
      "quantity": 8,
      "monsterName": "Green Plant"
    },
    {
      "location": "glast_01",
      "quantity": 8,
      "monsterName": "Green Plant"
    },
    {
      "location": "odin_tem01",
      "quantity": 7,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 25,
      "monsterName": "Green Plant"
    },
    {
      "location": "ayo_fild01",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "ein_fild03",
      "quantity": 15,
      "monsterName": "Green Plant"
    },
    {
      "location": "ein_fild04",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild00",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild00",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild02",
      "quantity": 8,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild04",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild04",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild07",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild07",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gef_fild10",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "gon_fild01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "hu_fild06",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "lhz_fild01",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "lhz_fild02",
      "quantity": 15,
      "monsterName": "Green Plant"
    },
    {
      "location": "lhz_fild03",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_10",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild01",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild02",
      "quantity": 4,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild03",
      "quantity": 4,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild04",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild06",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild07",
      "quantity": 8,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild08",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild09",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild00",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild01",
      "quantity": 3,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild03",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild03",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild03",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild03",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild04",
      "quantity": 5,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild05",
      "quantity": 6,
      "monsterName": "Green Plant"
    },
    {
      "location": "prt_fild06",
      "quantity": 15,
      "monsterName": "Green Plant"
    },
    {
      "location": "um_fild01",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "um_fild03",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 20,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild02",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild03",
      "quantity": 15,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild04",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild06",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild07",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild08",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild09",
      "quantity": 10,
      "monsterName": "Green Plant"
    },
    {
      "location": "yuno_fild11",
      "quantity": 10,
      "monsterName": "Green Plant"
    }
  ],
  1081: [
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "gon_dun01",
      "quantity": 11,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "gon_dun02",
      "quantity": 13,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "mosk_dun03",
      "quantity": 11,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "odin_tem01",
      "quantity": 7,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ayo_fild02",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "cmd_fild06",
      "quantity": 2,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "cmd_fild06",
      "quantity": 3,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "cmd_fild08",
      "quantity": 4,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "cmd_fild08",
      "quantity": 4,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild03",
      "quantity": 15,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild04",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild06",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild07",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild08",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ein_fild09",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "hu_fild06",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "lhz_fild01",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "lhz_fild02",
      "quantity": 15,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "lou_fild01",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild01",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild02",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild07",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild12",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 3,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 3,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild13",
      "quantity": 3,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "mosk_fild02",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "prt_fild09",
      "quantity": 3,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ra_fild12",
      "quantity": 15,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "um_fild01",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "um_fild02",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "um_fild04",
      "quantity": 5,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ve_fild01",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ve_fild02",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ve_fild03",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "ve_fild04",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 2,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 6,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 15,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild02",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild03",
      "quantity": 15,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild04",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild06",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild07",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild08",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild09",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    },
    {
      "location": "yuno_fild11",
      "quantity": 10,
      "monsterName": "Yellow Plant"
    }
  ],
  1079: [
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_dun01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "glast_01",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "odin_tem01",
      "quantity": 7,
      "monsterName": "Blue Plant"
    },
    {
      "location": "odin_tem02",
      "quantity": 13,
      "monsterName": "Blue Plant"
    },
    {
      "location": "odin_tem03",
      "quantity": 18,
      "monsterName": "Blue Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild00",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild00",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild02",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild07",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild08",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild09",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild10",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "gef_fild10",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "hu_fild04",
      "quantity": 4,
      "monsterName": "Blue Plant"
    },
    {
      "location": "hu_fild04",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_01",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_02",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_05",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_05",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_05",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_06",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_07",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_08",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "mjolnir_11",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "pay_fild10",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_fild01",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_fild03",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "prt_fild05",
      "quantity": 1,
      "monsterName": "Blue Plant"
    },
    {
      "location": "um_fild03",
      "quantity": 5,
      "monsterName": "Blue Plant"
    },
    {
      "location": "ve_fild01",
      "quantity": 4,
      "monsterName": "Blue Plant"
    },
    {
      "location": "ve_fild04",
      "quantity": 3,
      "monsterName": "Blue Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 2,
      "monsterName": "Blue Plant"
    },
    {
      "location": "yuno_fild03",
      "quantity": 4,
      "monsterName": "Blue Plant"
    }
  ],
  1082: [
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun01",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun01",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun01",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun01",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "gef_dun03",
      "quantity": 18,
      "monsterName": "White Plant"
    },
    {
      "location": "gon_dun01",
      "quantity": 11,
      "monsterName": "White Plant"
    },
    {
      "location": "gon_dun03",
      "quantity": 13,
      "monsterName": "White Plant"
    },
    {
      "location": "mosk_dun03",
      "quantity": 11,
      "monsterName": "White Plant"
    },
    {
      "location": "orcsdun01",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "orcsdun01",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "orcsdun02",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "orcsdun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun02",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 3,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun03",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "pay_d03_i",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "White Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 2,
      "monsterName": "White Plant"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "mosk_fild02",
      "quantity": 5,
      "monsterName": "White Plant"
    },
    {
      "location": "ve_fild07",
      "quantity": 10,
      "monsterName": "White Plant"
    }
  ],
  1015: [
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 2,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Zombie"
    },
    {
      "location": "gef_dun01",
      "quantity": 25,
      "monsterName": "Zombie"
    },
    {
      "location": "pay_dun00",
      "quantity": 40,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n1",
      "quantity": 1,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 2,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Zombie"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Zombie"
    }
  ],
  2405: [
    {
      "location": "treasure_n1",
      "quantity": 4,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n1",
      "quantity": 4,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n1",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 10,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 7,
      "monsterName": "Weak Skeleton"
    }
  ],
  1012: [
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 6,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 6,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Roda Frog"
    },
    {
      "location": "gef_fild01",
      "quantity": 112,
      "monsterName": "Roda Frog"
    },
    {
      "location": "gef_fild09",
      "quantity": 24,
      "monsterName": "Roda Frog"
    },
    {
      "location": "prt_fild00",
      "quantity": 169,
      "monsterName": "Roda Frog"
    },
    {
      "location": "prt_fild04",
      "quantity": 27,
      "monsterName": "Roda Frog"
    }
  ],
  1014: [
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 4,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 2,
      "monsterName": "Spore"
    },
    {
      "location": "prt_sewb2",
      "quantity": 20,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 3,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 4,
      "monsterName": "Spore"
    },
    {
      "location": "treasure_n1",
      "quantity": 2,
      "monsterName": "Spore"
    },
    {
      "location": "pay_fild02",
      "quantity": 30,
      "monsterName": "Spore"
    },
    {
      "location": "pay_fild06",
      "quantity": 30,
      "monsterName": "Spore"
    },
    {
      "location": "pay_fild08",
      "quantity": 148,
      "monsterName": "Spore"
    }
  ],
  2406: [
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 2,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 3,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 2,
      "monsterName": "Weak Soldier Skeleton"
    },
    {
      "location": "treasure_n2",
      "quantity": 5,
      "monsterName": "Weak Soldier Skeleton"
    }
  ],
  2887: [
    {
      "location": "abbey01",
      "quantity": 3,
      "monsterName": "Swift Banshee"
    }
  ],
  2603: [
    {
      "location": "abbey02",
      "quantity": 3,
      "monsterName": "Swift Zombie Slaughter"
    }
  ],
  2736: [
    {
      "location": "abbey03",
      "quantity": 2,
      "monsterName": "Necromancer Ringleader"
    }
  ],
  2832: [
    {
      "location": "abyss_01",
      "quantity": 2,
      "monsterName": "Furious Ferus"
    }
  ],
  2913: [
    {
      "location": "abyss_02",
      "quantity": 2,
      "monsterName": "Acidus Ringleader"
    }
  ],
  2912: [
    {
      "location": "abyss_03",
      "quantity": 2,
      "monsterName": "Solid Acidus"
    }
  ],
  2894: [
    {
      "location": "alde_dun01",
      "quantity": 1,
      "monsterName": "Arclouze Ringleader"
    }
  ],
  2805: [
    {
      "location": "alde_dun02",
      "quantity": 2,
      "monsterName": "Solid High Orc"
    }
  ],
  2717: [
    {
      "location": "alde_dun03",
      "quantity": 2,
      "monsterName": "Furious Penomena"
    }
  ],
  2885: [
    {
      "location": "alde_dun04",
      "quantity": 1,
      "monsterName": "Furious Bathory"
    }
  ],
  2746: [
    {
      "location": "ama_dun01",
      "quantity": 2,
      "monsterName": "Miyabi Doll Ringleader"
    }
  ],
  2704: [
    {
      "location": "ama_dun02",
      "quantity": 1,
      "monsterName": "Swift Poison Toad"
    }
  ],
  2664: [
    {
      "location": "ama_dun03",
      "quantity": 2,
      "monsterName": "Furious Shinobi"
    }
  ],
  2789: [
    {
      "location": "ama_fild01",
      "quantity": 2,
      "monsterName": "Swift Karakasa"
    }
  ],
  2857: [
    {
      "location": "anthell01",
      "quantity": 3,
      "monsterName": "Elusive Deniro"
    },
    {
      "location": "cmd_fild08",
      "quantity": 2,
      "monsterName": "Elusive Deniro"
    }
  ],
  2902: [
    {
      "location": "anthell02",
      "quantity": 2,
      "monsterName": "Solid Andre"
    }
  ],
  2886: [
    {
      "location": "arug_dun01",
      "quantity": 2,
      "monsterName": "Elusive Banshee Master"
    }
  ],
  2781: [
    {
      "location": "ayo_dun01",
      "quantity": 2,
      "monsterName": "Leaf Cat Ringleader"
    }
  ],
  2639: [
    {
      "location": "ayo_dun02",
      "quantity": 2,
      "monsterName": "Furious Tamruan"
    }
  ],
  2654: [
    {
      "location": "ayo_fild01",
      "quantity": 2,
      "monsterName": "Furious Smokie"
    }
  ],
  2609: [
    {
      "location": "ayo_fild02",
      "quantity": 1,
      "monsterName": "Solid Yoyo"
    }
  ],
  2759: [
    {
      "location": "beach_dun",
      "quantity": 2,
      "monsterName": "Swift Medusa"
    }
  ],
  2644: [
    {
      "location": "beach_dun2",
      "quantity": 2,
      "monsterName": "Furious Stalactic Golem"
    }
  ],
  2635: [
    {
      "location": "beach_dun3",
      "quantity": 2,
      "monsterName": "Elusive Thara Frog"
    }
  ],
  2751: [
    {
      "location": "bif_fild01",
      "quantity": 2,
      "monsterName": "Miming Ringleader"
    }
  ],
  2777: [
    {
      "location": "bif_fild02",
      "quantity": 2,
      "monsterName": "Furious Little Fatum"
    }
  ],
  2709: [
    {
      "location": "bra_dun01",
      "quantity": 2,
      "monsterName": "Swift Piranha"
    }
  ],
  2795: [
    {
      "location": "bra_dun02",
      "quantity": 3,
      "monsterName": "Solid Iara"
    }
  ],
  2630: [
    {
      "location": "bra_fild01",
      "quantity": 3,
      "monsterName": "Furious Toucan"
    }
  ],
  2682: [
    {
      "location": "c_tower1",
      "quantity": 2,
      "monsterName": "Solid Rideword"
    }
  ],
  2871: [
    {
      "location": "c_tower2",
      "quantity": 1,
      "monsterName": "Furious Clock"
    }
  ],
  2910: [
    {
      "location": "c_tower3",
      "quantity": 1,
      "monsterName": "Elusive Alarm"
    }
  ],
  2870: [
    {
      "location": "c_tower4",
      "quantity": 2,
      "monsterName": "Clock Ringleader"
    }
  ],
  2808: [
    {
      "location": "cmd_fild01",
      "quantity": 2,
      "monsterName": "Elusive Grove"
    }
  ],
  2829: [
    {
      "location": "cmd_fild02",
      "quantity": 3,
      "monsterName": "Swift Seal"
    }
  ],
  2907: [
    {
      "location": "cmd_fild03",
      "quantity": 3,
      "monsterName": "Solid Alligator"
    }
  ],
  2668: [
    {
      "location": "cmd_fild04",
      "quantity": 2,
      "monsterName": "Sea Otter Ringleader"
    }
  ],
  2812: [
    {
      "location": "cmd_fild06",
      "quantity": 2,
      "monsterName": "Furious Golem"
    }
  ],
  2694: [
    {
      "location": "cmd_fild07",
      "quantity": 2,
      "monsterName": "Elusive Raggler"
    }
  ],
  2754: [
    {
      "location": "cmd_fild09",
      "quantity": 2,
      "monsterName": "Swift Metaller"
    }
  ],
  2867: [
    {
      "location": "dew_dun01",
      "quantity": 2,
      "monsterName": "Elusive Comodo"
    }
  ],
  2888: [
    {
      "location": "dew_dun02",
      "quantity": 2,
      "monsterName": "Solid Banaspaty"
    }
  ],
  2906: [
    {
      "location": "dew_fild01",
      "quantity": 2,
      "monsterName": "Swift Rafflesia Arnoldi"
    }
  ],
  2799: [
    {
      "location": "dic_dun01",
      "quantity": 2,
      "monsterName": "Swift Uni-horn Scaraba"
    }
  ],
  2896: [
    {
      "location": "dic_dun02",
      "quantity": 2,
      "monsterName": "Elusive Antler Scaraba"
    }
  ],
  2693: [
    {
      "location": "dic_dun03",
      "quantity": 2,
      "monsterName": "Furious Rake Scaraba"
    }
  ],
  2873: [
    {
      "location": "dic_fild01",
      "quantity": 2,
      "monsterName": "Swift Centipede"
    }
  ],
  2850: [
    {
      "location": "dic_fild02",
      "quantity": 2,
      "monsterName": "Dolomedes Ringleader"
    }
  ],
  2758: [
    {
      "location": "ecl_fild01",
      "quantity": 1,
      "monsterName": "Elusive Menblatt"
    }
  ],
  2874: [
    {
      "location": "ecl_tdun01",
      "quantity": 1,
      "monsterName": "Solid Cenere"
    }
  ],
  2898: [
    {
      "location": "ecl_tdun02",
      "quantity": 1,
      "monsterName": "Solid Antique Book"
    }
  ],
  2897: [
    {
      "location": "ecl_tdun03",
      "quantity": 1,
      "monsterName": "Swift Antique Book"
    }
  ],
  2708: [
    {
      "location": "ein_dun01",
      "quantity": 2,
      "monsterName": "Elusive Pitman"
    }
  ],
  2750: [
    {
      "location": "ein_dun02",
      "quantity": 2,
      "monsterName": "Solid Mineral"
    }
  ],
  2629: [
    {
      "location": "ein_fild02",
      "quantity": 2,
      "monsterName": "Ungoliant Ringleader"
    }
  ],
  2636: [
    {
      "location": "ein_fild03",
      "quantity": 2,
      "monsterName": "Swift Teddy Bear"
    }
  ],
  2624: [
    {
      "location": "ein_fild04",
      "quantity": 2,
      "monsterName": "Venomous Ringleader"
    }
  ],
  2727: [
    {
      "location": "ein_fild05",
      "quantity": 2,
      "monsterName": "Furious Noxious"
    }
  ],
  2745: [
    {
      "location": "ein_fild06",
      "quantity": 2,
      "monsterName": "Solid Holden"
    }
  ],
  2756: [
    {
      "location": "ein_fild07",
      "quantity": 2,
      "monsterName": "Metaling Ringleader"
    }
  ],
  2755: [
    {
      "location": "ein_fild08",
      "quantity": 2,
      "monsterName": "Solid Metaling"
    }
  ],
  2700: [
    {
      "location": "ein_fild09",
      "quantity": 2,
      "monsterName": "Solid Porcellio"
    }
  ],
  2797: [
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Furious Hunter Fly"
    }
  ],
  2823: [
    {
      "location": "gef_dun01",
      "quantity": 2,
      "monsterName": "Elusive Ghoul"
    }
  ],
  2854: [
    {
      "location": "gef_dun02",
      "quantity": 2,
      "monsterName": "Solid Deviruchi"
    }
  ],
  2614: [
    {
      "location": "gef_dun03",
      "quantity": 1,
      "monsterName": "Solid Wind Ghost"
    },
    {
      "location": "gl_step",
      "quantity": 2,
      "monsterName": "Solid Wind Ghost"
    }
  ],
  2872: [
    {
      "location": "gef_fild00",
      "quantity": 2,
      "monsterName": "Elusive Chonchon"
    }
  ],
  2679: [
    {
      "location": "gef_fild01",
      "quantity": 2,
      "monsterName": "Furious Roda Frog"
    }
  ],
  2869: [
    {
      "location": "gef_fild02",
      "quantity": 3,
      "monsterName": "Solid Coco"
    }
  ],
  2725: [
    {
      "location": "gef_fild03",
      "quantity": 3,
      "monsterName": "Solid Orc Lady"
    }
  ],
  2765: [
    {
      "location": "gef_fild04",
      "quantity": 2,
      "monsterName": "Solid Mandragora"
    }
  ],
  2863: [
    {
      "location": "gef_fild05",
      "quantity": 2,
      "monsterName": "Swift Creamy"
    }
  ],
  2715: [
    {
      "location": "gef_fild06",
      "quantity": 2,
      "monsterName": "Solid Petite"
    }
  ],
  2699: [
    {
      "location": "gef_fild07",
      "quantity": 2,
      "monsterName": "Swift Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 1,
      "monsterName": "Swift Poring"
    }
  ],
  2714: [
    {
      "location": "gef_fild08",
      "quantity": 2,
      "monsterName": "Swift Petite"
    }
  ],
  2868: [
    {
      "location": "gef_fild09",
      "quantity": 2,
      "monsterName": "Swift Coco"
    }
  ],
  2722: [
    {
      "location": "gef_fild10",
      "quantity": 2,
      "monsterName": "Furious Orc Warrior"
    }
  ],
  2814: [
    {
      "location": "gef_fild11",
      "quantity": 3,
      "monsterName": "Swift Goblin"
    }
  ],
  2834: [
    {
      "location": "gefenia01",
      "quantity": 2,
      "monsterName": "Swift False Angel"
    }
  ],
  2623: [
    {
      "location": "gefenia02",
      "quantity": 2,
      "monsterName": "Solid Violy"
    }
  ],
  2622: [
    {
      "location": "gefenia03",
      "quantity": 2,
      "monsterName": "Swift Violy"
    }
  ],
  2621: [
    {
      "location": "gefenia04",
      "quantity": 2,
      "monsterName": "Elusive Violy"
    }
  ],
  2877: [
    {
      "location": "gl_cas01",
      "quantity": 2,
      "monsterName": "Elusive Carat"
    }
  ],
  2734: [
    {
      "location": "gl_cas02_",
      "quantity": 2,
      "monsterName": "Furious Wanderer (Nightmare)"
    }
  ],
  2620: [
    {
      "location": "gl_cas02",
      "quantity": 2,
      "monsterName": "Furious Wanderer"
    }
  ],
  2838: [
    {
      "location": "gl_church",
      "quantity": 2,
      "monsterName": "Elusive Evil Druid"
    }
  ],
  2733: [
    {
      "location": "gl_chyard_",
      "quantity": 2,
      "monsterName": "Elusive Wraith Dead (Nightmare)"
    }
  ],
  2861: [
    {
      "location": "gl_chyard",
      "quantity": 2,
      "monsterName": "Furious Dark Priest"
    }
  ],
  2893: [
    {
      "location": "gl_dun01",
      "quantity": 1,
      "monsterName": "Solid Arclouze"
    }
  ],
  2767: [
    {
      "location": "gl_dun02",
      "quantity": 1,
      "monsterName": "Furious Majoruros"
    }
  ],
  2761: [
    {
      "location": "gl_in01",
      "quantity": 1,
      "monsterName": "Marionette Ringleader"
    }
  ],
  2691: [
    {
      "location": "gl_knt01",
      "quantity": 2,
      "monsterName": "Solid Raydric"
    }
  ],
  2690: [
    {
      "location": "gl_knt02",
      "quantity": 2,
      "monsterName": "Swift Raydric"
    }
  ],
  2604: [
    {
      "location": "gl_prison",
      "quantity": 1,
      "monsterName": "Solid Zombie Prisoner"
    }
  ],
  2792: [
    {
      "location": "gl_prison1",
      "quantity": 2,
      "monsterName": "Furious Injustice"
    }
  ],
  2618: [
    {
      "location": "gl_sew01",
      "quantity": 1,
      "monsterName": "Solid Whisper"
    }
  ],
  2827: [
    {
      "location": "gl_sew02",
      "quantity": 1,
      "monsterName": "Furious Gargoyle"
    }
  ],
  2640: [
    {
      "location": "gl_sew03",
      "quantity": 2,
      "monsterName": "Elusive Sting"
    }
  ],
  2899: [
    {
      "location": "gl_sew04",
      "quantity": 2,
      "monsterName": "Furious Anolian"
    }
  ],
  2826: [
    {
      "location": "glast_01",
      "quantity": 1,
      "monsterName": "Gargoyle Ringleader"
    }
  ],
  2659: [
    {
      "location": "gld_dun01_2",
      "quantity": 2,
      "monsterName": "Furious Skeleton General"
    }
  ],
  2780: [
    {
      "location": "gld_dun01",
      "quantity": 2,
      "monsterName": "Solid Leib Olmai"
    }
  ],
  2901: [
    {
      "location": "gld_dun02_2",
      "quantity": 2,
      "monsterName": "Swift Angra Mantis"
    }
  ],
  2821: [
    {
      "location": "gld_dun02",
      "quantity": 2,
      "monsterName": "Giant Hornet Ringleader"
    }
  ],
  2818: [
    {
      "location": "gld_dun03_2",
      "quantity": 2,
      "monsterName": "Elusive Dark Hammer Kobold"
    }
  ],
  2876: [
    {
      "location": "gld_dun03",
      "quantity": 2,
      "monsterName": "Furious Caterpillar"
    }
  ],
  2820: [
    {
      "location": "gld_dun04_2",
      "quantity": 2,
      "monsterName": "Solid Dark Shadow"
    }
  ],
  2605: [
    {
      "location": "gld_dun04",
      "quantity": 2,
      "monsterName": "Zombie Master Ringleader"
    }
  ],
  2900: [
    {
      "location": "gld2_ald",
      "quantity": 2,
      "monsterName": "Elusive Angra Mantis"
    }
  ],
  2819: [
    {
      "location": "gld2_gef",
      "quantity": 2,
      "monsterName": "Swift Dark Shadow"
    }
  ],
  2658: [
    {
      "location": "gld2_pay",
      "quantity": 2,
      "monsterName": "Skeleton General Ringleader"
    }
  ],
  2817: [
    {
      "location": "gld2_prt",
      "quantity": 2,
      "monsterName": "Furious Dark Hammer Kobold"
    }
  ],
  2883: [
    {
      "location": "gon_dun01",
      "quantity": 2,
      "monsterName": "Swift Bloody Butterfly"
    }
  ],
  2775: [
    {
      "location": "gon_dun02",
      "quantity": 1,
      "monsterName": "Solid Enchanted Peach Tree"
    }
  ],
  2617: [
    {
      "location": "gon_dun03",
      "quantity": 2,
      "monsterName": "Elusive Evil Nymph"
    }
  ],
  2683: [
    {
      "location": "gon_fild01",
      "quantity": 2,
      "monsterName": "Dumpling Child Ringleader"
    }
  ],
  2731: [
    {
      "location": "hu_fild01",
      "quantity": 2,
      "monsterName": "Novus Ringleader"
    }
  ],
  2730: [
    {
      "location": "hu_fild02",
      "quantity": 2,
      "monsterName": "Solid Novus"
    }
  ],
  2729: [
    {
      "location": "hu_fild04",
      "quantity": 2,
      "monsterName": "Swift Novus"
    }
  ],
  2728: [
    {
      "location": "hu_fild05",
      "quantity": 2,
      "monsterName": "Elusive Novus"
    }
  ],
  2666: [
    {
      "location": "hu_fild06",
      "quantity": 1,
      "monsterName": "Swift Shellfish"
    }
  ],
  2661: [
    {
      "location": "ice_dun01",
      "quantity": 1,
      "monsterName": "Swift Siroma"
    }
  ],
  2652: [
    {
      "location": "ice_dun02",
      "quantity": 2,
      "monsterName": "Solid Snowier"
    }
  ],
  2794: [
    {
      "location": "ice_dun03",
      "quantity": 2,
      "monsterName": "Swift Ice Titan"
    }
  ],
  2847: [
    {
      "location": "in_sphinx1",
      "quantity": 1,
      "monsterName": "Elusive Drainliar"
    }
  ],
  2687: [
    {
      "location": "in_sphinx2",
      "quantity": 2,
      "monsterName": "Solid Requiem"
    }
  ],
  2763: [
    {
      "location": "in_sphinx3",
      "quantity": 1,
      "monsterName": "Elusive Marduk"
    }
  ],
  2749: [
    {
      "location": "in_sphinx4",
      "quantity": 1,
      "monsterName": "Swift Minorous"
    }
  ],
  2719: [
    {
      "location": "in_sphinx5",
      "quantity": 2,
      "monsterName": "Swift Pasana"
    }
  ],
  2707: [
    {
      "location": "iz_dun00",
      "quantity": 2,
      "monsterName": "Furious Plankton"
    }
  ],
  2628: [
    {
      "location": "iz_dun01",
      "quantity": 2,
      "monsterName": "Solid Vadon"
    }
  ],
  2864: [
    {
      "location": "iz_dun02",
      "quantity": 2,
      "monsterName": "Solid Cornutus"
    }
  ],
  2713: [
    {
      "location": "iz_dun03",
      "quantity": 2,
      "monsterName": "Elusive Phen"
    }
  ],
  2757: [
    {
      "location": "iz_dun04",
      "quantity": 2,
      "monsterName": "Furious Merman"
    }
  ],
  2669: [
    {
      "location": "iz_dun05",
      "quantity": 2,
      "monsterName": "Furious Lamp Rey"
    }
  ],
  2853: [
    {
      "location": "jupe_core",
      "quantity": 3,
      "monsterName": "Swift Dimik"
    }
  ],
  2625: [
    {
      "location": "juperos_01",
      "quantity": 3,
      "monsterName": "Furious Venatu"
    }
  ],
  2895: [
    {
      "location": "juperos_02",
      "quantity": 3,
      "monsterName": "Furious Apocalypse"
    }
  ],
  2908: [
    {
      "location": "kh_dun01",
      "quantity": 1,
      "monsterName": "Aliza Ringleader"
    }
  ],
  2909: [
    {
      "location": "kh_dun02",
      "quantity": 1,
      "monsterName": "Furious Alicel"
    }
  ],
  2866: [
    {
      "location": "kh_kiehl01",
      "quantity": 2,
      "monsterName": "Furious Constant"
    }
  ],
  2688: [
    {
      "location": "lhz_dun01",
      "quantity": 3,
      "monsterName": "Remover Ringleader"
    }
  ],
  2692: [
    {
      "location": "lhz_dun02",
      "quantity": 3,
      "monsterName": "Laurell Weinder Ringleader"
    }
  ],
  2667: [
    {
      "location": "lhz_dun03",
      "quantity": 3,
      "monsterName": "Solid Cecil Damon"
    }
  ],
  2875: [
    {
      "location": "lhz_dun04",
      "quantity": 3,
      "monsterName": "Celia Ringleader"
    }
  ],
  2695: [
    {
      "location": "lhz_fild01",
      "quantity": 3,
      "monsterName": "Swift Rafflesia"
    }
  ],
  2696: [
    {
      "location": "lhz_fild01",
      "quantity": 2,
      "monsterName": "Poring Ringleader"
    },
    {
      "location": "prt_fild08",
      "quantity": 1,
      "monsterName": "Poring Ringleader"
    }
  ],
  2697: [
    {
      "location": "lhz_fild01",
      "quantity": 2,
      "monsterName": "Furious Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 1,
      "monsterName": "Furious Poring"
    }
  ],
  2698: [
    {
      "location": "lhz_fild01",
      "quantity": 2,
      "monsterName": "Elusive Poring"
    },
    {
      "location": "prt_fild08",
      "quantity": 1,
      "monsterName": "Elusive Poring"
    }
  ],
  2641: [
    {
      "location": "lhz_fild02",
      "quantity": 2,
      "monsterName": "Swift Stem Worm"
    }
  ],
  2881: [
    {
      "location": "lhz_fild03",
      "quantity": 3,
      "monsterName": "Furious Breeze"
    }
  ],
  2778: [
    {
      "location": "lou_dun01",
      "quantity": 2,
      "monsterName": "Elusive Jing Guai"
    }
  ],
  2796: [
    {
      "location": "lou_dun02",
      "quantity": 1,
      "monsterName": "Yao Jun Ringleader"
    }
  ],
  2862: [
    {
      "location": "lou_dun03",
      "quantity": 1,
      "monsterName": "Elusive Zhu Po Long"
    }
  ],
  2793: [
    {
      "location": "lou_fild01",
      "quantity": 1,
      "monsterName": "Elusive Mi Gao"
    }
  ],
  2766: [
    {
      "location": "ma_dun01",
      "quantity": 2,
      "monsterName": "Manananggal Ringleader"
    }
  ],
  2631: [
    {
      "location": "ma_fild01",
      "quantity": 2,
      "monsterName": "Elusive Tiyanak"
    }
  ],
  2879: [
    {
      "location": "ma_fild02",
      "quantity": 2,
      "monsterName": "Solid Bungisngis"
    }
  ],
  2837: [
    {
      "location": "mag_dun01",
      "quantity": 1,
      "monsterName": "Furious Explosion"
    }
  ],
  2732: [
    {
      "location": "mag_dun02",
      "quantity": 2,
      "monsterName": "Furious Nightmare Terror"
    }
  ],
  2689: [
    {
      "location": "mal_dun01",
      "quantity": 2,
      "monsterName": "Elusive Red Eruma"
    }
  ],
  2735: [
    {
      "location": "man_fild01",
      "quantity": 2,
      "monsterName": "Solid Nephentes"
    }
  ],
  2882: [
    {
      "location": "man_fild02",
      "quantity": 2,
      "monsterName": "Elusive Bradium Golem"
    }
  ],
  2637: [
    {
      "location": "man_fild03",
      "quantity": 1,
      "monsterName": "Solid Tatacho"
    }
  ],
  2638: [
    {
      "location": "mjo_dun01",
      "quantity": 2,
      "monsterName": "Tarou Ringleader"
    }
  ],
  2760: [
    {
      "location": "mjo_dun02",
      "quantity": 2,
      "monsterName": "Solid Martin"
    }
  ],
  2660: [
    {
      "location": "mjo_dun03",
      "quantity": 2,
      "monsterName": "Elusive Skeleton Worker"
    }
  ],
  2878: [
    {
      "location": "mjolnir_01",
      "quantity": 2,
      "monsterName": "Swift Caramel"
    }
  ],
  2840: [
    {
      "location": "mjolnir_02",
      "quantity": 3,
      "monsterName": "Solid Elder Willow"
    }
  ],
  2663: [
    {
      "location": "mjolnir_03",
      "quantity": 2,
      "monsterName": "Side Winder Ringleader"
    }
  ],
  2846: [
    {
      "location": "mjolnir_04",
      "quantity": 3,
      "monsterName": "Furious Driller"
    }
  ],
  2892: [
    {
      "location": "mjolnir_05",
      "quantity": 2,
      "monsterName": "Swift Argiope"
    }
  ],
  2705: [
    {
      "location": "mjolnir_06",
      "quantity": 3,
      "monsterName": "Solid Poison Spore"
    }
  ],
  2673: [
    {
      "location": "mjolnir_07",
      "quantity": 3,
      "monsterName": "Savage Ringleader"
    }
  ],
  2787: [
    {
      "location": "mjolnir_08",
      "quantity": 2,
      "monsterName": "Furious Beetle King"
    }
  ],
  2671: [
    {
      "location": "mjolnir_09",
      "quantity": 2,
      "monsterName": "Swift Savage Babe"
    }
  ],
  2890: [
    {
      "location": "mjolnir_10",
      "quantity": 2,
      "monsterName": "Furious Argos"
    }
  ],
  2891: [
    {
      "location": "mjolnir_11",
      "quantity": 2,
      "monsterName": "Elusive Argiope"
    }
  ],
  2842: [
    {
      "location": "mjolnir_12",
      "quantity": 2,
      "monsterName": "Furious Dustiness"
    }
  ],
  2741: [
    {
      "location": "moc_fild01",
      "quantity": 3,
      "monsterName": "Muka Ringleader"
    }
  ],
  2718: [
    {
      "location": "moc_fild02",
      "quantity": 2,
      "monsterName": "Elusive Peco Peco"
    }
  ],
  2613: [
    {
      "location": "moc_fild03",
      "quantity": 2,
      "monsterName": "Swift Wolf"
    }
  ],
  2845: [
    {
      "location": "moc_fild07",
      "quantity": 3,
      "monsterName": "Drops Ringleader"
    }
  ],
  2856: [
    {
      "location": "moc_fild11",
      "quantity": 3,
      "monsterName": "Furious Baby Desert Wolf"
    }
  ],
  2712: [
    {
      "location": "moc_fild12",
      "quantity": 2,
      "monsterName": "Furious Picky"
    }
  ],
  2642: [
    {
      "location": "moc_fild13",
      "quantity": 3,
      "monsterName": "Solid Steel Chonchon"
    }
  ],
  2674: [
    {
      "location": "moc_fild16",
      "quantity": 2,
      "monsterName": "Furious Sandman"
    }
  ],
  2802: [
    {
      "location": "moc_fild17",
      "quantity": 2,
      "monsterName": "Furious Hode"
    }
  ],
  2670: [
    {
      "location": "moc_fild18",
      "quantity": 3,
      "monsterName": "Elusive Scorpion"
    }
  ],
  2744: [
    {
      "location": "moc_fild20",
      "quantity": 1,
      "monsterName": "Swift Incarnation of Morocc"
    }
  ],
  2743: [
    {
      "location": "moc_fild21",
      "quantity": 2,
      "monsterName": "Elusive Incarnation of Morocc"
    }
  ],
  2742: [
    {
      "location": "moc_fild22",
      "quantity": 3,
      "monsterName": "Furious Incarnation of Morocc"
    }
  ],
  2740: [
    {
      "location": "moc_pryd02",
      "quantity": 2,
      "monsterName": "Solid Mummy"
    }
  ],
  2739: [
    {
      "location": "moc_pryd03",
      "quantity": 2,
      "monsterName": "Swift Mummy"
    }
  ],
  2790: [
    {
      "location": "moc_pryd04",
      "quantity": 2,
      "monsterName": "Solid Isis"
    }
  ],
  2748: [
    {
      "location": "moc_pryd05",
      "quantity": 2,
      "monsterName": "Elusive Minorous"
    }
  ],
  2753: [
    {
      "location": "moc_pryd06",
      "quantity": 2,
      "monsterName": "Elusive Mimic"
    }
  ],
  2747: [
    {
      "location": "moc_prydn1",
      "quantity": 2,
      "monsterName": "Furious Minorous"
    }
  ],
  2752: [
    {
      "location": "moc_prydn2",
      "quantity": 2,
      "monsterName": "Furious Mimic"
    }
  ],
  2612: [
    {
      "location": "mosk_dun01",
      "quantity": 2,
      "monsterName": "Elusive Wood Goblin"
    }
  ],
  2779: [
    {
      "location": "mosk_dun02",
      "quantity": 1,
      "monsterName": "Swift Les"
    }
  ],
  2626: [
    {
      "location": "mosk_dun03",
      "quantity": 2,
      "monsterName": "Elusive Vavayaga"
    }
  ],
  2662: [
    {
      "location": "mosk_fild02",
      "quantity": 1,
      "monsterName": "Solid Side Winder"
    }
  ],
  2822: [
    {
      "location": "nameless_n",
      "quantity": 1,
      "monsterName": "Furious Ghoul"
    }
  ],
  2776: [
    {
      "location": "new_1-3",
      "quantity": 2,
      "monsterName": "Baby Poring Ringleader"
    }
  ],
  2852: [
    {
      "location": "nif_fild01",
      "quantity": 2,
      "monsterName": "Elusive Disguise"
    }
  ],
  2774: [
    {
      "location": "nif_fild02",
      "quantity": 1,
      "monsterName": "Swift Loli Ruri"
    }
  ],
  2772: [
    {
      "location": "niflheim",
      "quantity": 1,
      "monsterName": "Furious Lude"
    }
  ],
  2849: [
    {
      "location": "nyd_dun01",
      "quantity": 2,
      "monsterName": "Solid Draco"
    }
  ],
  2880: [
    {
      "location": "odin_tem01",
      "quantity": 1,
      "monsterName": "Breeze Ringleader"
    }
  ],
  2657: [
    {
      "location": "odin_tem02",
      "quantity": 1,
      "monsterName": "Solid Skogul"
    }
  ],
  2706: [
    {
      "location": "odin_tem03",
      "quantity": 2,
      "monsterName": "Plasma Ringleader"
    }
  ],
  2723: [
    {
      "location": "orcsdun01",
      "quantity": 2,
      "monsterName": "Elusive Orc Zombie"
    }
  ],
  2724: [
    {
      "location": "orcsdun02",
      "quantity": 2,
      "monsterName": "Swift Orc Skeleton"
    }
  ],
  2606: [
    {
      "location": "pay_dun00",
      "quantity": 2,
      "monsterName": "Furious Zombie"
    }
  ],
  2649: [
    {
      "location": "pay_dun01",
      "quantity": 2,
      "monsterName": "Furious Soldier Skeleton"
    }
  ],
  2648: [
    {
      "location": "pay_dun02",
      "quantity": 3,
      "monsterName": "Soldier Skeleton Ringleader"
    }
  ],
  2651: [
    {
      "location": "pay_dun03",
      "quantity": 2,
      "monsterName": "Swift Sohee"
    }
  ],
  2851: [
    {
      "location": "pay_dun04",
      "quantity": 2,
      "monsterName": "Furious Dokebi"
    }
  ],
  2615: [
    {
      "location": "pay_fild01",
      "quantity": 2,
      "monsterName": "Willow Ringleader"
    }
  ],
  2653: [
    {
      "location": "pay_fild02",
      "quantity": 3,
      "monsterName": "Boa Ringleader"
    }
  ],
  2836: [
    {
      "location": "pay_fild03",
      "quantity": 3,
      "monsterName": "Fabre Ringleader"
    }
  ],
  2703: [
    {
      "location": "pay_fild04",
      "quantity": 2,
      "monsterName": "Elusive Poporing"
    }
  ],
  2610: [
    {
      "location": "pay_fild06",
      "quantity": 3,
      "monsterName": "Wormtail Ringleader"
    }
  ],
  2884: [
    {
      "location": "pay_fild07",
      "quantity": 2,
      "monsterName": "Bigfoot Ringleader"
    }
  ],
  2800: [
    {
      "location": "pay_fild09",
      "quantity": 2,
      "monsterName": "Solid Horn"
    }
  ],
  2809: [
    {
      "location": "pay_fild10",
      "quantity": 2,
      "monsterName": "Swift Greatest General"
    }
  ],
  2678: [
    {
      "location": "prt_fild00",
      "quantity": 2,
      "monsterName": "Roda Frog Ringleader"
    }
  ],
  2771: [
    {
      "location": "prt_fild01",
      "quantity": 2,
      "monsterName": "Lunatic Ringleader"
    }
  ],
  2645: [
    {
      "location": "prt_fild02",
      "quantity": 3,
      "monsterName": "Elusive Stainer"
    }
  ],
  2608: [
    {
      "location": "prt_fild03",
      "quantity": 2,
      "monsterName": "Swift Yoyo"
    }
  ],
  2905: [
    {
      "location": "prt_fild04",
      "quantity": 2,
      "monsterName": "Elusive Ambernite"
    }
  ],
  2798: [
    {
      "location": "prt_fild05",
      "quantity": 2,
      "monsterName": "Elusive Hornet"
    }
  ],
  2835: [
    {
      "location": "prt_fild06",
      "quantity": 2,
      "monsterName": "Solid Fabre"
    }
  ],
  2680: [
    {
      "location": "prt_fild07",
      "quantity": 3,
      "monsterName": "Elusive Rocker"
    }
  ],
  2770: [
    {
      "location": "prt_fild08",
      "quantity": 1,
      "monsterName": "Solid Lunatic"
    }
  ],
  2768: [
    {
      "location": "prt_fild09",
      "quantity": 2,
      "monsterName": "Elusive Magnolia"
    }
  ],
  2839: [
    {
      "location": "prt_fild10",
      "quantity": 3,
      "monsterName": "Swift Elder Willow"
    }
  ],
  2813: [
    {
      "location": "prt_fild11",
      "quantity": 3,
      "monsterName": "Elusive Goblin"
    }
  ],
  2672: [
    {
      "location": "prt_maze01",
      "quantity": 2,
      "monsterName": "Solid Savage"
    }
  ],
  2702: [
    {
      "location": "prt_maze02",
      "quantity": 2,
      "monsterName": "Furious Poporing"
    }
  ],
  2701: [
    {
      "location": "prt_maze03",
      "quantity": 2,
      "monsterName": "Poporing Ringleader"
    }
  ],
  2764: [
    {
      "location": "prt_maze03",
      "quantity": 2,
      "monsterName": "Swift Mantis"
    }
  ],
  2833: [
    {
      "location": "prt_sewb1",
      "quantity": 1,
      "monsterName": "Elusive Familiar"
    }
  ],
  2634: [
    {
      "location": "prt_sewb2",
      "quantity": 2,
      "monsterName": "Furious Thief Bug"
    }
  ],
  2633: [
    {
      "location": "prt_sewb3",
      "quantity": 3,
      "monsterName": "Thief Bug Ringleader"
    }
  ],
  2632: [
    {
      "location": "prt_sewb4",
      "quantity": 2,
      "monsterName": "Solid Thief Bug"
    }
  ],
  2855: [
    {
      "location": "ra_fild01",
      "quantity": 2,
      "monsterName": "Baby Desert Wolf Ringleader"
    }
  ],
  2804: [
    {
      "location": "ra_fild03",
      "quantity": 3,
      "monsterName": "Swift Hill Wind"
    }
  ],
  2803: [
    {
      "location": "ra_fild04",
      "quantity": 3,
      "monsterName": "Elusive Hill Wind"
    }
  ],
  2785: [
    {
      "location": "ra_fild05",
      "quantity": 3,
      "monsterName": "Solid Kobold"
    }
  ],
  2784: [
    {
      "location": "ra_fild06",
      "quantity": 3,
      "monsterName": "Swift Kobold Archer"
    }
  ],
  2904: [
    {
      "location": "ra_fild08",
      "quantity": 2,
      "monsterName": "Furious Anacondaq"
    }
  ],
  2677: [
    {
      "location": "ra_fild12",
      "quantity": 2,
      "monsterName": "Solid Roween"
    }
  ],
  2627: [
    {
      "location": "ra_san01",
      "quantity": 2,
      "monsterName": "Swift Vanberk"
    }
  ],
  2791: [
    {
      "location": "ra_san02",
      "quantity": 2,
      "monsterName": "Isilla Ringleader"
    }
  ],
  2801: [
    {
      "location": "ra_san03",
      "quantity": 2,
      "monsterName": "Hodremlin Ringleader"
    }
  ],
  2841: [
    {
      "location": "ra_san04",
      "quantity": 1,
      "monsterName": "Echio Ringleader"
    }
  ],
  2911: [
    {
      "location": "ra_san05",
      "quantity": 2,
      "monsterName": "Swift Agav"
    }
  ],
  2607: [
    {
      "location": "schg_dun01",
      "quantity": 2,
      "monsterName": "Elusive Zakudam"
    }
  ],
  2710: [
    {
      "location": "spl_fild01",
      "quantity": 2,
      "monsterName": "Solid Dark Pinguicula"
    }
  ],
  2711: [
    {
      "location": "spl_fild02",
      "quantity": 2,
      "monsterName": "Pinguicula Ringleader"
    }
  ],
  2773: [
    {
      "location": "spl_fild03",
      "quantity": 1,
      "monsterName": "Elusive Luciola Vespa"
    }
  ],
  2783: [
    {
      "location": "teg_dun01",
      "quantity": 2,
      "monsterName": "Elusive Eremes"
    }
  ],
  2782: [
    {
      "location": "teg_dun02",
      "quantity": 2,
      "monsterName": "Furious Wickebine Tres"
    }
  ],
  2681: [
    {
      "location": "tha_t01",
      "quantity": 2,
      "monsterName": "Swift Rideword"
    }
  ],
  2903: [
    {
      "location": "tha_t02",
      "quantity": 2,
      "monsterName": "Ancient Mimic Ringleader"
    }
  ],
  2860: [
    {
      "location": "tha_t03",
      "quantity": 2,
      "monsterName": "Death Word Ringleader"
    }
  ],
  2859: [
    {
      "location": "tha_t04",
      "quantity": 2,
      "monsterName": "Solid Death Word"
    }
  ],
  2721: [
    {
      "location": "tha_t05",
      "quantity": 2,
      "monsterName": "Owl Duke Ringleader"
    }
  ],
  2858: [
    {
      "location": "tha_t06",
      "quantity": 2,
      "monsterName": "Swift Death Word"
    }
  ],
  2686: [
    {
      "location": "tha_t07",
      "quantity": 2,
      "monsterName": "Swift Baroness of Retribution"
    }
  ],
  2685: [
    {
      "location": "tha_t08",
      "quantity": 2,
      "monsterName": "Elusive Baroness of Retribution"
    }
  ],
  2650: [
    {
      "location": "tha_t09",
      "quantity": 2,
      "monsterName": "Elusive Lady Solace"
    }
  ],
  2684: [
    {
      "location": "tha_t10",
      "quantity": 2,
      "monsterName": "Furious Baroness of Retribution"
    }
  ],
  2665: [
    {
      "location": "tha_t11",
      "quantity": 2,
      "monsterName": "Elusive Mistress of Shelter"
    }
  ],
  2726: [
    {
      "location": "tha_t12",
      "quantity": 2,
      "monsterName": "Dame of Sentinel Ringleader"
    }
  ],
  2788: [
    {
      "location": "thor_v01",
      "quantity": 2,
      "monsterName": "Elusive Kasa"
    }
  ],
  2786: [
    {
      "location": "thor_v02",
      "quantity": 1,
      "monsterName": "Knocker Ringleader"
    }
  ],
  2675: [
    {
      "location": "thor_v03",
      "quantity": 2,
      "monsterName": "Elusive Salamander"
    }
  ],
  2646: [
    {
      "location": "treasure_n1",
      "quantity": 2,
      "monsterName": "Swift Spore"
    }
  ],
  2619: [
    {
      "location": "treasure_n2",
      "quantity": 2,
      "monsterName": "Weak Skeleton Ringleader"
    }
  ],
  2676: [
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Swift Sailor Skeleton"
    }
  ],
  2716: [
    {
      "location": "treasure02",
      "quantity": 2,
      "monsterName": "Penomena Ringleader"
    }
  ],
  2848: [
    {
      "location": "tur_dun01",
      "quantity": 1,
      "monsterName": "Swift Dragon Tail"
    }
  ],
  2647: [
    {
      "location": "tur_dun02",
      "quantity": 2,
      "monsterName": "Solid Solider"
    }
  ],
  2831: [
    {
      "location": "tur_dun03",
      "quantity": 1,
      "monsterName": "Freezer Ringleader"
    }
  ],
  2889: [
    {
      "location": "tur_dun04",
      "quantity": 1,
      "monsterName": "Assaulter Ringleader"
    }
  ],
  2830: [
    {
      "location": "tur_dun05",
      "quantity": 1,
      "monsterName": "Solid Freezer"
    }
  ],
  2843: [
    {
      "location": "um_fild01",
      "quantity": 2,
      "monsterName": "Swift Dryad"
    }
  ],
  2611: [
    {
      "location": "um_fild02",
      "quantity": 1,
      "monsterName": "Furious Wootan Fighter"
    }
  ],
  2720: [
    {
      "location": "um_fild03",
      "quantity": 1,
      "monsterName": "Solid Parasite"
    }
  ],
  2616: [
    {
      "location": "um_fild04",
      "quantity": 1,
      "monsterName": "Furious Wild Rose"
    }
  ],
  2828: [
    {
      "location": "ve_fild01",
      "quantity": 1,
      "monsterName": "Elusive Galion"
    }
  ],
  2844: [
    {
      "location": "ve_fild02",
      "quantity": 2,
      "monsterName": "Solid Drosera"
    }
  ],
  2769: [
    {
      "location": "ve_fild03",
      "quantity": 2,
      "monsterName": "Swift Magmaring"
    }
  ],
  2738: [
    {
      "location": "ve_fild04",
      "quantity": 2,
      "monsterName": "Elusive Muscipular"
    }
  ],
  2643: [
    {
      "location": "ve_fild07",
      "quantity": 2,
      "monsterName": "Stapo Ringleader"
    }
  ],
  2865: [
    {
      "location": "xmas_dun01",
      "quantity": 2,
      "monsterName": "Cookie Ringleader"
    }
  ],
  2737: [
    {
      "location": "xmas_dun02",
      "quantity": 2,
      "monsterName": "Furious Myst Case"
    }
  ],
  2762: [
    {
      "location": "xmas_fild01",
      "quantity": 1,
      "monsterName": "Furious Marin"
    }
  ],
  2825: [
    {
      "location": "yuno_fild01",
      "quantity": 2,
      "monsterName": "Solid Geographer"
    }
  ],
  2656: [
    {
      "location": "yuno_fild02",
      "quantity": 2,
      "monsterName": "Swift Sleeper"
    }
  ],
  2807: [
    {
      "location": "yuno_fild03",
      "quantity": 3,
      "monsterName": "Furious Harpy"
    }
  ],
  2806: [
    {
      "location": "yuno_fild04",
      "quantity": 3,
      "monsterName": "Harpy Ringleader"
    }
  ],
  2655: [
    {
      "location": "yuno_fild06",
      "quantity": 1,
      "monsterName": "Elusive Sleeper"
    }
  ],
  2816: [
    {
      "location": "yuno_fild07",
      "quantity": 2,
      "monsterName": "Goat Ringleader"
    }
  ],
  2811: [
    {
      "location": "yuno_fild08",
      "quantity": 2,
      "monsterName": "Grand Peco Ringleader"
    }
  ],
  2810: [
    {
      "location": "yuno_fild09",
      "quantity": 2,
      "monsterName": "Solid Grand Peco"
    }
  ],
  2815: [
    {
      "location": "yuno_fild11",
      "quantity": 2,
      "monsterName": "Solid Goat"
    }
  ],
  2824: [
    {
      "location": "yuno_fild12",
      "quantity": 1,
      "monsterName": "Swift Geographer"
    }
  ],
  2401: [
    {
      "location": "int_land",
      "quantity": 40,
      "monsterName": "Poring"
    },
    {
      "location": "int_land01",
      "quantity": 40,
      "monsterName": "Poring"
    },
    {
      "location": "int_land02",
      "quantity": 40,
      "monsterName": "Poring"
    },
    {
      "location": "int_land03",
      "quantity": 40,
      "monsterName": "Poring"
    },
    {
      "location": "int_land04",
      "quantity": 40,
      "monsterName": "Poring"
    }
  ],
  20355: [
    {
      "location": "sp_os",
      "quantity": 112,
      "monsterName": "Heart Hunter Bellare"
    }
  ],
  20357: [
    {
      "location": "sp_os",
      "quantity": 108,
      "monsterName": "Heart Hunter Sanare"
    }
  ],
  20363: [
    {
      "location": "sp_os",
      "quantity": 5,
      "monsterName": "Venenum"
    },
    {
      "location": "sp_rudus",
      "quantity": 30,
      "monsterName": "Venenum"
    }
  ],
  2081: [
    {
      "location": "brasilis",
      "quantity": 5,
      "monsterName": "Strange Hydra"
    },
    {
      "location": "brasilis",
      "quantity": 4,
      "monsterName": "Strange Hydra"
    },
    {
      "location": "brasilis",
      "quantity": 4,
      "monsterName": "Strange Hydra"
    },
    {
      "location": "brasilis",
      "quantity": 5,
      "monsterName": "Strange Hydra"
    }
  ],
  3154: [
    {
      "location": "ver_eju",
      "quantity": 50,
      "monsterName": "Recon Robot"
    },
    {
      "location": "ver_tunn",
      "quantity": 5,
      "monsterName": "Recon Robot"
    }
  ],
  3153: [
    {
      "location": "ver_eju",
      "quantity": 10,
      "monsterName": "Excavator Robot"
    }
  ],
  3247: [
    {
      "location": "verus01",
      "quantity": 50,
      "monsterName": "Green Cenere"
    }
  ],
  3249: [
    {
      "location": "verus01",
      "quantity": 25,
      "monsterName": "Explorer Robot Turbo"
    },
    {
      "location": "verus02",
      "quantity": 50,
      "monsterName": "Explorer Robot Turbo"
    }
  ],
  3248: [
    {
      "location": "verus01",
      "quantity": 25,
      "monsterName": "Repair Robot Turbo"
    },
    {
      "location": "verus02",
      "quantity": 50,
      "monsterName": "Repair Robot Turbo"
    }
  ],
  3159: [
    {
      "location": "verus03",
      "quantity": 40,
      "monsterName": "Illegal Promotion"
    }
  ],
  3156: [
    {
      "location": "verus03",
      "quantity": 50,
      "monsterName": "Explorer Robot"
    }
  ],
  3155: [
    {
      "location": "verus03",
      "quantity": 50,
      "monsterName": "Repair Robot"
    }
  ],
  3158: [
    {
      "location": "verus03",
      "quantity": 10,
      "monsterName": "Ruin Grace Believer"
    }
  ],
  1051: [
    {
      "location": "un_bunker",
      "quantity": 6,
      "monsterName": "Thief Bug"
    },
    {
      "location": "prt_sewb1",
      "quantity": 40,
      "monsterName": "Thief Bug"
    },
    {
      "location": "prt_sewb2",
      "quantity": 70,
      "monsterName": "Thief Bug"
    },
    {
      "location": "prt_sewb3",
      "quantity": 20,
      "monsterName": "Thief Bug"
    },
    {
      "location": "prt_sewb4",
      "quantity": 20,
      "monsterName": "Thief Bug"
    },
    {
      "location": "gef_fild05",
      "quantity": 10,
      "monsterName": "Thief Bug"
    },
    {
      "location": "prt_fild05",
      "quantity": 42,
      "monsterName": "Thief Bug"
    }
  ],
  3255: [
    {
      "location": "un_bunker",
      "quantity": 68,
      "monsterName": "Smelly Ghoul"
    }
  ],
  3256: [
    {
      "location": "un_bunker",
      "quantity": 80,
      "monsterName": "Smelly Zombie"
    }
  ],
  3250: [
    {
      "location": "un_bunker",
      "quantity": 28,
      "monsterName": "Machine Component"
    }
  ],
  3252: [
    {
      "location": "un_bunker",
      "quantity": 14,
      "monsterName": "DR815"
    }
  ],
  3251: [
    {
      "location": "un_bunker",
      "quantity": 10,
      "monsterName": "GC109"
    }
  ],
  1011: [
    {
      "location": "un_bunker",
      "quantity": 2,
      "monsterName": "Chonchon"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Chonchon"
    },
    {
      "location": "gef_fild00",
      "quantity": 160,
      "monsterName": "Chonchon"
    },
    {
      "location": "gef_fild04",
      "quantity": 25,
      "monsterName": "Chonchon"
    },
    {
      "location": "gef_fild07",
      "quantity": 20,
      "monsterName": "Chonchon"
    },
    {
      "location": "moc_fild07",
      "quantity": 46,
      "monsterName": "Chonchon"
    }
  ],
  1036: [
    {
      "location": "nameless_n",
      "quantity": 40,
      "monsterName": "Ghoul"
    },
    {
      "location": "abbey01",
      "quantity": 57,
      "monsterName": "Ghoul"
    },
    {
      "location": "ayo_dun01",
      "quantity": 48,
      "monsterName": "Ghoul"
    },
    {
      "location": "gef_dun01",
      "quantity": 40,
      "monsterName": "Ghoul"
    },
    {
      "location": "gef_dun02",
      "quantity": 10,
      "monsterName": "Ghoul"
    }
  ],
  1866: [
    {
      "location": "nameless_n",
      "quantity": 17,
      "monsterName": "Hellhound"
    },
    {
      "location": "abbey01",
      "quantity": 25,
      "monsterName": "Hellhound"
    }
  ],
  1867: [
    {
      "location": "nameless_n",
      "quantity": 16,
      "monsterName": "Banshee"
    },
    {
      "location": "abbey01",
      "quantity": 96,
      "monsterName": "Banshee"
    },
    {
      "location": "abbey03",
      "quantity": 30,
      "monsterName": "Banshee"
    }
  ],
  1865: [
    {
      "location": "nameless_n",
      "quantity": 12,
      "monsterName": "Ragged Zombie"
    },
    {
      "location": "abbey01",
      "quantity": 34,
      "monsterName": "Ragged Zombie"
    },
    {
      "location": "abbey02",
      "quantity": 70,
      "monsterName": "Ragged Zombie"
    }
  ],
  1864: [
    {
      "location": "nameless_n",
      "quantity": 12,
      "monsterName": "Zombie Slaughter"
    },
    {
      "location": "abbey01",
      "quantity": 30,
      "monsterName": "Zombie Slaughter"
    },
    {
      "location": "abbey02",
      "quantity": 210,
      "monsterName": "Zombie Slaughter"
    }
  ],
  1869: [
    {
      "location": "nameless_n",
      "quantity": 3,
      "monsterName": "Flame Skull"
    },
    {
      "location": "abbey01",
      "quantity": 21,
      "monsterName": "Flame Skull"
    },
    {
      "location": "abbey02",
      "quantity": 21,
      "monsterName": "Flame Skull"
    },
    {
      "location": "abbey03",
      "quantity": 25,
      "monsterName": "Flame Skull"
    }
  ],
  1870: [
    {
      "location": "abbey02",
      "quantity": 7,
      "monsterName": "Necromancer"
    },
    {
      "location": "abbey03",
      "quantity": 60,
      "monsterName": "Necromancer"
    }
  ],
  1871: [
    {
      "location": "abbey02",
      "quantity": 1,
      "monsterName": "Fallen Bishop"
    }
  ],
  1873: [
    {
      "location": "abbey03",
      "quantity": 1,
      "monsterName": "Beelzebub"
    }
  ],
  1717: [
    {
      "location": "abyss_01",
      "quantity": 55,
      "monsterName": "Ferus"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Ferus"
    }
  ],
  1216: [
    {
      "location": "abyss_01",
      "quantity": 30,
      "monsterName": "Penomena"
    },
    {
      "location": "alde_dun03",
      "quantity": 85,
      "monsterName": "Penomena"
    }
  ],
  1714: [
    {
      "location": "abyss_01",
      "quantity": 30,
      "monsterName": "Ferus"
    },
    {
      "location": "abyss_02",
      "quantity": 50,
      "monsterName": "Ferus"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Ferus"
    }
  ],
  1191: [
    {
      "location": "abyss_01",
      "quantity": 10,
      "monsterName": "Mimic"
    },
    {
      "location": "abyss_02",
      "quantity": 10,
      "monsterName": "Mimic"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Mimic"
    },
    {
      "location": "ama_dun03",
      "quantity": 5,
      "monsterName": "Mimic"
    },
    {
      "location": "c_tower2",
      "quantity": 4,
      "monsterName": "Mimic"
    },
    {
      "location": "c_tower3",
      "quantity": 9,
      "monsterName": "Mimic"
    },
    {
      "location": "c_tower4",
      "quantity": 12,
      "monsterName": "Mimic"
    },
    {
      "location": "gl_cas02",
      "quantity": 2,
      "monsterName": "Mimic"
    },
    {
      "location": "gl_church",
      "quantity": 12,
      "monsterName": "Mimic"
    },
    {
      "location": "gl_chyard",
      "quantity": 4,
      "monsterName": "Mimic"
    },
    {
      "location": "gl_step",
      "quantity": 6,
      "monsterName": "Mimic"
    },
    {
      "location": "in_sphinx3",
      "quantity": 6,
      "monsterName": "Mimic"
    },
    {
      "location": "in_sphinx4",
      "quantity": 6,
      "monsterName": "Mimic"
    },
    {
      "location": "in_sphinx5",
      "quantity": 7,
      "monsterName": "Mimic"
    },
    {
      "location": "lou_dun02",
      "quantity": 7,
      "monsterName": "Mimic"
    },
    {
      "location": "moc_pryd03",
      "quantity": 5,
      "monsterName": "Mimic"
    },
    {
      "location": "moc_pryd04",
      "quantity": 18,
      "monsterName": "Mimic"
    },
    {
      "location": "moc_pryd06",
      "quantity": 35,
      "monsterName": "Mimic"
    },
    {
      "location": "tha_t01",
      "quantity": 20,
      "monsterName": "Mimic"
    },
    {
      "location": "tha_t02",
      "quantity": 30,
      "monsterName": "Mimic"
    },
    {
      "location": "tha_t03",
      "quantity": 10,
      "monsterName": "Mimic"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Mimic"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Mimic"
    }
  ],
  1699: [
    {
      "location": "abyss_01",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "abyss_02",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t02",
      "quantity": 80,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t03",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t05",
      "quantity": 40,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t06",
      "quantity": 40,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t07",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    },
    {
      "location": "tha_t08",
      "quantity": 10,
      "monsterName": "Ancient Mimic"
    }
  ],
  1715: [
    {
      "location": "abyss_01",
      "quantity": 9,
      "monsterName": "Novus"
    },
    {
      "location": "abyss_02",
      "quantity": 5,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild01",
      "quantity": 105,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild02",
      "quantity": 126,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild04",
      "quantity": 30,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild05",
      "quantity": 35,
      "monsterName": "Novus"
    }
  ],
  1718: [
    {
      "location": "abyss_01",
      "quantity": 9,
      "monsterName": "Novus"
    },
    {
      "location": "abyss_02",
      "quantity": 5,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild01",
      "quantity": 36,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild02",
      "quantity": 37,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild04",
      "quantity": 100,
      "monsterName": "Novus"
    },
    {
      "location": "hu_fild05",
      "quantity": 130,
      "monsterName": "Novus"
    }
  ],
  1721: [
    {
      "location": "abyss_01",
      "quantity": 8,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "abyss_02",
      "quantity": 10,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "hu_fild01",
      "quantity": 10,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "hu_fild02",
      "quantity": 25,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "hu_fild04",
      "quantity": 20,
      "monsterName": "Dragon Egg"
    },
    {
      "location": "hu_fild05",
      "quantity": 20,
      "monsterName": "Dragon Egg"
    }
  ],
  1716: [
    {
      "location": "abyss_02",
      "quantity": 60,
      "monsterName": "Acidus"
    },
    {
      "location": "abyss_03",
      "quantity": 10,
      "monsterName": "Acidus"
    }
  ],
  1713: [
    {
      "location": "abyss_02",
      "quantity": 10,
      "monsterName": "Acidus"
    },
    {
      "location": "abyss_03",
      "quantity": 60,
      "monsterName": "Acidus"
    }
  ],
  1720: [
    {
      "location": "abyss_03",
      "quantity": 3,
      "monsterName": "Hydrolancer"
    }
  ],
  1719: [
    {
      "location": "abyss_03",
      "quantity": 1,
      "monsterName": "Detardeurus"
    }
  ],
  1194: [
    {
      "location": "alde_dun01",
      "quantity": 58,
      "monsterName": "Arclouze"
    },
    {
      "location": "alde_dun02",
      "quantity": 20,
      "monsterName": "Arclouze"
    },
    {
      "location": "gl_dun01",
      "quantity": 53,
      "monsterName": "Arclouze"
    },
    {
      "location": "gl_sew01",
      "quantity": 16,
      "monsterName": "Arclouze"
    },
    {
      "location": "moc_pryd06",
      "quantity": 23,
      "monsterName": "Arclouze"
    }
  ],
  1111: [
    {
      "location": "alde_dun01",
      "quantity": 47,
      "monsterName": "Drainliar"
    },
    {
      "location": "alde_dun03",
      "quantity": 55,
      "monsterName": "Drainliar"
    },
    {
      "location": "gef_dun01",
      "quantity": 20,
      "monsterName": "Drainliar"
    },
    {
      "location": "gl_sew04",
      "quantity": 12,
      "monsterName": "Drainliar"
    },
    {
      "location": "in_sphinx1",
      "quantity": 76,
      "monsterName": "Drainliar"
    },
    {
      "location": "in_sphinx2",
      "quantity": 24,
      "monsterName": "Drainliar"
    },
    {
      "location": "mjo_dun02",
      "quantity": 23,
      "monsterName": "Drainliar"
    },
    {
      "location": "moc_pryd02",
      "quantity": 20,
      "monsterName": "Drainliar"
    },
    {
      "location": "moc_pryd03",
      "quantity": 5,
      "monsterName": "Drainliar"
    },
    {
      "location": "orcsdun01",
      "quantity": 5,
      "monsterName": "Drainliar"
    },
    {
      "location": "orcsdun02",
      "quantity": 20,
      "monsterName": "Drainliar"
    },
    {
      "location": "pay_dun01",
      "quantity": 5,
      "monsterName": "Drainliar"
    },
    {
      "location": "prt_sewb4",
      "quantity": 20,
      "monsterName": "Drainliar"
    }
  ],
  1213: [
    {
      "location": "alde_dun02",
      "quantity": 50,
      "monsterName": "High Orc"
    }
  ],
  1211: [
    {
      "location": "alde_dun02",
      "quantity": 20,
      "monsterName": "Brilight"
    }
  ],
  1189: [
    {
      "location": "alde_dun02",
      "quantity": 20,
      "monsterName": "Orc Archer"
    },
    {
      "location": "orcsdun02",
      "quantity": 5,
      "monsterName": "Orc Archer"
    }
  ],
  1209: [
    {
      "location": "alde_dun03",
      "quantity": 56,
      "monsterName": "Cramp"
    },
    {
      "location": "gl_prison1",
      "quantity": 5,
      "monsterName": "Cramp"
    },
    {
      "location": "gl_sew02",
      "quantity": 24,
      "monsterName": "Cramp"
    },
    {
      "location": "mjo_dun03",
      "quantity": 3,
      "monsterName": "Cramp"
    },
    {
      "location": "prt_sewb4",
      "quantity": 5,
      "monsterName": "Cramp"
    }
  ],
  1102: [
    {
      "location": "alde_dun04",
      "quantity": 57,
      "monsterName": "Bathory"
    },
    {
      "location": "c_tower1",
      "quantity": 1,
      "monsterName": "Bathory"
    }
  ],
  1179: [
    {
      "location": "alde_dun04",
      "quantity": 11,
      "monsterName": "Whisper"
    },
    {
      "location": "ayo_dun01",
      "quantity": 16,
      "monsterName": "Whisper"
    },
    {
      "location": "ayo_dun02",
      "quantity": 23,
      "monsterName": "Whisper"
    },
    {
      "location": "c_tower4",
      "quantity": 5,
      "monsterName": "Whisper"
    },
    {
      "location": "gef_dun02",
      "quantity": 20,
      "monsterName": "Whisper"
    },
    {
      "location": "gl_cas01",
      "quantity": 17,
      "monsterName": "Whisper"
    },
    {
      "location": "gl_sew01",
      "quantity": 66,
      "monsterName": "Whisper"
    },
    {
      "location": "treasure02",
      "quantity": 10,
      "monsterName": "Whisper"
    }
  ],
  1131: [
    {
      "location": "alde_dun04",
      "quantity": 11,
      "monsterName": "Joker"
    }
  ],
  1404: [
    {
      "location": "ama_dun01",
      "quantity": 91,
      "monsterName": "Miyabi Doll"
    },
    {
      "location": "ama_dun02",
      "quantity": 5,
      "monsterName": "Miyabi Doll"
    },
    {
      "location": "ama_dun03",
      "quantity": 1,
      "monsterName": "Miyabi Doll"
    },
    {
      "location": "ama_fild01",
      "quantity": 2,
      "monsterName": "Miyabi Doll"
    }
  ],
  1403: [
    {
      "location": "ama_dun01",
      "quantity": 63,
      "monsterName": "Firelock Soldier"
    },
    {
      "location": "ama_dun02",
      "quantity": 20,
      "monsterName": "Firelock Soldier"
    },
    {
      "location": "ama_dun03",
      "quantity": 29,
      "monsterName": "Firelock Soldier"
    }
  ],
  1401: [
    {
      "location": "ama_dun01",
      "quantity": 2,
      "monsterName": "Shinobi"
    },
    {
      "location": "ama_dun02",
      "quantity": 2,
      "monsterName": "Shinobi"
    },
    {
      "location": "ama_dun03",
      "quantity": 65,
      "monsterName": "Shinobi"
    }
  ],
  1402: [
    {
      "location": "ama_dun02",
      "quantity": 35,
      "monsterName": "Poison Toad"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Poison Toad"
    }
  ],
  1129: [
    {
      "location": "ama_dun02",
      "quantity": 10,
      "monsterName": "Horong"
    },
    {
      "location": "lou_dun01",
      "quantity": 17,
      "monsterName": "Horong"
    },
    {
      "location": "pay_dun04",
      "quantity": 30,
      "monsterName": "Horong"
    }
  ],
  1375: [
    {
      "location": "ama_dun02",
      "quantity": 1,
      "monsterName": "The Paper"
    },
    {
      "location": "ama_dun03",
      "quantity": 23,
      "monsterName": "The Paper"
    }
  ],
  1405: [
    {
      "location": "ama_dun03",
      "quantity": 65,
      "monsterName": "Tengu"
    }
  ],
  1492: [
    {
      "location": "ama_dun03",
      "quantity": 1,
      "monsterName": "Samurai Specter"
    }
  ],
  20928: [
    {
      "location": "amicitia2",
      "quantity": 1,
      "monsterName": "The One"
    }
  ],
  1160: [
    {
      "location": "anthell01",
      "quantity": 50,
      "monsterName": "Piere"
    },
    {
      "location": "anthell02",
      "quantity": 15,
      "monsterName": "Piere"
    },
    {
      "location": "cmd_fild08",
      "quantity": 62,
      "monsterName": "Piere"
    },
    {
      "location": "cmd_fild09",
      "quantity": 16,
      "monsterName": "Piere"
    }
  ],
  1105: [
    {
      "location": "anthell01",
      "quantity": 40,
      "monsterName": "Deniro"
    },
    {
      "location": "anthell02",
      "quantity": 15,
      "monsterName": "Deniro"
    },
    {
      "location": "cmd_fild08",
      "quantity": 62,
      "monsterName": "Deniro"
    },
    {
      "location": "cmd_fild09",
      "quantity": 16,
      "monsterName": "Deniro"
    }
  ],
  1005: [
    {
      "location": "anthell01",
      "quantity": 20,
      "monsterName": "Familiar"
    },
    {
      "location": "anthell02",
      "quantity": 20,
      "monsterName": "Familiar"
    },
    {
      "location": "mjo_dun01",
      "quantity": 31,
      "monsterName": "Familiar"
    },
    {
      "location": "moc_pryd01",
      "quantity": 72,
      "monsterName": "Familiar"
    },
    {
      "location": "orcsdun01",
      "quantity": 15,
      "monsterName": "Familiar"
    },
    {
      "location": "pay_dun00",
      "quantity": 15,
      "monsterName": "Familiar"
    },
    {
      "location": "prt_sewb1",
      "quantity": 66,
      "monsterName": "Familiar"
    },
    {
      "location": "prt_sewb2",
      "quantity": 10,
      "monsterName": "Familiar"
    },
    {
      "location": "prt_sewb3",
      "quantity": 20,
      "monsterName": "Familiar"
    }
  ],
  1095: [
    {
      "location": "anthell01",
      "quantity": 15,
      "monsterName": "Andre"
    },
    {
      "location": "anthell02",
      "quantity": 50,
      "monsterName": "Andre"
    },
    {
      "location": "cmd_fild08",
      "quantity": 62,
      "monsterName": "Andre"
    },
    {
      "location": "cmd_fild09",
      "quantity": 16,
      "monsterName": "Andre"
    }
  ],
  1176: [
    {
      "location": "anthell01",
      "quantity": 10,
      "monsterName": "Vitata"
    },
    {
      "location": "anthell02",
      "quantity": 30,
      "monsterName": "Vitata"
    }
  ],
  1121: [
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Giearth"
    },
    {
      "location": "anthell02",
      "quantity": 3,
      "monsterName": "Giearth"
    },
    {
      "location": "mjo_dun02",
      "quantity": 41,
      "monsterName": "Giearth"
    },
    {
      "location": "mjo_dun03",
      "quantity": 5,
      "monsterName": "Giearth"
    }
  ],
  1097: [
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell01",
      "quantity": 1,
      "monsterName": "Ant Egg"
    },
    {
      "location": "anthell02",
      "quantity": 15,
      "monsterName": "Ant Egg"
    },
    {
      "location": "cmd_fild08",
      "quantity": 37,
      "monsterName": "Ant Egg"
    },
    {
      "location": "cmd_fild09",
      "quantity": 10,
      "monsterName": "Ant Egg"
    }
  ],
  1147: [
    {
      "location": "anthell02",
      "quantity": 1,
      "monsterName": "Maya"
    },
    {
      "location": "gld_dun02_2",
      "quantity": 1,
      "monsterName": "Maya"
    }
  ],
  21386: [
    {
      "location": "ant_d02_i",
      "quantity": 30,
      "monsterName": "Diligent Andre"
    }
  ],
  21388: [
    {
      "location": "ant_d02_i",
      "quantity": 20,
      "monsterName": "Diligent Andre Larva"
    }
  ],
  21391: [
    {
      "location": "ant_d02_i",
      "quantity": 20,
      "monsterName": "Mushy Ant Egg"
    }
  ],
  21389: [
    {
      "location": "ant_d02_i",
      "quantity": 30,
      "monsterName": "Diligent Deniro"
    }
  ],
  21393: [
    {
      "location": "ant_d02_i",
      "quantity": 25,
      "monsterName": "Gutsy Familiar"
    }
  ],
  21392: [
    {
      "location": "ant_d02_i",
      "quantity": 15,
      "monsterName": "Gutsy Giearth"
    }
  ],
  21390: [
    {
      "location": "ant_d02_i",
      "quantity": 30,
      "monsterName": "Diligent Piere"
    }
  ],
  21387: [
    {
      "location": "ant_d02_i",
      "quantity": 15,
      "monsterName": "Diligent Soldier Andre"
    }
  ],
  21394: [
    {
      "location": "ant_d02_i",
      "quantity": 15,
      "monsterName": "Diligent Vitata"
    }
  ],
  1586: [
    {
      "location": "ayo_dun01",
      "quantity": 104,
      "monsterName": "Leaf Cat"
    },
    {
      "location": "ayo_fild02",
      "quantity": 63,
      "monsterName": "Leaf Cat"
    }
  ],
  1587: [
    {
      "location": "ayo_dun01",
      "quantity": 8,
      "monsterName": "Kraben"
    },
    {
      "location": "ayo_dun02",
      "quantity": 23,
      "monsterName": "Kraben"
    },
    {
      "location": "ayo_fild02",
      "quantity": 9,
      "monsterName": "Kraben"
    }
  ],
  1584: [
    {
      "location": "ayo_dun02",
      "quantity": 116,
      "monsterName": "Tamruan"
    }
  ],
  1688: [
    {
      "location": "ayo_dun02",
      "quantity": 1,
      "monsterName": "Lady Tanee"
    }
  ],
  20639: [
    {
      "location": "ba_2whs01",
      "quantity": 30,
      "monsterName": "Broken Beta Guards"
    },
    {
      "location": "ba_2whs02",
      "quantity": 80,
      "monsterName": "Broken Beta Guards"
    }
  ],
  20641: [
    {
      "location": "ba_2whs01",
      "quantity": 90,
      "monsterName": "Broken Omega Cleaner"
    },
    {
      "location": "ba_2whs02",
      "quantity": 20,
      "monsterName": "Broken Omega Cleaner"
    }
  ],
  20682: [
    {
      "location": "ba_2whs01",
      "quantity": 70,
      "monsterName": "Heart Hunter Skirmisher"
    }
  ],
  20637: [
    {
      "location": "ba_2whs02",
      "quantity": 80,
      "monsterName": "Broken Warehouse Manager"
    }
  ],
  20633: [
    {
      "location": "ba_bath",
      "quantity": 30,
      "monsterName": "Broken Cleaner"
    }
  ],
  20634: [
    {
      "location": "ba_bath",
      "quantity": 30,
      "monsterName": "Broken Cleaner"
    }
  ],
  20643: [
    {
      "location": "ba_bath",
      "quantity": 70,
      "monsterName": "Boiling Water Phen"
    }
  ],
  20644: [
    {
      "location": "ba_bath",
      "quantity": 50,
      "monsterName": "Boiling Water Marc"
    }
  ],
  20645: [
    {
      "location": "ba_bath",
      "quantity": 50,
      "monsterName": "Boiling Water Swordfish"
    }
  ],
  20646: [
    {
      "location": "ba_bath",
      "quantity": 70,
      "monsterName": "Boiling Water Piranha"
    }
  ],
  20630: [
    {
      "location": "ba_lib",
      "quantity": 10,
      "monsterName": "Broken Beta"
    },
    {
      "location": "ba_pw01",
      "quantity": 15,
      "monsterName": "Broken Beta"
    },
    {
      "location": "ba_maison",
      "quantity": 15,
      "monsterName": "Broken Beta"
    }
  ],
  20680: [
    {
      "location": "ba_lib",
      "quantity": 15,
      "monsterName": "Heart Hunter Skirmisher"
    },
    {
      "location": "ba_pw01",
      "quantity": 15,
      "monsterName": "Heart Hunter Skirmisher"
    },
    {
      "location": "ba_pw02",
      "quantity": 15,
      "monsterName": "Heart Hunter Skirmisher"
    }
  ],
  20683: [
    {
      "location": "ba_lib",
      "quantity": 80,
      "monsterName": "Bookworm"
    },
    {
      "location": "ba_maison",
      "quantity": 2,
      "monsterName": "Bookworm"
    }
  ],
  20684: [
    {
      "location": "ba_lib",
      "quantity": 70,
      "monsterName": "Roaming Spellbook"
    },
    {
      "location": "ba_maison",
      "quantity": 1,
      "monsterName": "Roaming Spellbook"
    }
  ],
  20688: [
    {
      "location": "ba_pw01",
      "quantity": 90,
      "monsterName": "Elite Bellare"
    },
    {
      "location": "ba_pw02",
      "quantity": 60,
      "monsterName": "Elite Bellare"
    }
  ],
  20689: [
    {
      "location": "ba_pw01",
      "quantity": 80,
      "monsterName": "Spell Addicted Dolor"
    }
  ],
  20690: [
    {
      "location": "ba_pw01",
      "quantity": 50,
      "monsterName": "Released Spell"
    }
  ],
  20685: [
    {
      "location": "ba_pw02",
      "quantity": 60,
      "monsterName": "Sewage Venenum"
    }
  ],
  20686: [
    {
      "location": "ba_pw02",
      "quantity": 80,
      "monsterName": "Sewage Clamp"
    }
  ],
  20687: [
    {
      "location": "ba_pw02",
      "quantity": 60,
      "monsterName": "Sewage Waterfall"
    }
  ],
  20691: [
    {
      "location": "ba_pw03",
      "quantity": 80,
      "monsterName": "Spell Addicted Plaga"
    }
  ],
  20692: [
    {
      "location": "ba_pw03",
      "quantity": 80,
      "monsterName": "Spell Addicted Sanare"
    }
  ],
  20693: [
    {
      "location": "ba_pw03",
      "quantity": 70,
      "monsterName": "Powerful Spell"
    }
  ],
  20694: [
    {
      "location": "ba_pw03",
      "quantity": 70,
      "monsterName": "Sharp Spell"
    }
  ],
  1148: [
    {
      "location": "beach_dun",
      "quantity": 60,
      "monsterName": "Medusa"
    }
  ],
  1255: [
    {
      "location": "beach_dun",
      "quantity": 20,
      "monsterName": "Nereid"
    },
    {
      "location": "beach_dun2",
      "quantity": 3,
      "monsterName": "Nereid"
    },
    {
      "location": "beach_dun3",
      "quantity": 1,
      "monsterName": "Nereid"
    }
  ],
  1256: [
    {
      "location": "beach_dun",
      "quantity": 20,
      "monsterName": "Pest"
    },
    {
      "location": "tur_dun01",
      "quantity": 15,
      "monsterName": "Pest"
    },
    {
      "location": "tur_dun02",
      "quantity": 15,
      "monsterName": "Pest"
    }
  ],
  1264: [
    {
      "location": "beach_dun",
      "quantity": 3,
      "monsterName": "Merman"
    },
    {
      "location": "iz_dun02",
      "quantity": 1,
      "monsterName": "Merman"
    },
    {
      "location": "iz_dun03",
      "quantity": 3,
      "monsterName": "Merman"
    },
    {
      "location": "iz_dun04",
      "quantity": 61,
      "monsterName": "Merman"
    }
  ],
  1583: [
    {
      "location": "beach_dun",
      "quantity": 1,
      "monsterName": "Tao Gunka"
    }
  ],
  1278: [
    {
      "location": "beach_dun2",
      "quantity": 65,
      "monsterName": "Stalactic Golem"
    }
  ],
  1279: [
    {
      "location": "beach_dun2",
      "quantity": 20,
      "monsterName": "Tri Joint"
    }
  ],
  1274: [
    {
      "location": "beach_dun2",
      "quantity": 15,
      "monsterName": "Megalith"
    }
  ],
  1068: [
    {
      "location": "beach_dun2",
      "quantity": 10,
      "monsterName": "Hydra"
    },
    {
      "location": "beach_dun3",
      "quantity": 30,
      "monsterName": "Hydra"
    },
    {
      "location": "bra_dun01",
      "quantity": 15,
      "monsterName": "Hydra"
    },
    {
      "location": "bra_dun02",
      "quantity": 15,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun00",
      "quantity": 20,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun01",
      "quantity": 30,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun02",
      "quantity": 40,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "iz_dun04",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 4,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    },
    {
      "location": "ama_fild01",
      "quantity": 1,
      "monsterName": "Hydra"
    }
  ],
  1034: [
    {
      "location": "beach_dun3",
      "quantity": 50,
      "monsterName": "Thara Frog"
    },
    {
      "location": "tur_dun01",
      "quantity": 10,
      "monsterName": "Thara Frog"
    }
  ],
  1064: [
    {
      "location": "beach_dun3",
      "quantity": 30,
      "monsterName": "Megalodon"
    }
  ],
  2070: [
    {
      "location": "bra_dun01",
      "quantity": 80,
      "monsterName": "Piranha"
    },
    {
      "location": "bra_dun02",
      "quantity": 60,
      "monsterName": "Piranha"
    }
  ],
  2069: [
    {
      "location": "bra_dun01",
      "quantity": 30,
      "monsterName": "Iara"
    },
    {
      "location": "bra_dun02",
      "quantity": 110,
      "monsterName": "Iara"
    }
  ],
  1141: [
    {
      "location": "bra_dun01",
      "quantity": 20,
      "monsterName": "Marina"
    },
    {
      "location": "bra_dun02",
      "quantity": 10,
      "monsterName": "Marina"
    },
    {
      "location": "iz_dun00",
      "quantity": 61,
      "monsterName": "Marina"
    },
    {
      "location": "iz_dun01",
      "quantity": 15,
      "monsterName": "Marina"
    }
  ],
  1070: [
    {
      "location": "bra_dun01",
      "quantity": 10,
      "monsterName": "Kukre"
    },
    {
      "location": "bra_dun02",
      "quantity": 10,
      "monsterName": "Kukre"
    },
    {
      "location": "iz_dun00",
      "quantity": 20,
      "monsterName": "Kukre"
    },
    {
      "location": "iz_dun01",
      "quantity": 50,
      "monsterName": "Kukre"
    },
    {
      "location": "treasure01",
      "quantity": 10,
      "monsterName": "Kukre"
    },
    {
      "location": "treasure02",
      "quantity": 20,
      "monsterName": "Kukre"
    }
  ],
  1161: [
    {
      "location": "bra_dun01",
      "quantity": 10,
      "monsterName": "Plankton"
    },
    {
      "location": "bra_dun02",
      "quantity": 10,
      "monsterName": "Plankton"
    },
    {
      "location": "iz_dun00",
      "quantity": 88,
      "monsterName": "Plankton"
    },
    {
      "location": "iz_dun01",
      "quantity": 10,
      "monsterName": "Plankton"
    },
    {
      "location": "prt_sewb2",
      "quantity": 5,
      "monsterName": "Plankton"
    }
  ],
  1083: [
    {
      "location": "bra_dun02",
      "quantity": 2,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_dun00",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_dun02",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_dun03",
      "quantity": 5,
      "monsterName": "Shining Plant"
    },
    {
      "location": "glast_01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "lou_dun01",
      "quantity": 5,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mosk_dun03",
      "quantity": 5,
      "monsterName": "Shining Plant"
    },
    {
      "location": "odin_tem03",
      "quantity": 18,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 5,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 3,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yggdrasil01",
      "quantity": 10,
      "monsterName": "Shining Plant"
    },
    {
      "location": "cmd_fild01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "cmd_fild03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "cmd_fild03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "cmd_fild03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_fild02",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_fild06",
      "quantity": 4,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gef_fild07",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "gon_fild01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_04",
      "quantity": 3,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_05",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "mjolnir_10",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_fild04",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_fild06",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_fild08",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "pay_fild09",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_fild00",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_fild02",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_fild02",
      "quantity": 2,
      "monsterName": "Shining Plant"
    },
    {
      "location": "prt_fild10",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "um_fild01",
      "quantity": 5,
      "monsterName": "Shining Plant"
    },
    {
      "location": "um_fild03",
      "quantity": 2,
      "monsterName": "Shining Plant"
    },
    {
      "location": "ve_fild01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 1,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yuno_fild01",
      "quantity": 2,
      "monsterName": "Shining Plant"
    },
    {
      "location": "yuno_fild03",
      "quantity": 1,
      "monsterName": "Shining Plant"
    }
  ],
  2068: [
    {
      "location": "bra_dun02",
      "quantity": 1,
      "monsterName": "Boitata"
    }
  ],
  1195: [
    {
      "location": "c_tower1",
      "quantity": 107,
      "monsterName": "Rideword"
    },
    {
      "location": "c_tower2",
      "quantity": 16,
      "monsterName": "Rideword"
    },
    {
      "location": "c_tower3",
      "quantity": 8,
      "monsterName": "Rideword"
    },
    {
      "location": "c_tower4",
      "quantity": 15,
      "monsterName": "Rideword"
    },
    {
      "location": "gl_cas01",
      "quantity": 26,
      "monsterName": "Rideword"
    },
    {
      "location": "gl_cas02",
      "quantity": 29,
      "monsterName": "Rideword"
    },
    {
      "location": "gl_in01",
      "quantity": 10,
      "monsterName": "Rideword"
    },
    {
      "location": "gl_knt01",
      "quantity": 29,
      "monsterName": "Rideword"
    },
    {
      "location": "tha_t01",
      "quantity": 20,
      "monsterName": "Rideword"
    },
    {
      "location": "tha_t02",
      "quantity": 10,
      "monsterName": "Rideword"
    },
    {
      "location": "tha_t03",
      "quantity": 30,
      "monsterName": "Rideword"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Rideword"
    }
  ],
  1199: [
    {
      "location": "c_tower1",
      "quantity": 107,
      "monsterName": "Punk"
    },
    {
      "location": "c_tower2",
      "quantity": 55,
      "monsterName": "Punk"
    }
  ],
  1270: [
    {
      "location": "c_tower1",
      "quantity": 1,
      "monsterName": "Clock Tower Manager"
    },
    {
      "location": "c_tower2",
      "quantity": 1,
      "monsterName": "Clock Tower Manager"
    },
    {
      "location": "c_tower3",
      "quantity": 4,
      "monsterName": "Clock Tower Manager"
    },
    {
      "location": "c_tower4",
      "quantity": 3,
      "monsterName": "Clock Tower Manager"
    }
  ],
  1269: [
    {
      "location": "c_tower2",
      "quantity": 55,
      "monsterName": "Clock"
    },
    {
      "location": "c_tower4",
      "quantity": 35,
      "monsterName": "Clock"
    }
  ],
  1377: [
    {
      "location": "c_tower2",
      "quantity": 2,
      "monsterName": "Elder"
    },
    {
      "location": "c_tower4",
      "quantity": 2,
      "monsterName": "Elder"
    },
    {
      "location": "tha_t02",
      "quantity": 10,
      "monsterName": "Elder"
    },
    {
      "location": "tha_t03",
      "quantity": 10,
      "monsterName": "Elder"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Elder"
    },
    {
      "location": "tha_t05",
      "quantity": 20,
      "monsterName": "Elder"
    },
    {
      "location": "tha_t06",
      "quantity": 20,
      "monsterName": "Elder"
    }
  ],
  1193: [
    {
      "location": "c_tower3",
      "quantity": 109,
      "monsterName": "Alarm"
    },
    {
      "location": "c_tower4",
      "quantity": 30,
      "monsterName": "Alarm"
    }
  ],
  1320: [
    {
      "location": "c_tower4",
      "quantity": 30,
      "monsterName": "Owl Duke"
    },
    {
      "location": "gl_cas01",
      "quantity": 35,
      "monsterName": "Owl Duke"
    },
    {
      "location": "tha_t04",
      "quantity": 10,
      "monsterName": "Owl Duke"
    },
    {
      "location": "tha_t05",
      "quantity": 80,
      "monsterName": "Owl Duke"
    },
    {
      "location": "tha_t06",
      "quantity": 40,
      "monsterName": "Owl Duke"
    }
  ],
  2479: [
    {
      "location": "c_tower2_",
      "quantity": 4,
      "monsterName": "Mimic (Nightmare)"
    },
    {
      "location": "c_tower3_",
      "quantity": 9,
      "monsterName": "Mimic (Nightmare)"
    },
    {
      "location": "gl_cas02_",
      "quantity": 19,
      "monsterName": "Mimic (Nightmare)"
    },
    {
      "location": "gl_chyard_",
      "quantity": 34,
      "monsterName": "Mimic (Nightmare)"
    }
  ],
  2478: [
    {
      "location": "c_tower2_",
      "quantity": 16,
      "monsterName": "Rideword (Nightmare)"
    },
    {
      "location": "c_tower3_",
      "quantity": 8,
      "monsterName": "Rideword (Nightmare)"
    },
    {
      "location": "gl_cas02_",
      "quantity": 10,
      "monsterName": "Rideword (Nightmare)"
    }
  ],
  2919: [
    {
      "location": "c_tower2_",
      "quantity": 55,
      "monsterName": "Neo Punk"
    }
  ],
  2916: [
    {
      "location": "c_tower2_",
      "quantity": 55,
      "monsterName": "Big Ben"
    }
  ],
  2918: [
    {
      "location": "c_tower2_",
      "quantity": 1,
      "monsterName": "Time Keeper"
    },
    {
      "location": "c_tower3_",
      "quantity": 2,
      "monsterName": "Time Keeper"
    }
  ],
  2920: [
    {
      "location": "c_tower2_",
      "quantity": 2,
      "monsterName": "Arc Elder"
    }
  ],
  2921: [
    {
      "location": "c_tower2_",
      "quantity": 1,
      "monsterName": "Owl Viscount"
    },
    {
      "location": "c_tower3_",
      "quantity": 3,
      "monsterName": "Owl Viscount"
    }
  ],
  2917: [
    {
      "location": "c_tower3_",
      "quantity": 109,
      "monsterName": "Big Bell"
    }
  ],
  2923: [
    {
      "location": "c_tower3_",
      "quantity": 3,
      "monsterName": "Owl Marquis"
    }
  ],
  3074: [
    {
      "location": "c_tower3_",
      "quantity": 1,
      "monsterName": "Time Holder"
    }
  ],
  2152: [
    {
      "location": "dew_dun01",
      "quantity": 100,
      "monsterName": "Comodo"
    }
  ],
  2156: [
    {
      "location": "dew_dun01",
      "quantity": 1,
      "monsterName": "Leak"
    }
  ],
  2154: [
    {
      "location": "dew_dun02",
      "quantity": 70,
      "monsterName": "Banaspaty"
    }
  ],
  2155: [
    {
      "location": "dew_dun02",
      "quantity": 40,
      "monsterName": "Butoijo"
    }
  ],
  2083: [
    {
      "location": "dic_dun01",
      "quantity": 50,
      "monsterName": "One-Horned Scaraba"
    }
  ],
  2084: [
    {
      "location": "dic_dun01",
      "quantity": 45,
      "monsterName": "Two-Horned Scaraba"
    }
  ],
  2088: [
    {
      "location": "dic_dun01",
      "quantity": 15,
      "monsterName": "Scaraba Egg"
    }
  ],
  2089: [
    {
      "location": "dic_dun01",
      "quantity": 15,
      "monsterName": "Scaraba Egg"
    }
  ],
  2085: [
    {
      "location": "dic_dun02",
      "quantity": 50,
      "monsterName": "Antler Scaraba"
    }
  ],
  2086: [
    {
      "location": "dic_dun02",
      "quantity": 45,
      "monsterName": "Rake Scaraba"
    }
  ],
  2090: [
    {
      "location": "dic_dun02",
      "quantity": 15,
      "monsterName": "Antler Scaraba Egg"
    }
  ],
  2091: [
    {
      "location": "dic_dun02",
      "quantity": 15,
      "monsterName": "Rake Scaraba Egg"
    }
  ],
  2087: [
    {
      "location": "dic_dun02",
      "quantity": 1,
      "monsterName": "Scaraba Queen"
    }
  ],
  2166: [
    {
      "location": "dic_dun03",
      "quantity": 10,
      "monsterName": "Gold One-Horn Scaraba Egg"
    }
  ],
  2167: [
    {
      "location": "dic_dun03",
      "quantity": 10,
      "monsterName": "Gold Two-Horn Scaraba Egg"
    }
  ],
  2168: [
    {
      "location": "dic_dun03",
      "quantity": 10,
      "monsterName": "Gold Antler Scaraba Egg"
    }
  ],
  2169: [
    {
      "location": "dic_dun03",
      "quantity": 10,
      "monsterName": "Gold Rake Scaraba Egg"
    }
  ],
  2161: [
    {
      "location": "dic_dun03",
      "quantity": 30,
      "monsterName": "Gold One-Horn Scaraba"
    }
  ],
  2162: [
    {
      "location": "dic_dun03",
      "quantity": 30,
      "monsterName": "Gold Two-Horn Scaraba"
    }
  ],
  2163: [
    {
      "location": "dic_dun03",
      "quantity": 40,
      "monsterName": "Gold Antler Scaraba"
    }
  ],
  2164: [
    {
      "location": "dic_dun03",
      "quantity": 40,
      "monsterName": "Gold Rake Scaraba"
    }
  ],
  2165: [
    {
      "location": "dic_dun03",
      "quantity": 1,
      "monsterName": "Gold Queen Scaraba"
    }
  ],
  2365: [
    {
      "location": "ecl_tdun01",
      "quantity": 15,
      "monsterName": "Cenere"
    },
    {
      "location": "ecl_tdun02",
      "quantity": 15,
      "monsterName": "Cenere"
    }
  ],
  2366: [
    {
      "location": "ecl_tdun01",
      "quantity": 10,
      "monsterName": "Antique Book"
    },
    {
      "location": "ecl_tdun02",
      "quantity": 15,
      "monsterName": "Antique Book"
    },
    {
      "location": "ecl_tdun03",
      "quantity": 15,
      "monsterName": "Antique Book"
    }
  ],
  2367: [
    {
      "location": "ecl_tdun01",
      "quantity": 5,
      "monsterName": "Blue Lichtern"
    }
  ],
  2368: [
    {
      "location": "ecl_tdun01",
      "quantity": 5,
      "monsterName": "Yellow Lichtern"
    },
    {
      "location": "ecl_tdun02",
      "quantity": 5,
      "monsterName": "Yellow Lichtern"
    },
    {
      "location": "ecl_tdun03",
      "quantity": 5,
      "monsterName": "Yellow Lichtern"
    }
  ],
  2369: [
    {
      "location": "ecl_tdun02",
      "quantity": 5,
      "monsterName": "Red Lichtern"
    }
  ],
  2370: [
    {
      "location": "ecl_tdun03",
      "quantity": 5,
      "monsterName": "Green Lichtern"
    }
  ],
  2371: [
    {
      "location": "ecl_tdun03",
      "quantity": 3,
      "monsterName": "Faithful Manager"
    }
  ],
  1616: [
    {
      "location": "ein_dun01",
      "quantity": 70,
      "monsterName": "Pitman"
    },
    {
      "location": "ein_fild03",
      "quantity": 20,
      "monsterName": "Pitman"
    },
    {
      "location": "ein_fild04",
      "quantity": 12,
      "monsterName": "Pitman"
    },
    {
      "location": "ein_fild05",
      "quantity": 10,
      "monsterName": "Pitman"
    }
  ],
  1620: [
    {
      "location": "ein_dun01",
      "quantity": 30,
      "monsterName": "Noxious"
    },
    {
      "location": "ein_fild03",
      "quantity": 20,
      "monsterName": "Noxious"
    },
    {
      "location": "ein_fild04",
      "quantity": 37,
      "monsterName": "Noxious"
    },
    {
      "location": "ein_fild05",
      "quantity": 100,
      "monsterName": "Noxious"
    }
  ],
  1619: [
    {
      "location": "ein_dun01",
      "quantity": 30,
      "monsterName": "Porcellio"
    },
    {
      "location": "ein_fild07",
      "quantity": 36,
      "monsterName": "Porcellio"
    },
    {
      "location": "ein_fild08",
      "quantity": 41,
      "monsterName": "Porcellio"
    },
    {
      "location": "ein_fild09",
      "quantity": 97,
      "monsterName": "Porcellio"
    }
  ],
  1621: [
    {
      "location": "ein_dun01",
      "quantity": 10,
      "monsterName": "Venomous"
    },
    {
      "location": "ein_fild03",
      "quantity": 20,
      "monsterName": "Venomous"
    },
    {
      "location": "ein_fild04",
      "quantity": 124,
      "monsterName": "Venomous"
    },
    {
      "location": "ein_fild05",
      "quantity": 30,
      "monsterName": "Venomous"
    }
  ],
  1617: [
    {
      "location": "ein_dun01",
      "quantity": 1,
      "monsterName": "Old Stove"
    },
    {
      "location": "ein_dun02",
      "quantity": 30,
      "monsterName": "Old Stove"
    }
  ],
  1618: [
    {
      "location": "ein_dun01",
      "quantity": 1,
      "monsterName": "Ungoliant"
    },
    {
      "location": "ein_fild07",
      "quantity": 1,
      "monsterName": "Ungoliant"
    }
  ],
  1614: [
    {
      "location": "ein_dun02",
      "quantity": 50,
      "monsterName": "Mineral"
    }
  ],
  1615: [
    {
      "location": "ein_dun02",
      "quantity": 40,
      "monsterName": "Obsidian"
    }
  ],
  1622: [
    {
      "location": "ein_dun02",
      "quantity": 30,
      "monsterName": "Teddy Bear"
    },
    {
      "location": "ein_fild03",
      "quantity": 100,
      "monsterName": "Teddy Bear"
    },
    {
      "location": "ein_fild04",
      "quantity": 24,
      "monsterName": "Teddy Bear"
    },
    {
      "location": "ein_fild05",
      "quantity": 20,
      "monsterName": "Teddy Bear"
    }
  ],
  1623: [
    {
      "location": "ein_dun02",
      "quantity": 1,
      "monsterName": "RSX-0806"
    }
  ],
  20601: [
    {
      "location": "ein_dun03",
      "quantity": 1,
      "monsterName": "Jungoliant"
    }
  ],
  20255: [
    {
      "location": "ein_d02_i",
      "quantity": 25,
      "monsterName": "Red Teddybear"
    }
  ],
  20256: [
    {
      "location": "ein_d02_i",
      "quantity": 25,
      "monsterName": "Yellow Teddybear"
    }
  ],
  20257: [
    {
      "location": "ein_d02_i",
      "quantity": 25,
      "monsterName": "Green Teddybear"
    }
  ],
  20258: [
    {
      "location": "ein_d02_i",
      "quantity": 20,
      "monsterName": "White Teddybear"
    }
  ],
  20259: [
    {
      "location": "ein_d02_i",
      "quantity": 20,
      "monsterName": "Blue Teddybear"
    }
  ],
  1371: [
    {
      "location": "gefenia01",
      "quantity": 63,
      "monsterName": "False Angel"
    },
    {
      "location": "gefenia02",
      "quantity": 30,
      "monsterName": "False Angel"
    },
    {
      "location": "gefenia03",
      "quantity": 42,
      "monsterName": "False Angel"
    },
    {
      "location": "gefenia04",
      "quantity": 30,
      "monsterName": "False Angel"
    }
  ],
  1390: [
    {
      "location": "gefenia01",
      "quantity": 31,
      "monsterName": "Violy"
    },
    {
      "location": "gefenia02",
      "quantity": 40,
      "monsterName": "Violy"
    },
    {
      "location": "gefenia03",
      "quantity": 42,
      "monsterName": "Violy"
    },
    {
      "location": "gefenia04",
      "quantity": 30,
      "monsterName": "Violy"
    }
  ],
  1292: [
    {
      "location": "gefenia01",
      "quantity": 21,
      "monsterName": "Mini Demon"
    },
    {
      "location": "gefenia02",
      "quantity": 30,
      "monsterName": "Mini Demon"
    },
    {
      "location": "gefenia03",
      "quantity": 31,
      "monsterName": "Mini Demon"
    },
    {
      "location": "gefenia04",
      "quantity": 20,
      "monsterName": "Mini Demon"
    },
    {
      "location": "gld_dun04",
      "quantity": 10,
      "monsterName": "Mini Demon"
    }
  ],
  1219: [
    {
      "location": "gefenia01",
      "quantity": 10,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gefenia02",
      "quantity": 10,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gefenia03",
      "quantity": 10,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gefenia04",
      "quantity": 10,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "glast_01",
      "quantity": 2,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gl_cas02",
      "quantity": 7,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gl_knt01",
      "quantity": 14,
      "monsterName": "Abysmal Knight"
    },
    {
      "location": "gl_knt02",
      "quantity": 7,
      "monsterName": "Abysmal Knight"
    }
  ],
  1374: [
    {
      "location": "gefenia01",
      "quantity": 10,
      "monsterName": "Incubus"
    },
    {
      "location": "gefenia02",
      "quantity": 10,
      "monsterName": "Incubus"
    },
    {
      "location": "gefenia03",
      "quantity": 21,
      "monsterName": "Incubus"
    },
    {
      "location": "gefenia04",
      "quantity": 10,
      "monsterName": "Incubus"
    }
  ],
  1370: [
    {
      "location": "gefenia01",
      "quantity": 10,
      "monsterName": "Succubus"
    },
    {
      "location": "gefenia02",
      "quantity": 20,
      "monsterName": "Succubus"
    },
    {
      "location": "gefenia03",
      "quantity": 10,
      "monsterName": "Succubus"
    },
    {
      "location": "gefenia04",
      "quantity": 10,
      "monsterName": "Succubus"
    }
  ],
  1268: [
    {
      "location": "gefenia01",
      "quantity": 1,
      "monsterName": "Bloody Knight"
    },
    {
      "location": "gefenia02",
      "quantity": 1,
      "monsterName": "Bloody Knight"
    },
    {
      "location": "gefenia03",
      "quantity": 1,
      "monsterName": "Bloody Knight"
    },
    {
      "location": "gefenia04",
      "quantity": 1,
      "monsterName": "Bloody Knight"
    },
    {
      "location": "gl_knt02",
      "quantity": 1,
      "monsterName": "Bloody Knight"
    }
  ],
  1203: [
    {
      "location": "gefenia01",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gefenia02",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gefenia03",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gefenia04",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gl_cas02",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gl_knt02",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    },
    {
      "location": "gl_cas02_",
      "quantity": 1,
      "monsterName": "Mysteltainn"
    }
  ],
  1205: [
    {
      "location": "gefenia01",
      "quantity": 1,
      "monsterName": "Executioner"
    },
    {
      "location": "gefenia02",
      "quantity": 1,
      "monsterName": "Executioner"
    },
    {
      "location": "gefenia03",
      "quantity": 1,
      "monsterName": "Executioner"
    },
    {
      "location": "gefenia04",
      "quantity": 1,
      "monsterName": "Executioner"
    }
  ],
  1204: [
    {
      "location": "gefenia01",
      "quantity": 1,
      "monsterName": "Ogretooth"
    },
    {
      "location": "gefenia02",
      "quantity": 1,
      "monsterName": "Ogretooth"
    },
    {
      "location": "gefenia03",
      "quantity": 1,
      "monsterName": "Ogretooth"
    },
    {
      "location": "gefenia04",
      "quantity": 1,
      "monsterName": "Ogretooth"
    },
    {
      "location": "gl_cas02",
      "quantity": 1,
      "monsterName": "Ogretooth"
    }
  ],
  1035: [
    {
      "location": "gef_dun00",
      "quantity": 30,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "gef_dun02",
      "quantity": 10,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "gl_chyard",
      "quantity": 4,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "gl_prison",
      "quantity": 12,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "gl_prison1",
      "quantity": 10,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "prt_maze03",
      "quantity": 30,
      "monsterName": "Hunter Fly"
    },
    {
      "location": "mjolnir_12",
      "quantity": 43,
      "monsterName": "Hunter Fly"
    }
  ],
  1077: [
    {
      "location": "gef_dun00",
      "quantity": 25,
      "monsterName": "Poison Spore"
    },
    {
      "location": "prt_sewb3",
      "quantity": 15,
      "monsterName": "Poison Spore"
    },
    {
      "location": "mjolnir_06",
      "quantity": 100,
      "monsterName": "Poison Spore"
    }
  ],
  1031: [
    {
      "location": "gef_dun00",
      "quantity": 15,
      "monsterName": "Poporing"
    },
    {
      "location": "moc_pryd01",
      "quantity": 28,
      "monsterName": "Poporing"
    },
    {
      "location": "moc_pryd02",
      "quantity": 20,
      "monsterName": "Poporing"
    },
    {
      "location": "mosk_dun01",
      "quantity": 22,
      "monsterName": "Poporing"
    },
    {
      "location": "pay_dun00",
      "quantity": 15,
      "monsterName": "Poporing"
    },
    {
      "location": "pay_dun02",
      "quantity": 10,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_maze02",
      "quantity": 32,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_maze03",
      "quantity": 52,
      "monsterName": "Poporing"
    },
    {
      "location": "xmas_dun01",
      "quantity": 24,
      "monsterName": "Poporing"
    },
    {
      "location": "gef_fild02",
      "quantity": 24,
      "monsterName": "Poporing"
    },
    {
      "location": "mjolnir_02",
      "quantity": 22,
      "monsterName": "Poporing"
    },
    {
      "location": "pay_fild04",
      "quantity": 141,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_fild02",
      "quantity": 40,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_fild03",
      "quantity": 38,
      "monsterName": "Poporing"
    },
    {
      "location": "prt_fild10",
      "quantity": 22,
      "monsterName": "Poporing"
    }
  ],
  1130: [
    {
      "location": "gef_dun01",
      "quantity": 40,
      "monsterName": "Jakk"
    }
  ],
  1061: [
    {
      "location": "gef_dun01",
      "quantity": 30,
      "monsterName": "Nightmare"
    },
    {
      "location": "gef_dun02",
      "quantity": 20,
      "monsterName": "Nightmare"
    }
  ],
  1389: [
    {
      "location": "gef_dun01",
      "quantity": 1,
      "monsterName": "Dracula"
    }
  ],
  1109: [
    {
      "location": "gef_dun02",
      "quantity": 45,
      "monsterName": "Deviruchi"
    }
  ],
  1143: [
    {
      "location": "gef_dun02",
      "quantity": 30,
      "monsterName": "Marionette"
    },
    {
      "location": "gl_in01",
      "quantity": 25,
      "monsterName": "Marionette"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Marionette"
    }
  ],
  1046: [
    {
      "location": "gef_dun02",
      "quantity": 1,
      "monsterName": "Doppelganger"
    },
    {
      "location": "gld_dun04",
      "quantity": 1,
      "monsterName": "Doppelganger"
    }
  ],
  1192: [
    {
      "location": "gef_dun03",
      "quantity": 14,
      "monsterName": "Wraith"
    },
    {
      "location": "gl_church",
      "quantity": 78,
      "monsterName": "Wraith"
    },
    {
      "location": "gl_chyard",
      "quantity": 55,
      "monsterName": "Wraith"
    }
  ],
  1263: [
    {
      "location": "gef_dun03",
      "quantity": 5,
      "monsterName": "Wind Ghost"
    },
    {
      "location": "gl_step",
      "quantity": 138,
      "monsterName": "Wind Ghost"
    }
  ],
  1626: [
    {
      "location": "gef_dun03",
      "quantity": 1,
      "monsterName": "Hellion Revenant"
    }
  ],
  1253: [
    {
      "location": "glast_01",
      "quantity": 10,
      "monsterName": "Gargoyle"
    },
    {
      "location": "gl_dun02",
      "quantity": 17,
      "monsterName": "Gargoyle"
    },
    {
      "location": "gl_sew01",
      "quantity": 49,
      "monsterName": "Gargoyle"
    },
    {
      "location": "gl_sew02",
      "quantity": 89,
      "monsterName": "Gargoyle"
    },
    {
      "location": "gl_sew03",
      "quantity": 56,
      "monsterName": "Gargoyle"
    },
    {
      "location": "gl_sew04",
      "quantity": 25,
      "monsterName": "Gargoyle"
    }
  ],
  1267: [
    {
      "location": "gl_cas01",
      "quantity": 50,
      "monsterName": "Carat"
    }
  ],
  1260: [
    {
      "location": "gl_cas01",
      "quantity": 35,
      "monsterName": "Dark Frame"
    },
    {
      "location": "gl_in01",
      "quantity": 12,
      "monsterName": "Dark Frame"
    }
  ],
  1281: [
    {
      "location": "gl_cas01",
      "quantity": 17,
      "monsterName": "Sage Worm"
    },
    {
      "location": "gl_in01",
      "quantity": 17,
      "monsterName": "Sage Worm"
    }
  ],
  1295: [
    {
      "location": "gl_cas01",
      "quantity": 10,
      "monsterName": "Owl Baron"
    },
    {
      "location": "tha_t04",
      "quantity": 10,
      "monsterName": "Owl Baron"
    },
    {
      "location": "tha_t05",
      "quantity": 20,
      "monsterName": "Owl Baron"
    },
    {
      "location": "tha_t06",
      "quantity": 40,
      "monsterName": "Owl Baron"
    }
  ],
  1275: [
    {
      "location": "gl_cas01",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "gl_cas02",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "gl_in01",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "gl_knt02",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "gl_cas02_",
      "quantity": 1,
      "monsterName": "Alice"
    },
    {
      "location": "kh_dun01",
      "quantity": 30,
      "monsterName": "Alice"
    },
    {
      "location": "tha_t01",
      "quantity": 5,
      "monsterName": "Alice"
    },
    {
      "location": "tha_t02",
      "quantity": 10,
      "monsterName": "Alice"
    }
  ],
  1208: [
    {
      "location": "gl_cas02",
      "quantity": 41,
      "monsterName": "Wanderer"
    },
    {
      "location": "gl_in01",
      "quantity": 1,
      "monsterName": "Wanderer"
    }
  ],
  1163: [
    {
      "location": "gl_cas02",
      "quantity": 36,
      "monsterName": "Raydric"
    },
    {
      "location": "gl_knt01",
      "quantity": 126,
      "monsterName": "Raydric"
    },
    {
      "location": "gl_knt02",
      "quantity": 101,
      "monsterName": "Raydric"
    }
  ],
  1276: [
    {
      "location": "gl_cas02",
      "quantity": 20,
      "monsterName": "Raydric Archer"
    },
    {
      "location": "gl_knt01",
      "quantity": 14,
      "monsterName": "Raydric Archer"
    },
    {
      "location": "gl_knt02",
      "quantity": 38,
      "monsterName": "Raydric Archer"
    },
    {
      "location": "gl_step",
      "quantity": 13,
      "monsterName": "Raydric Archer"
    }
  ],
  1117: [
    {
      "location": "gl_cas02",
      "quantity": 9,
      "monsterName": "Evil Druid"
    },
    {
      "location": "gl_church",
      "quantity": 85,
      "monsterName": "Evil Druid"
    },
    {
      "location": "gl_chyard",
      "quantity": 15,
      "monsterName": "Evil Druid"
    }
  ],
  1132: [
    {
      "location": "gl_cas02",
      "quantity": 6,
      "monsterName": "Khalitzburg"
    },
    {
      "location": "gl_knt01",
      "quantity": 14,
      "monsterName": "Khalitzburg"
    },
    {
      "location": "gl_knt02",
      "quantity": 50,
      "monsterName": "Khalitzburg"
    }
  ],
  1283: [
    {
      "location": "gl_cas02",
      "quantity": 3,
      "monsterName": "Chimera"
    }
  ],
  1185: [
    {
      "location": "gl_cas02",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "gl_cas02_",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Whisper"
    },
    {
      "location": "pay_d03_i",
      "quantity": 1,
      "monsterName": "Whisper"
    }
  ],
  1198: [
    {
      "location": "gl_chyard",
      "quantity": 95,
      "monsterName": "Dark Priest"
    }
  ],
  1272: [
    {
      "location": "gl_chyard",
      "quantity": 1,
      "monsterName": "Dark Lord"
    },
    {
      "location": "gl_chyard_",
      "quantity": 1,
      "monsterName": "Dark Lord"
    },
    {
      "location": "gld_dun04_2",
      "quantity": 1,
      "monsterName": "Dark Lord"
    }
  ],
  1302: [
    {
      "location": "gl_chyard",
      "quantity": 1,
      "monsterName": "Dark Illusion"
    },
    {
      "location": "gld_dun04_2",
      "quantity": 1,
      "monsterName": "Dark Illusion"
    },
    {
      "location": "gld2_gef",
      "quantity": 1,
      "monsterName": "Dark Illusion"
    }
  ],
  1207: [
    {
      "location": "gl_dun01",
      "quantity": 43,
      "monsterName": "Sting"
    },
    {
      "location": "gl_sew03",
      "quantity": 99,
      "monsterName": "Sting"
    }
  ],
  1310: [
    {
      "location": "gl_dun02",
      "quantity": 52,
      "monsterName": "Majoruros"
    }
  ],
  1186: [
    {
      "location": "gl_knt01",
      "quantity": 1,
      "monsterName": "Giant Whisper"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Giant Whisper"
    }
  ],
  1197: [
    {
      "location": "gl_prison",
      "quantity": 38,
      "monsterName": "Zombie Prisoner"
    }
  ],
  1257: [
    {
      "location": "gl_prison",
      "quantity": 25,
      "monsterName": "Injustice"
    },
    {
      "location": "gl_prison1",
      "quantity": 40,
      "monsterName": "Injustice"
    }
  ],
  1201: [
    {
      "location": "gl_prison",
      "quantity": 19,
      "monsterName": "Rybio"
    },
    {
      "location": "gl_prison1",
      "quantity": 10,
      "monsterName": "Rybio"
    }
  ],
  1196: [
    {
      "location": "gl_prison1",
      "quantity": 30,
      "monsterName": "Skeleton Prisoner"
    }
  ],
  1202: [
    {
      "location": "gl_prison1",
      "quantity": 10,
      "monsterName": "Phendark"
    }
  ],
  1200: [
    {
      "location": "gl_prison1",
      "quantity": 1,
      "monsterName": "Zealotus"
    }
  ],
  1206: [
    {
      "location": "gl_sew04",
      "quantity": 126,
      "monsterName": "Anolian"
    }
  ],
  2480: [
    {
      "location": "gl_cas02_",
      "quantity": 4,
      "monsterName": "Evil Druid (Nightmare)"
    },
    {
      "location": "gl_chyard_",
      "quantity": 22,
      "monsterName": "Evil Druid (Nightmare)"
    }
  ],
  2485: [
    {
      "location": "gl_cas02_",
      "quantity": 1,
      "monsterName": "Chimera (Nightmare)"
    }
  ],
  2477: [
    {
      "location": "gl_cas02_",
      "quantity": 60,
      "monsterName": "Wanderer (Nightmare)"
    }
  ],
  2483: [
    {
      "location": "gl_cas02_",
      "quantity": 1,
      "monsterName": "Baphomet (Nightmare)"
    }
  ],
  2481: [
    {
      "location": "gl_chyard_",
      "quantity": 91,
      "monsterName": "Wraith Dead (Nightmare)"
    }
  ],
  1291: [
    {
      "location": "gl_chyard_",
      "quantity": 31,
      "monsterName": "Wraith Dead"
    },
    {
      "location": "gld_dun04",
      "quantity": 25,
      "monsterName": "Wraith Dead"
    }
  ],
  20421: [
    {
      "location": "gl_cas01_",
      "quantity": 1,
      "monsterName": "Corrupted Spider Queen"
    }
  ],
  20422: [
    {
      "location": "gl_cas01_",
      "quantity": 1,
      "monsterName": "Corrupted Dark Lord"
    }
  ],
  1977: [
    {
      "location": "schg_dun01",
      "quantity": 15,
      "monsterName": "Heavy Metaling"
    }
  ],
  1976: [
    {
      "location": "schg_dun01",
      "quantity": 15,
      "monsterName": "Cobalt Mineral"
    }
  ],
  1975: [
    {
      "location": "arug_dun01",
      "quantity": 22,
      "monsterName": "Beholder master"
    }
  ],
  1796: [
    {
      "location": "arug_dun01",
      "quantity": 22,
      "monsterName": "Aunoe"
    }
  ],
  1797: [
    {
      "location": "arug_dun01",
      "quantity": 5,
      "monsterName": "Fanat"
    }
  ],
  1311: [
    {
      "location": "gld_dun01",
      "quantity": 30,
      "monsterName": "Gullinbursti"
    }
  ],
  1306: [
    {
      "location": "gld_dun01",
      "quantity": 55,
      "monsterName": "Leib Olmai"
    },
    {
      "location": "lou_dun01",
      "quantity": 1,
      "monsterName": "Leib Olmai"
    },
    {
      "location": "prt_maze02",
      "quantity": 1,
      "monsterName": "Leib Olmai"
    }
  ],
  1307: [
    {
      "location": "gld_dun01",
      "quantity": 3,
      "monsterName": "Cat O' Nine Tails"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Cat o' Nine Tails"
    }
  ],
  1150: [
    {
      "location": "gld_dun01",
      "quantity": 1,
      "monsterName": "Moonlight Flower"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Moonlight Flower"
    }
  ],
  1290: [
    {
      "location": "gld_dun01_2",
      "quantity": 50,
      "monsterName": "Skeleton General"
    },
    {
      "location": "gld2_pay",
      "quantity": 60,
      "monsterName": "Skeleton General"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Skeleton General"
    }
  ],
  1301: [
    {
      "location": "gld_dun01_2",
      "quantity": 15,
      "monsterName": "Am Mut"
    },
    {
      "location": "gld2_pay",
      "quantity": 25,
      "monsterName": "Am Mut"
    },
    {
      "location": "pay_dun04",
      "quantity": 1,
      "monsterName": "Am Mut"
    }
  ],
  1309: [
    {
      "location": "gld_dun01_2",
      "quantity": 20,
      "monsterName": "Gajomart"
    },
    {
      "location": "gld2_pay",
      "quantity": 30,
      "monsterName": "Gajomart"
    }
  ],
  1115: [
    {
      "location": "gld_dun01_2",
      "quantity": 1,
      "monsterName": "Eddga"
    },
    {
      "location": "pay_fild10",
      "quantity": 1,
      "monsterName": "Eddga"
    }
  ],
  2253: [
    {
      "location": "gld2_pay",
      "quantity": 1,
      "monsterName": "General Daehyun"
    }
  ],
  2254: [
    {
      "location": "gld2_pay",
      "quantity": 1,
      "monsterName": "Samurai Soheon"
    }
  ],
  1303: [
    {
      "location": "gld_dun02",
      "quantity": 30,
      "monsterName": "Giant Hornet"
    }
  ],
  1305: [
    {
      "location": "gld_dun02",
      "quantity": 25,
      "monsterName": "Ancient Worm"
    }
  ],
  1304: [
    {
      "location": "gld_dun02",
      "quantity": 15,
      "monsterName": "Giant Spider"
    }
  ],
  1059: [
    {
      "location": "gld_dun02",
      "quantity": 1,
      "monsterName": "Mistress"
    },
    {
      "location": "mjolnir_04",
      "quantity": 1,
      "monsterName": "Mistress"
    }
  ],
  1294: [
    {
      "location": "gld_dun02_2",
      "quantity": 30,
      "monsterName": "Killer Mantis"
    },
    {
      "location": "gld2_ald",
      "quantity": 60,
      "monsterName": "Killer Mantis"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Killer Mantis"
    }
  ],
  2133: [
    {
      "location": "gld_dun02_2",
      "quantity": 40,
      "monsterName": "Angra Mantis"
    },
    {
      "location": "gld2_ald",
      "quantity": 70,
      "monsterName": "Angra Mantis"
    },
    {
      "location": "bif_fild01",
      "quantity": 5,
      "monsterName": "Angra Mantis"
    },
    {
      "location": "bif_fild02",
      "quantity": 5,
      "monsterName": "Angra Mantis"
    }
  ],
  1289: [
    {
      "location": "gld_dun02_2",
      "quantity": 3,
      "monsterName": "Maya Purple"
    },
    {
      "location": "gld2_ald",
      "quantity": 3,
      "monsterName": "Maya Purple"
    }
  ],
  2251: [
    {
      "location": "gld2_ald",
      "quantity": 1,
      "monsterName": "Gioia"
    }
  ],
  2252: [
    {
      "location": "gld2_ald",
      "quantity": 1,
      "monsterName": "Elvira"
    }
  ],
  1300: [
    {
      "location": "gld_dun03",
      "quantity": 35,
      "monsterName": "Caterpillar"
    }
  ],
  1293: [
    {
      "location": "gld_dun03",
      "quantity": 35,
      "monsterName": "Creamy Fear"
    }
  ],
  1039: [
    {
      "location": "gld_dun03",
      "quantity": 1,
      "monsterName": "Baphomet"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Baphomet"
    }
  ],
  2284: [
    {
      "location": "gld_dun03_2",
      "quantity": 13,
      "monsterName": "Dark Axe Kobold"
    },
    {
      "location": "gld2_prt",
      "quantity": 25,
      "monsterName": "Dark Axe Kobold"
    }
  ],
  2285: [
    {
      "location": "gld_dun03_2",
      "quantity": 23,
      "monsterName": "Dark Hammer Kobold"
    },
    {
      "location": "gld2_prt",
      "quantity": 35,
      "monsterName": "Dark Hammer Kobold"
    }
  ],
  2286: [
    {
      "location": "gld_dun03_2",
      "quantity": 23,
      "monsterName": "Dark Mace Kobold"
    },
    {
      "location": "gld2_prt",
      "quantity": 35,
      "monsterName": "Dark Mace Kobold"
    }
  ],
  2287: [
    {
      "location": "gld_dun03_2",
      "quantity": 23,
      "monsterName": "Dark Kobold Archer"
    },
    {
      "location": "gld2_prt",
      "quantity": 35,
      "monsterName": "Dark Kobold Archer"
    }
  ],
  1296: [
    {
      "location": "gld_dun03_2",
      "quantity": 1,
      "monsterName": "Kobold Leader"
    },
    {
      "location": "ra_fild06",
      "quantity": 1,
      "monsterName": "Kobold Leader"
    }
  ],
  1785: [
    {
      "location": "gld_dun03_2",
      "quantity": 1,
      "monsterName": "Atroce"
    },
    {
      "location": "ra_fild03",
      "quantity": 1,
      "monsterName": "Atroce"
    },
    {
      "location": "ra_fild04",
      "quantity": 1,
      "monsterName": "Atroce"
    },
    {
      "location": "ve_fild01",
      "quantity": 1,
      "monsterName": "Atroce"
    },
    {
      "location": "ve_fild02",
      "quantity": 1,
      "monsterName": "Atroce"
    }
  ],
  2249: [
    {
      "location": "gld2_prt",
      "quantity": 1,
      "monsterName": "Angry Student Pyuriel"
    }
  ],
  2250: [
    {
      "location": "gld2_prt",
      "quantity": 1,
      "monsterName": "Warrior Laura"
    }
  ],
  1298: [
    {
      "location": "gld_dun04",
      "quantity": 55,
      "monsterName": "Zombie Master"
    }
  ],
  1120: [
    {
      "location": "gld_dun04",
      "quantity": 1,
      "monsterName": "Ghostring"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Ghostring"
    },
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Ghostring"
    },
    {
      "location": "pay_fild04",
      "quantity": 1,
      "monsterName": "Ghostring"
    }
  ],
  2282: [
    {
      "location": "gld_dun04_2",
      "quantity": 15,
      "monsterName": "Dark Frame"
    },
    {
      "location": "gld2_gef",
      "quantity": 20,
      "monsterName": "Dark Frame"
    }
  ],
  2283: [
    {
      "location": "gld_dun04_2",
      "quantity": 15,
      "monsterName": "Dark Priest"
    },
    {
      "location": "gld2_gef",
      "quantity": 20,
      "monsterName": "Dark Priest"
    }
  ],
  2281: [
    {
      "location": "gld_dun04_2",
      "quantity": 45,
      "monsterName": "Dark Shadow"
    },
    {
      "location": "gld2_gef",
      "quantity": 80,
      "monsterName": "Dark Shadow"
    }
  ],
  2255: [
    {
      "location": "gld2_gef",
      "quantity": 1,
      "monsterName": "Dark Guardian Kades"
    }
  ],
  2256: [
    {
      "location": "gld2_gef",
      "quantity": 1,
      "monsterName": "Rudo"
    }
  ],
  2288: [
    {
      "location": "gld2_pay",
      "quantity": 5,
      "monsterName": "Treasure Chest"
    },
    {
      "location": "gld2_ald",
      "quantity": 5,
      "monsterName": "Treasure Chest"
    },
    {
      "location": "gld2_prt",
      "quantity": 5,
      "monsterName": "Treasure Chest"
    },
    {
      "location": "gld2_gef",
      "quantity": 5,
      "monsterName": "Treasure Chest"
    }
  ],
  1408: [
    {
      "location": "gon_dun01",
      "quantity": 60,
      "monsterName": "Bloody Butterfly"
    },
    {
      "location": "gon_dun02",
      "quantity": 26,
      "monsterName": "Bloody Butterfly"
    }
  ],
  1410: [
    {
      "location": "gon_dun01",
      "quantity": 38,
      "monsterName": "Enchanted Peach Tree"
    },
    {
      "location": "gon_dun02",
      "quantity": 27,
      "monsterName": "Enchanted Peach Tree"
    }
  ],
  1417: [
    {
      "location": "gon_dun01",
      "quantity": 33,
      "monsterName": "Zipper Bear"
    }
  ],
  1412: [
    {
      "location": "gon_dun02",
      "quantity": 26,
      "monsterName": "Taoist Hermit"
    },
    {
      "location": "gon_dun03",
      "quantity": 40,
      "monsterName": "Taoist Hermit"
    }
  ],
  1415: [
    {
      "location": "gon_dun02",
      "quantity": 7,
      "monsterName": "Baby Leopard"
    },
    {
      "location": "gon_fild01",
      "quantity": 51,
      "monsterName": "Baby Leopard"
    }
  ],
  1416: [
    {
      "location": "gon_dun03",
      "quantity": 67,
      "monsterName": "Evil Nymph"
    }
  ],
  1413: [
    {
      "location": "gon_dun03",
      "quantity": 26,
      "monsterName": "Hermit Plant"
    }
  ],
  1418: [
    {
      "location": "gon_dun03",
      "quantity": 1,
      "monsterName": "Evil Snake Lord"
    }
  ],
  1776: [
    {
      "location": "ice_dun01",
      "quantity": 76,
      "monsterName": "Siroma"
    },
    {
      "location": "ice_dun02",
      "quantity": 30,
      "monsterName": "Siroma"
    }
  ],
  1782: [
    {
      "location": "ice_dun01",
      "quantity": 5,
      "monsterName": "Roween"
    },
    {
      "location": "ra_fild01",
      "quantity": 33,
      "monsterName": "Roween"
    },
    {
      "location": "ra_fild03",
      "quantity": 35,
      "monsterName": "Roween"
    },
    {
      "location": "ra_fild04",
      "quantity": 35,
      "monsterName": "Roween"
    },
    {
      "location": "ra_fild08",
      "quantity": 79,
      "monsterName": "Roween"
    },
    {
      "location": "ra_fild12",
      "quantity": 216,
      "monsterName": "Roween"
    }
  ],
  1780: [
    {
      "location": "ice_dun01",
      "quantity": 5,
      "monsterName": "Muscipular"
    },
    {
      "location": "ve_fild01",
      "quantity": 34,
      "monsterName": "Muscipular"
    },
    {
      "location": "ve_fild02",
      "quantity": 27,
      "monsterName": "Muscipular"
    },
    {
      "location": "ve_fild03",
      "quantity": 38,
      "monsterName": "Muscipular"
    },
    {
      "location": "ve_fild04",
      "quantity": 110,
      "monsterName": "Muscipular"
    },
    {
      "location": "ve_fild07",
      "quantity": 38,
      "monsterName": "Muscipular"
    }
  ],
  1778: [
    {
      "location": "ice_dun01",
      "quantity": 2,
      "monsterName": "Gazeti"
    },
    {
      "location": "ice_dun02",
      "quantity": 15,
      "monsterName": "Gazeti"
    },
    {
      "location": "ice_dun03",
      "quantity": 42,
      "monsterName": "Gazeti"
    }
  ],
  1775: [
    {
      "location": "ice_dun02",
      "quantity": 70,
      "monsterName": "Snowier"
    },
    {
      "location": "ice_dun03",
      "quantity": 15,
      "monsterName": "Snowier"
    }
  ],
  1789: [
    {
      "location": "ice_dun02",
      "quantity": 19,
      "monsterName": "Iceicle"
    },
    {
      "location": "ice_dun03",
      "quantity": 32,
      "monsterName": "Iceicle"
    }
  ],
  1777: [
    {
      "location": "ice_dun02",
      "quantity": 7,
      "monsterName": "Ice Titan"
    },
    {
      "location": "ice_dun03",
      "quantity": 70,
      "monsterName": "Ice Titan"
    }
  ],
  1164: [
    {
      "location": "in_sphinx1",
      "quantity": 38,
      "monsterName": "Requiem"
    },
    {
      "location": "in_sphinx2",
      "quantity": 80,
      "monsterName": "Requiem"
    }
  ],
  1178: [
    {
      "location": "in_sphinx1",
      "quantity": 38,
      "monsterName": "Zerom"
    },
    {
      "location": "in_sphinx2",
      "quantity": 80,
      "monsterName": "Zerom"
    }
  ],
  1146: [
    {
      "location": "in_sphinx1",
      "quantity": 19,
      "monsterName": "Matyr"
    },
    {
      "location": "in_sphinx2",
      "quantity": 32,
      "monsterName": "Matyr"
    },
    {
      "location": "in_sphinx3",
      "quantity": 18,
      "monsterName": "Matyr"
    },
    {
      "location": "in_sphinx5",
      "quantity": 11,
      "monsterName": "Matyr"
    },
    {
      "location": "moc_pryd03",
      "quantity": 10,
      "monsterName": "Matyr"
    },
    {
      "location": "moc_pryd04",
      "quantity": 24,
      "monsterName": "Matyr"
    }
  ],
  1140: [
    {
      "location": "in_sphinx3",
      "quantity": 82,
      "monsterName": "Marduk"
    }
  ],
  1154: [
    {
      "location": "in_sphinx3",
      "quantity": 6,
      "monsterName": "Pasana"
    },
    {
      "location": "in_sphinx4",
      "quantity": 30,
      "monsterName": "Pasana"
    },
    {
      "location": "in_sphinx5",
      "quantity": 79,
      "monsterName": "Pasana"
    }
  ],
  1149: [
    {
      "location": "in_sphinx4",
      "quantity": 77,
      "monsterName": "Minorous"
    },
    {
      "location": "moc_pryd05",
      "quantity": 78,
      "monsterName": "Minorous"
    }
  ],
  1098: [
    {
      "location": "in_sphinx4",
      "quantity": 23,
      "monsterName": "Anubis"
    },
    {
      "location": "in_sphinx5",
      "quantity": 11,
      "monsterName": "Anubis"
    }
  ],
  1037: [
    {
      "location": "in_sphinx5",
      "quantity": 22,
      "monsterName": "Side Winder"
    },
    {
      "location": "lou_dun01",
      "quantity": 11,
      "monsterName": "Side Winder"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Side Winder"
    },
    {
      "location": "prt_maze03",
      "quantity": 20,
      "monsterName": "Side Winder"
    },
    {
      "location": "prt_maze03",
      "quantity": 10,
      "monsterName": "Side Winder"
    },
    {
      "location": "gef_fild06",
      "quantity": 36,
      "monsterName": "Side Winder"
    },
    {
      "location": "gon_fild01",
      "quantity": 12,
      "monsterName": "Side Winder"
    },
    {
      "location": "mjolnir_03",
      "quantity": 140,
      "monsterName": "Side Winder"
    },
    {
      "location": "mjolnir_04",
      "quantity": 43,
      "monsterName": "Side Winder"
    },
    {
      "location": "mosk_fild02",
      "quantity": 56,
      "monsterName": "Side Winder"
    }
  ],
  1157: [
    {
      "location": "in_sphinx5",
      "quantity": 1,
      "monsterName": "Pharaoh"
    }
  ],
  1066: [
    {
      "location": "iz_dun00",
      "quantity": 20,
      "monsterName": "Vadon"
    },
    {
      "location": "iz_dun01",
      "quantity": 60,
      "monsterName": "Vadon"
    }
  ],
  1067: [
    {
      "location": "iz_dun01",
      "quantity": 15,
      "monsterName": "Cornutus"
    },
    {
      "location": "iz_dun02",
      "quantity": 60,
      "monsterName": "Cornutus"
    }
  ],
  1144: [
    {
      "location": "iz_dun02",
      "quantity": 40,
      "monsterName": "Marse"
    }
  ],
  1044: [
    {
      "location": "iz_dun02",
      "quantity": 40,
      "monsterName": "Obeaune"
    }
  ],
  1158: [
    {
      "location": "iz_dun03",
      "quantity": 45,
      "monsterName": "Phen"
    }
  ],
  1045: [
    {
      "location": "iz_dun03",
      "quantity": 40,
      "monsterName": "Marc"
    }
  ],
  1069: [
    {
      "location": "iz_dun03",
      "quantity": 40,
      "monsterName": "Swordfish"
    },
    {
      "location": "iz_dun04",
      "quantity": 11,
      "monsterName": "Swordfish"
    }
  ],
  1142: [
    {
      "location": "iz_dun03",
      "quantity": 20,
      "monsterName": "Marine Sphere"
    },
    {
      "location": "iz_dun04",
      "quantity": 11,
      "monsterName": "Marine Sphere"
    }
  ],
  1065: [
    {
      "location": "iz_dun04",
      "quantity": 58,
      "monsterName": "Strouf"
    }
  ],
  1108: [
    {
      "location": "iz_dun04",
      "quantity": 3,
      "monsterName": "Deviace"
    }
  ],
  2201: [
    {
      "location": "iz_dun05",
      "quantity": 50,
      "monsterName": "Sropho"
    }
  ],
  2204: [
    {
      "location": "iz_dun05",
      "quantity": 60,
      "monsterName": "Sedora"
    }
  ],
  2203: [
    {
      "location": "iz_dun05",
      "quantity": 30,
      "monsterName": "Pot Dofle"
    }
  ],
  2198: [
    {
      "location": "iz_dun05",
      "quantity": 25,
      "monsterName": "King Dramoh"
    }
  ],
  2202: [
    {
      "location": "iz_dun05",
      "quantity": 1,
      "monsterName": "Kraken"
    }
  ],
  20801: [
    {
      "location": "iz_d04_i",
      "quantity": 45,
      "monsterName": "Deep Sea Sropho"
    }
  ],
  20802: [
    {
      "location": "iz_d04_i",
      "quantity": 45,
      "monsterName": "Deep Sea Obeaune"
    }
  ],
  20805: [
    {
      "location": "iz_d04_i",
      "quantity": 45,
      "monsterName": "Deep Sea Merman"
    }
  ],
  20804: [
    {
      "location": "iz_d04_i",
      "quantity": 45,
      "monsterName": "Deep Sea Marse"
    }
  ],
  20803: [
    {
      "location": "iz_d04_i",
      "quantity": 45,
      "monsterName": "Deep Sea Deviace"
    }
  ],
  20808: [
    {
      "location": "iz_d05_i",
      "quantity": 45,
      "monsterName": "Deep Sea Strouf"
    }
  ],
  20807: [
    {
      "location": "iz_d05_i",
      "quantity": 45,
      "monsterName": "Deep Sea Swordfish"
    }
  ],
  20809: [
    {
      "location": "iz_d05_i",
      "quantity": 45,
      "monsterName": "Deep Sea Phen"
    }
  ],
  20806: [
    {
      "location": "iz_d05_i",
      "quantity": 45,
      "monsterName": "Deep Sea Sedora"
    }
  ],
  20810: [
    {
      "location": "iz_d05_i",
      "quantity": 45,
      "monsterName": "Deep Sea King Dramoh"
    }
  ],
  1676: [
    {
      "location": "juperos_01",
      "quantity": 70,
      "monsterName": "Venatu"
    },
    {
      "location": "juperos_02",
      "quantity": 65,
      "monsterName": "Venatu"
    },
    {
      "location": "jupe_core",
      "quantity": 25,
      "monsterName": "Venatu"
    }
  ],
  1677: [
    {
      "location": "juperos_01",
      "quantity": 70,
      "monsterName": "Venatu"
    },
    {
      "location": "juperos_02",
      "quantity": 65,
      "monsterName": "Venatu"
    },
    {
      "location": "jupe_core",
      "quantity": 25,
      "monsterName": "Venatu"
    }
  ],
  1678: [
    {
      "location": "juperos_01",
      "quantity": 70,
      "monsterName": "Venatu"
    },
    {
      "location": "juperos_02",
      "quantity": 65,
      "monsterName": "Venatu"
    },
    {
      "location": "jupe_core",
      "quantity": 25,
      "monsterName": "Venatu"
    }
  ],
  1679: [
    {
      "location": "juperos_01",
      "quantity": 50,
      "monsterName": "Venatu"
    },
    {
      "location": "juperos_02",
      "quantity": 50,
      "monsterName": "Venatu"
    }
  ],
  1670: [
    {
      "location": "juperos_01",
      "quantity": 10,
      "monsterName": "Dimik"
    },
    {
      "location": "jupe_core",
      "quantity": 40,
      "monsterName": "Dimik"
    }
  ],
  1671: [
    {
      "location": "juperos_01",
      "quantity": 5,
      "monsterName": "Dimik"
    },
    {
      "location": "jupe_core",
      "quantity": 40,
      "monsterName": "Dimik"
    }
  ],
  1672: [
    {
      "location": "juperos_01",
      "quantity": 5,
      "monsterName": "Dimik"
    },
    {
      "location": "jupe_core",
      "quantity": 40,
      "monsterName": "Dimik"
    }
  ],
  1673: [
    {
      "location": "juperos_01",
      "quantity": 5,
      "monsterName": "Dimik"
    },
    {
      "location": "jupe_core",
      "quantity": 40,
      "monsterName": "Dimik"
    }
  ],
  1365: [
    {
      "location": "juperos_02",
      "quantity": 70,
      "monsterName": "Apocalypse"
    }
  ],
  1668: [
    {
      "location": "jupe_core",
      "quantity": 40,
      "monsterName": "Archdam"
    }
  ],
  1685: [
    {
      "location": "jupe_core",
      "quantity": 1,
      "monsterName": "Vesper"
    }
  ],
  1737: [
    {
      "location": "kh_dun01",
      "quantity": 55,
      "monsterName": "Aliza"
    },
    {
      "location": "kh_dun02",
      "quantity": 13,
      "monsterName": "Aliza"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliza"
    }
  ],
  1738: [
    {
      "location": "kh_dun01",
      "quantity": 9,
      "monsterName": "Constant"
    },
    {
      "location": "kh_dun02",
      "quantity": 20,
      "monsterName": "Constant"
    }
  ],
  1745: [
    {
      "location": "kh_dun01",
      "quantity": 6,
      "monsterName": "Constant"
    },
    {
      "location": "kh_dun02",
      "quantity": 6,
      "monsterName": "Constant"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 10,
      "monsterName": "Constant"
    }
  ],
  1735: [
    {
      "location": "kh_dun01",
      "quantity": 3,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_dun02",
      "quantity": 41,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    }
  ],
  1736: [
    {
      "location": "kh_dun01",
      "quantity": 3,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_dun02",
      "quantity": 34,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    }
  ],
  1734: [
    {
      "location": "kh_dun02",
      "quantity": 1,
      "monsterName": "Kiel D-01"
    }
  ],
  1740: [
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliot"
    }
  ],
  1739: [
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Alicel"
    }
  ],
  1746: [
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliza"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliza"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliza"
    },
    {
      "location": "kh_kiehl01",
      "quantity": 1,
      "monsterName": "Aliza"
    }
  ],
  1682: [
    {
      "location": "lhz_dun01",
      "quantity": 101,
      "monsterName": "Remover"
    },
    {
      "location": "lhz_dun02",
      "quantity": 20,
      "monsterName": "Remover"
    }
  ],
  1627: [
    {
      "location": "lhz_dun01",
      "quantity": 70,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild01",
      "quantity": 11,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild03",
      "quantity": 23,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild04",
      "quantity": 23,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild05",
      "quantity": 11,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild06",
      "quantity": 12,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild08",
      "quantity": 15,
      "monsterName": "Anopheles"
    },
    {
      "location": "ra_fild12",
      "quantity": 49,
      "monsterName": "Anopheles"
    }
  ],
  1613: [
    {
      "location": "lhz_dun01",
      "quantity": 50,
      "monsterName": "Metaling"
    },
    {
      "location": "ein_fild06",
      "quantity": 30,
      "monsterName": "Metaling"
    },
    {
      "location": "ein_fild07",
      "quantity": 109,
      "monsterName": "Metaling"
    },
    {
      "location": "ein_fild08",
      "quantity": 139,
      "monsterName": "Metaling"
    },
    {
      "location": "ein_fild09",
      "quantity": 41,
      "monsterName": "Metaling"
    },
    {
      "location": "lhz_fild01",
      "quantity": 45,
      "monsterName": "Metaling"
    },
    {
      "location": "lhz_fild02",
      "quantity": 20,
      "monsterName": "Metaling"
    },
    {
      "location": "lhz_fild03",
      "quantity": 20,
      "monsterName": "Metaling"
    }
  ],
  1656: [
    {
      "location": "lhz_dun01",
      "quantity": 13,
      "monsterName": "Kavach Icarus"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Kavach Icarus"
    }
  ],
  1655: [
    {
      "location": "lhz_dun01",
      "quantity": 13,
      "monsterName": "Errende Ebecee"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Errende Ebecee"
    }
  ],
  1657: [
    {
      "location": "lhz_dun01",
      "quantity": 11,
      "monsterName": "Laurell Weinder"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Laurell Weinder"
    }
  ],
  1653: [
    {
      "location": "lhz_dun01",
      "quantity": 11,
      "monsterName": "Wickebine Tres"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Wickebine Tres"
    }
  ],
  1654: [
    {
      "location": "lhz_dun01",
      "quantity": 8,
      "monsterName": "Armeyer Dinze"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Armeyer Dinze"
    }
  ],
  1652: [
    {
      "location": "lhz_dun01",
      "quantity": 8,
      "monsterName": "Egnigem Cenia"
    },
    {
      "location": "lhz_dun02",
      "quantity": 50,
      "monsterName": "Egnigem Cenia"
    }
  ],
  1681: [
    {
      "location": "lhz_dun01",
      "quantity": 1,
      "monsterName": "Gemini-S58"
    },
    {
      "location": "lhz_dun02",
      "quantity": 10,
      "monsterName": "Gemini-S58"
    }
  ],
  1635: [
    {
      "location": "lhz_dun02",
      "quantity": 1,
      "monsterName": "Eremes Guile"
    },
    {
      "location": "lhz_dun03",
      "quantity": 42,
      "monsterName": "Eremes Guile"
    }
  ],
  1658: [
    {
      "location": "lhz_dun02",
      "quantity": 1,
      "monsterName": "Egnigem Cenia"
    }
  ],
  1638: [
    {
      "location": "lhz_dun03",
      "quantity": 81,
      "monsterName": "Cecil Damon"
    }
  ],
  1639: [
    {
      "location": "lhz_dun03",
      "quantity": 57,
      "monsterName": "Kathryne Keyron"
    }
  ],
  1637: [
    {
      "location": "lhz_dun03",
      "quantity": 42,
      "monsterName": "Margaretha Sorin"
    }
  ],
  1636: [
    {
      "location": "lhz_dun03",
      "quantity": 42,
      "monsterName": "Howard Alt-Eisen"
    }
  ],
  1634: [
    {
      "location": "lhz_dun03",
      "quantity": 42,
      "monsterName": "Seyren Windsor"
    }
  ],
  1641: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "Assassin Cross Eremes"
    }
  ],
  1645: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "High Wizard Kathryne"
    }
  ],
  1640: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "Lord Knight Seyren"
    }
  ],
  1644: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "Sniper Cecil"
    }
  ],
  1642: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "Whitesmith Howard"
    }
  ],
  1643: [
    {
      "location": "lhz_dun03",
      "quantity": 1,
      "monsterName": "High Priest Margaretha"
    }
  ],
  2221: [
    {
      "location": "lhz_dun04",
      "quantity": 42,
      "monsterName": "Randel"
    }
  ],
  2222: [
    {
      "location": "lhz_dun04",
      "quantity": 42,
      "monsterName": "Flamel"
    }
  ],
  2223: [
    {
      "location": "lhz_dun04",
      "quantity": 81,
      "monsterName": "Celia"
    }
  ],
  2224: [
    {
      "location": "lhz_dun04",
      "quantity": 42,
      "monsterName": "Chen"
    }
  ],
  2225: [
    {
      "location": "lhz_dun04",
      "quantity": 57,
      "monsterName": "Gertie"
    }
  ],
  2226: [
    {
      "location": "lhz_dun04",
      "quantity": 42,
      "monsterName": "Alphoccio"
    }
  ],
  2227: [
    {
      "location": "lhz_dun04",
      "quantity": 42,
      "monsterName": "Trentini"
    }
  ],
  2228: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Paladin Randel"
    }
  ],
  2229: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Creator Flamel"
    }
  ],
  2230: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Professor Celia"
    }
  ],
  2231: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Champion Chen"
    }
  ],
  2232: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Stalker Gertie"
    }
  ],
  2233: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Clown Alphoccio"
    }
  ],
  2234: [
    {
      "location": "lhz_dun04",
      "quantity": 1,
      "monsterName": "Gypsy Trentini"
    }
  ],
  3208: [
    {
      "location": "lhz_dun_n",
      "quantity": 20,
      "monsterName": "Eremes Guille"
    }
  ],
  3209: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Magaleta Sorin"
    }
  ],
  3210: [
    {
      "location": "lhz_dun_n",
      "quantity": 15,
      "monsterName": "Catherine Cheiron"
    }
  ],
  3211: [
    {
      "location": "lhz_dun_n",
      "quantity": 20,
      "monsterName": "Shecil Damon"
    }
  ],
  3212: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Harword Alt-Eisen"
    }
  ],
  3213: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Seyren Windsor"
    }
  ],
  3226: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Randel Lawrence"
    }
  ],
  3227: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Flamel Emule"
    }
  ],
  3228: [
    {
      "location": "lhz_dun_n",
      "quantity": 15,
      "monsterName": "Celia Alde"
    }
  ],
  3229: [
    {
      "location": "lhz_dun_n",
      "quantity": 15,
      "monsterName": "Chen Liu"
    }
  ],
  3230: [
    {
      "location": "lhz_dun_n",
      "quantity": 15,
      "monsterName": "Gertie Wie"
    }
  ],
  3231: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Alphoccio Basil"
    }
  ],
  3232: [
    {
      "location": "lhz_dun_n",
      "quantity": 10,
      "monsterName": "Trentini"
    }
  ],
  1517: [
    {
      "location": "lou_dun01",
      "quantity": 52,
      "monsterName": "Jing Guai"
    }
  ],
  1381: [
    {
      "location": "lou_dun01",
      "quantity": 17,
      "monsterName": "Grizzly"
    },
    {
      "location": "mag_dun01",
      "quantity": 10,
      "monsterName": "Grizzly"
    }
  ],
  1516: [
    {
      "location": "lou_dun01",
      "quantity": 17,
      "monsterName": "Mi Gao"
    },
    {
      "location": "lou_fild01",
      "quantity": 60,
      "monsterName": "Mi Gao"
    }
  ],
  1512: [
    {
      "location": "lou_dun02",
      "quantity": 56,
      "monsterName": "Yao Jun"
    },
    {
      "location": "lou_dun03",
      "quantity": 30,
      "monsterName": "Yao Jun"
    }
  ],
  1026: [
    {
      "location": "lou_dun02",
      "quantity": 35,
      "monsterName": "Munak"
    },
    {
      "location": "pay_dun02",
      "quantity": 40,
      "monsterName": "Munak"
    },
    {
      "location": "pay_dun03",
      "quantity": 3,
      "monsterName": "Munak"
    }
  ],
  1514: [
    {
      "location": "lou_dun02",
      "quantity": 7,
      "monsterName": "Zhu Po Long"
    },
    {
      "location": "lou_dun03",
      "quantity": 30,
      "monsterName": "Zhu Po Long"
    }
  ],
  1513: [
    {
      "location": "lou_dun03",
      "quantity": 18,
      "monsterName": "Mao Guai"
    }
  ],
  1631: [
    {
      "location": "lou_dun03",
      "quantity": 6,
      "monsterName": "Green Maiden"
    },
    {
      "location": "lou_dun03",
      "quantity": 5,
      "monsterName": "Green Maiden"
    }
  ],
  1630: [
    {
      "location": "lou_dun03",
      "quantity": 1,
      "monsterName": "White Lady"
    }
  ],
  1383: [
    {
      "location": "mag_dun01",
      "quantity": 30,
      "monsterName": "Explosion"
    }
  ],
  1366: [
    {
      "location": "mag_dun01",
      "quantity": 20,
      "monsterName": "Lava Golem"
    }
  ],
  1367: [
    {
      "location": "mag_dun01",
      "quantity": 20,
      "monsterName": "Blazer"
    },
    {
      "location": "mag_dun02",
      "quantity": 20,
      "monsterName": "Blazer"
    }
  ],
  1072: [
    {
      "location": "mag_dun01",
      "quantity": 20,
      "monsterName": "Kaho"
    },
    {
      "location": "thor_v02",
      "quantity": 10,
      "monsterName": "Kaho"
    }
  ],
  1379: [
    {
      "location": "mag_dun02",
      "quantity": 46,
      "monsterName": "Nightmare Terror"
    }
  ],
  1385: [
    {
      "location": "mag_dun02",
      "quantity": 40,
      "monsterName": "Deleter"
    }
  ],
  1384: [
    {
      "location": "mag_dun02",
      "quantity": 38,
      "monsterName": "Deleter"
    }
  ],
  1382: [
    {
      "location": "mag_dun02",
      "quantity": 15,
      "monsterName": "Diabolic"
    }
  ],
  1387: [
    {
      "location": "mag_dun02",
      "quantity": 10,
      "monsterName": "Gig"
    }
  ],
  20419: [
    {
      "location": "mag_dun03",
      "quantity": 1,
      "monsterName": "Rigid Muspellskoll"
    }
  ],
  1073: [
    {
      "location": "mal_dun01",
      "quantity": 10,
      "monsterName": "Crab"
    },
    {
      "location": "cmd_fild02",
      "quantity": 27,
      "monsterName": "Crab"
    },
    {
      "location": "cmd_fild04",
      "quantity": 24,
      "monsterName": "Crab"
    },
    {
      "location": "cmd_fild07",
      "quantity": 34,
      "monsterName": "Crab"
    },
    {
      "location": "hu_fild06",
      "quantity": 35,
      "monsterName": "Crab"
    }
  ],
  1074: [
    {
      "location": "mal_dun01",
      "quantity": 10,
      "monsterName": "Shellfish"
    },
    {
      "location": "cmd_fild02",
      "quantity": 27,
      "monsterName": "Shellfish"
    },
    {
      "location": "cmd_fild04",
      "quantity": 24,
      "monsterName": "Shellfish"
    },
    {
      "location": "cmd_fild07",
      "quantity": 34,
      "monsterName": "Shellfish"
    },
    {
      "location": "hu_fild06",
      "quantity": 87,
      "monsterName": "Shellfish"
    }
  ],
  1266: [
    {
      "location": "mal_dun01",
      "quantity": 20,
      "monsterName": "Aster"
    },
    {
      "location": "cmd_fild02",
      "quantity": 13,
      "monsterName": "Aster"
    },
    {
      "location": "cmd_fild04",
      "quantity": 12,
      "monsterName": "Aster"
    },
    {
      "location": "cmd_fild07",
      "quantity": 34,
      "monsterName": "Aster"
    },
    {
      "location": "hu_fild06",
      "quantity": 35,
      "monsterName": "Aster"
    }
  ],
  2197: [
    {
      "location": "mal_dun01",
      "quantity": 60,
      "monsterName": "Red Eruma"
    }
  ],
  2199: [
    {
      "location": "mal_dun01",
      "quantity": 45,
      "monsterName": "Siorava"
    }
  ],
  2208: [
    {
      "location": "mal_dun01",
      "quantity": 1,
      "monsterName": "Wild Rider"
    }
  ],
  1894: [
    {
      "location": "mal_dun01",
      "quantity": 30,
      "monsterName": "Pouring"
    }
  ],
  2311: [
    {
      "location": "ma_dun01",
      "quantity": 40,
      "monsterName": "Manananggal"
    }
  ],
  2315: [
    {
      "location": "ma_dun01",
      "quantity": 30,
      "monsterName": "Wakwak"
    },
    {
      "location": "ma_fild02",
      "quantity": 34,
      "monsterName": "Wakwak"
    }
  ],
  2314: [
    {
      "location": "ma_dun01",
      "quantity": 40,
      "monsterName": "Tiyanak"
    },
    {
      "location": "ma_fild01",
      "quantity": 67,
      "monsterName": "Tiyanak"
    }
  ],
  1175: [
    {
      "location": "mjo_dun01",
      "quantity": 63,
      "monsterName": "Tarou"
    },
    {
      "location": "prt_sewb1",
      "quantity": 13,
      "monsterName": "Tarou"
    },
    {
      "location": "prt_sewb2",
      "quantity": 60,
      "monsterName": "Tarou"
    },
    {
      "location": "prt_sewb3",
      "quantity": 15,
      "monsterName": "Tarou"
    }
  ],
  1145: [
    {
      "location": "mjo_dun01",
      "quantity": 21,
      "monsterName": "Martin"
    },
    {
      "location": "mjo_dun02",
      "quantity": 71,
      "monsterName": "Martin"
    },
    {
      "location": "mjo_dun03",
      "quantity": 5,
      "monsterName": "Martin"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Martin"
    }
  ],
  1169: [
    {
      "location": "mjo_dun02",
      "quantity": 23,
      "monsterName": "Skeleton Worker"
    },
    {
      "location": "mjo_dun03",
      "quantity": 78,
      "monsterName": "Skeleton Worker"
    }
  ],
  1151: [
    {
      "location": "mjo_dun03",
      "quantity": 39,
      "monsterName": "Myst"
    }
  ],
  1041: [
    {
      "location": "moc_pryd02",
      "quantity": 31,
      "monsterName": "Mummy"
    },
    {
      "location": "moc_pryd03",
      "quantity": 70,
      "monsterName": "Mummy"
    },
    {
      "location": "moc_pryd04",
      "quantity": 31,
      "monsterName": "Mummy"
    },
    {
      "location": "moc_pryd05",
      "quantity": 13,
      "monsterName": "Mummy"
    }
  ],
  1028: [
    {
      "location": "moc_pryd02",
      "quantity": 31,
      "monsterName": "Soldier Skeleton"
    },
    {
      "location": "pay_dun01",
      "quantity": 53,
      "monsterName": "Soldier Skeleton"
    },
    {
      "location": "pay_dun02",
      "quantity": 45,
      "monsterName": "Soldier Skeleton"
    }
  ],
  1016: [
    {
      "location": "moc_pryd02",
      "quantity": 31,
      "monsterName": "Archer Skeleton"
    },
    {
      "location": "pay_dun01",
      "quantity": 32,
      "monsterName": "Archer Skeleton"
    },
    {
      "location": "pay_dun02",
      "quantity": 20,
      "monsterName": "Archer Skeleton"
    },
    {
      "location": "pay_dun04",
      "quantity": 15,
      "monsterName": "Archer Skeleton"
    }
  ],
  1029: [
    {
      "location": "moc_pryd02",
      "quantity": 5,
      "monsterName": "Isis"
    },
    {
      "location": "moc_pryd04",
      "quantity": 62,
      "monsterName": "Isis"
    }
  ],
  1032: [
    {
      "location": "moc_pryd03",
      "quantity": 20,
      "monsterName": "Verit"
    },
    {
      "location": "moc_pryd05",
      "quantity": 65,
      "monsterName": "Verit"
    },
    {
      "location": "moc_pryd06",
      "quantity": 35,
      "monsterName": "Verit"
    }
  ],
  1297: [
    {
      "location": "moc_pryd04",
      "quantity": 3,
      "monsterName": "Ancient Mummy"
    },
    {
      "location": "moc_pryd06",
      "quantity": 23,
      "monsterName": "Ancient Mummy"
    }
  ],
  1038: [
    {
      "location": "moc_pryd04",
      "quantity": 1,
      "monsterName": "Osiris"
    }
  ],
  1511: [
    {
      "location": "moc_pryd06",
      "quantity": 1,
      "monsterName": "Amon Ra"
    }
  ],
  2353: [
    {
      "location": "moc_prydn1",
      "quantity": 78,
      "monsterName": "Nightmare Minorous"
    }
  ],
  2354: [
    {
      "location": "moc_prydn1",
      "quantity": 13,
      "monsterName": "Nightmare Mummy"
    }
  ],
  2355: [
    {
      "location": "moc_prydn1",
      "quantity": 65,
      "monsterName": "Nightmare Verit"
    },
    {
      "location": "moc_prydn2",
      "quantity": 35,
      "monsterName": "Nightmare Verit"
    }
  ],
  2356: [
    {
      "location": "moc_prydn2",
      "quantity": 35,
      "monsterName": "Nightmare Mimic"
    }
  ],
  2358: [
    {
      "location": "moc_prydn2",
      "quantity": 23,
      "monsterName": "Nightmare Arclouze"
    }
  ],
  2360: [
    {
      "location": "moc_prydn2",
      "quantity": 23,
      "monsterName": "Nightmare Ancient Mummy"
    }
  ],
  2362: [
    {
      "location": "moc_prydn2",
      "quantity": 1,
      "monsterName": "Nightmare Amon Ra"
    }
  ],
  1880: [
    {
      "location": "mosk_dun01",
      "quantity": 74,
      "monsterName": "Wood Goblin"
    },
    {
      "location": "mosk_dun02",
      "quantity": 35,
      "monsterName": "Wood Goblin"
    }
  ],
  1881: [
    {
      "location": "mosk_dun01",
      "quantity": 37,
      "monsterName": "Les"
    },
    {
      "location": "mosk_dun02",
      "quantity": 47,
      "monsterName": "Les"
    }
  ],
  1139: [
    {
      "location": "mosk_dun01",
      "quantity": 11,
      "monsterName": "Mantis"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Mantis"
    },
    {
      "location": "prt_maze03",
      "quantity": 30,
      "monsterName": "Mantis"
    },
    {
      "location": "gef_fild06",
      "quantity": 36,
      "monsterName": "Mantis"
    },
    {
      "location": "gef_fild08",
      "quantity": 37,
      "monsterName": "Mantis"
    },
    {
      "location": "lou_fild01",
      "quantity": 28,
      "monsterName": "Mantis"
    },
    {
      "location": "mjolnir_03",
      "quantity": 37,
      "monsterName": "Mantis"
    },
    {
      "location": "mjolnir_04",
      "quantity": 43,
      "monsterName": "Mantis"
    },
    {
      "location": "mjolnir_05",
      "quantity": 44,
      "monsterName": "Mantis"
    },
    {
      "location": "mjolnir_12",
      "quantity": 43,
      "monsterName": "Mantis"
    },
    {
      "location": "mosk_fild02",
      "quantity": 14,
      "monsterName": "Mantis"
    },
    {
      "location": "yuno_fild01",
      "quantity": 52,
      "monsterName": "Mantis"
    },
    {
      "location": "yuno_fild12",
      "quantity": 34,
      "monsterName": "Mantis"
    }
  ],
  1882: [
    {
      "location": "mosk_dun02",
      "quantity": 23,
      "monsterName": "Baba Yaga"
    },
    {
      "location": "mosk_dun03",
      "quantity": 68,
      "monsterName": "Baba Yaga"
    }
  ],
  1883: [
    {
      "location": "mosk_dun02",
      "quantity": 5,
      "monsterName": "Uzhas"
    },
    {
      "location": "mosk_dun03",
      "quantity": 39,
      "monsterName": "Uzhas"
    }
  ],
  1884: [
    {
      "location": "mosk_dun03",
      "quantity": 17,
      "monsterName": "Mavka"
    }
  ],
  1885: [
    {
      "location": "mosk_dun03",
      "quantity": 1,
      "monsterName": "Gopinich"
    }
  ],
  2013: [
    {
      "location": "nyd_dun01",
      "quantity": 40,
      "monsterName": "Draco"
    }
  ],
  2016: [
    {
      "location": "nyd_dun01",
      "quantity": 20,
      "monsterName": "Aqua Elemental"
    }
  ],
  2015: [
    {
      "location": "nyd_dun01",
      "quantity": 10,
      "monsterName": "Dark Pinguicula"
    },
    {
      "location": "spl_fild01",
      "quantity": 98,
      "monsterName": "Dark Pinguicula"
    }
  ],
  2017: [
    {
      "location": "nyd_dun01",
      "quantity": 2,
      "monsterName": "Rata"
    }
  ],
  2018: [
    {
      "location": "nyd_dun01",
      "quantity": 2,
      "monsterName": "Duneyrr"
    }
  ],
  2014: [
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    },
    {
      "location": "nyd_dun01",
      "quantity": 1,
      "monsterName": "Draco Egg"
    }
  ],
  1693: [
    {
      "location": "odin_tem01",
      "quantity": 14,
      "monsterName": "Plasma"
    },
    {
      "location": "odin_tem02",
      "quantity": 20,
      "monsterName": "Plasma"
    },
    {
      "location": "odin_tem03",
      "quantity": 24,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t12",
      "quantity": 5,
      "monsterName": "Plasma"
    }
  ],
  1692: [
    {
      "location": "odin_tem01",
      "quantity": 14,
      "monsterName": "Breeze"
    },
    {
      "location": "lhz_fild02",
      "quantity": 40,
      "monsterName": "Breeze"
    },
    {
      "location": "lhz_fild03",
      "quantity": 130,
      "monsterName": "Breeze"
    }
  ],
  1753: [
    {
      "location": "odin_tem01",
      "quantity": 7,
      "monsterName": "Frus"
    },
    {
      "location": "odin_tem02",
      "quantity": 40,
      "monsterName": "Frus"
    },
    {
      "location": "odin_tem03",
      "quantity": 4,
      "monsterName": "Frus"
    }
  ],
  1752: [
    {
      "location": "odin_tem01",
      "quantity": 7,
      "monsterName": "Skogul"
    },
    {
      "location": "odin_tem02",
      "quantity": 40,
      "monsterName": "Skogul"
    },
    {
      "location": "odin_tem03",
      "quantity": 4,
      "monsterName": "Skogul"
    }
  ],
  1697: [
    {
      "location": "odin_tem01",
      "quantity": 4,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t02",
      "quantity": 20,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t05",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t06",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t10",
      "quantity": 5,
      "monsterName": "Plasma"
    }
  ],
  1695: [
    {
      "location": "odin_tem01",
      "quantity": 4,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t01",
      "quantity": 20,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t05",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t06",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t11",
      "quantity": 5,
      "monsterName": "Plasma"
    }
  ],
  1696: [
    {
      "location": "odin_tem01",
      "quantity": 4,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t03",
      "quantity": 20,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t05",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t06",
      "quantity": 10,
      "monsterName": "Plasma"
    }
  ],
  1694: [
    {
      "location": "odin_tem01",
      "quantity": 4,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t05",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t06",
      "quantity": 10,
      "monsterName": "Plasma"
    },
    {
      "location": "tha_t09",
      "quantity": 5,
      "monsterName": "Plasma"
    }
  ],
  1762: [
    {
      "location": "odin_tem02",
      "quantity": 4,
      "monsterName": "Frus"
    },
    {
      "location": "odin_tem03",
      "quantity": 6,
      "monsterName": "Frus"
    }
  ],
  1761: [
    {
      "location": "odin_tem02",
      "quantity": 2,
      "monsterName": "Skogul"
    },
    {
      "location": "odin_tem03",
      "quantity": 6,
      "monsterName": "Skogul"
    }
  ],
  1754: [
    {
      "location": "odin_tem02",
      "quantity": 1,
      "monsterName": "Skeggiold"
    },
    {
      "location": "odin_tem03",
      "quantity": 19,
      "monsterName": "Skeggiold"
    }
  ],
  1755: [
    {
      "location": "odin_tem02",
      "quantity": 1,
      "monsterName": "Skeggiold"
    },
    {
      "location": "odin_tem03",
      "quantity": 19,
      "monsterName": "Skeggiold"
    }
  ],
  1765: [
    {
      "location": "odin_tem03",
      "quantity": 2,
      "monsterName": "Valkyrie"
    }
  ],
  1751: [
    {
      "location": "odin_tem03",
      "quantity": 1,
      "monsterName": "Valkyrie Randgris"
    }
  ],
  1153: [
    {
      "location": "orcsdun01",
      "quantity": 80,
      "monsterName": "Orc Zombie"
    }
  ],
  1042: [
    {
      "location": "orcsdun01",
      "quantity": 10,
      "monsterName": "Steel Chonchon"
    },
    {
      "location": "orcsdun02",
      "quantity": 20,
      "monsterName": "Steel Chonchon"
    },
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Steel Chonchon"
    },
    {
      "location": "moc_fild03",
      "quantity": 23,
      "monsterName": "Steel Chonchon"
    },
    {
      "location": "moc_fild13",
      "quantity": 140,
      "monsterName": "Steel Chonchon"
    }
  ],
  1152: [
    {
      "location": "orcsdun01",
      "quantity": 10,
      "monsterName": "Orc Skeleton"
    },
    {
      "location": "orcsdun02",
      "quantity": 50,
      "monsterName": "Orc Skeleton"
    }
  ],
  1177: [
    {
      "location": "orcsdun02",
      "quantity": 50,
      "monsterName": "Zenorc"
    }
  ],
  21301: [
    {
      "location": "oz_dun02",
      "quantity": 1,
      "monsterName": "Burning Fang"
    }
  ],
  1076: [
    {
      "location": "pay_dun00",
      "quantity": 35,
      "monsterName": "Skeleton"
    }
  ],
  1116: [
    {
      "location": "pay_dun01",
      "quantity": 16,
      "monsterName": "Eggyra"
    }
  ],
  1188: [
    {
      "location": "pay_dun02",
      "quantity": 30,
      "monsterName": "Bongun"
    },
    {
      "location": "pay_dun03",
      "quantity": 3,
      "monsterName": "Bongun"
    }
  ],
  1180: [
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Nine Tail"
    },
    {
      "location": "pay_dun03",
      "quantity": 2,
      "monsterName": "Nine Tail"
    },
    {
      "location": "pay_dun04",
      "quantity": 30,
      "monsterName": "Nine Tail"
    }
  ],
  1020: [
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun02",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "pay_dun03",
      "quantity": 1,
      "monsterName": "Mandragora"
    },
    {
      "location": "gef_fild04",
      "quantity": 125,
      "monsterName": "Mandragora"
    }
  ],
  1170: [
    {
      "location": "pay_dun03",
      "quantity": 70,
      "monsterName": "Sohee"
    }
  ],
  1277: [
    {
      "location": "pay_dun03",
      "quantity": 3,
      "monsterName": "Greatest General"
    },
    {
      "location": "pay_dun04",
      "quantity": 15,
      "monsterName": "Greatest General"
    },
    {
      "location": "pay_fild10",
      "quantity": 129,
      "monsterName": "Greatest General"
    }
  ],
  1110: [
    {
      "location": "pay_dun04",
      "quantity": 40,
      "monsterName": "Dokebi"
    },
    {
      "location": "bra_fild01",
      "quantity": 10,
      "monsterName": "Dokebi"
    }
  ],
  3760: [
    {
      "location": "pay_d03_i",
      "quantity": 20,
      "monsterName": "Resentful Munak"
    }
  ],
  3761: [
    {
      "location": "pay_d03_i",
      "quantity": 20,
      "monsterName": "Resentful Bongun"
    }
  ],
  3762: [
    {
      "location": "pay_d03_i",
      "quantity": 20,
      "monsterName": "Resentful Sohee"
    }
  ],
  3765: [
    {
      "location": "pay_d03_i",
      "quantity": 5,
      "monsterName": "Deranged Adventurer"
    }
  ],
  3759: [
    {
      "location": "pay_d03_i",
      "quantity": 10,
      "monsterName": "Angry Nine Tail"
    }
  ],
  1104: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Coco"
    },
    {
      "location": "ayo_fild01",
      "quantity": 40,
      "monsterName": "Coco"
    },
    {
      "location": "gef_fild02",
      "quantity": 172,
      "monsterName": "Coco"
    },
    {
      "location": "gef_fild09",
      "quantity": 98,
      "monsterName": "Coco"
    },
    {
      "location": "pay_fild09",
      "quantity": 38,
      "monsterName": "Coco"
    },
    {
      "location": "prt_fild10",
      "quantity": 22,
      "monsterName": "Coco"
    }
  ],
  1174: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Stainer"
    },
    {
      "location": "gef_fild05",
      "quantity": 20,
      "monsterName": "Stainer"
    },
    {
      "location": "mjolnir_01",
      "quantity": 23,
      "monsterName": "Stainer"
    },
    {
      "location": "pay_fild07",
      "quantity": 26,
      "monsterName": "Stainer"
    },
    {
      "location": "prt_fild02",
      "quantity": 188,
      "monsterName": "Stainer"
    }
  ],
  1103: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Caramel"
    },
    {
      "location": "mjolnir_01",
      "quantity": 167,
      "monsterName": "Caramel"
    },
    {
      "location": "pay_fild07",
      "quantity": 40,
      "monsterName": "Caramel"
    }
  ],
  1114: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Dustiness"
    },
    {
      "location": "mjolnir_12",
      "quantity": 162,
      "monsterName": "Dustiness"
    },
    {
      "location": "yuno_fild01",
      "quantity": 52,
      "monsterName": "Dustiness"
    }
  ],
  1128: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Horn"
    },
    {
      "location": "gef_fild02",
      "quantity": 24,
      "monsterName": "Horn"
    },
    {
      "location": "mjolnir_02",
      "quantity": 33,
      "monsterName": "Horn"
    },
    {
      "location": "pay_fild09",
      "quantity": 181,
      "monsterName": "Horn"
    },
    {
      "location": "prt_fild03",
      "quantity": 38,
      "monsterName": "Horn"
    },
    {
      "location": "prt_fild10",
      "quantity": 22,
      "monsterName": "Horn"
    }
  ],
  1013: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Wolf"
    },
    {
      "location": "moc_fild03",
      "quantity": 164,
      "monsterName": "Wolf"
    },
    {
      "location": "moc_fild13",
      "quantity": 15,
      "monsterName": "Wolf"
    }
  ],
  1025: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Boa"
    },
    {
      "location": "pay_fild02",
      "quantity": 142,
      "monsterName": "Boa"
    },
    {
      "location": "pay_fild06",
      "quantity": 30,
      "monsterName": "Boa"
    },
    {
      "location": "pay_fild08",
      "quantity": 31,
      "monsterName": "Boa"
    }
  ],
  1056: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Smokie"
    },
    {
      "location": "ayo_fild01",
      "quantity": 40,
      "monsterName": "Smokie"
    },
    {
      "location": "gef_fild05",
      "quantity": 20,
      "monsterName": "Smokie"
    },
    {
      "location": "mjolnir_06",
      "quantity": 70,
      "monsterName": "Smokie"
    }
  ],
  1166: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Savage"
    },
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Savage"
    },
    {
      "location": "bra_fild01",
      "quantity": 5,
      "monsterName": "Savage"
    },
    {
      "location": "mjolnir_07",
      "quantity": 161,
      "monsterName": "Savage"
    },
    {
      "location": "mjolnir_08",
      "quantity": 36,
      "monsterName": "Savage"
    },
    {
      "location": "pay_fild10",
      "quantity": 64,
      "monsterName": "Savage"
    }
  ],
  1008: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Pupa"
    },
    {
      "location": "gef_fild07",
      "quantity": 134,
      "monsterName": "Pupa"
    },
    {
      "location": "pay_fild03",
      "quantity": 20,
      "monsterName": "Pupa"
    },
    {
      "location": "prt_fild08",
      "quantity": 20,
      "monsterName": "Pupa"
    }
  ],
  1052: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Rocker"
    },
    {
      "location": "prt_fild07",
      "quantity": 203,
      "monsterName": "Rocker"
    }
  ],
  1060: [
    {
      "location": "prt_maze01",
      "quantity": 5,
      "monsterName": "Bigfoot"
    },
    {
      "location": "prt_maze02",
      "quantity": 6,
      "monsterName": "Bigfoot"
    },
    {
      "location": "ama_fild01",
      "quantity": 14,
      "monsterName": "Bigfoot"
    },
    {
      "location": "mjolnir_01",
      "quantity": 23,
      "monsterName": "Bigfoot"
    },
    {
      "location": "pay_fild07",
      "quantity": 174,
      "monsterName": "Bigfoot"
    }
  ],
  1057: [
    {
      "location": "prt_maze01",
      "quantity": 4,
      "monsterName": "Yoyo"
    },
    {
      "location": "ayo_fild01",
      "quantity": 40,
      "monsterName": "Yoyo"
    },
    {
      "location": "ayo_fild02",
      "quantity": 82,
      "monsterName": "Yoyo"
    },
    {
      "location": "mjolnir_02",
      "quantity": 22,
      "monsterName": "Yoyo"
    },
    {
      "location": "prt_fild03",
      "quantity": 127,
      "monsterName": "Yoyo"
    }
  ],
  1099: [
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Argiope"
    },
    {
      "location": "dew_fild01",
      "quantity": 75,
      "monsterName": "Argiope"
    },
    {
      "location": "mjolnir_05",
      "quantity": 166,
      "monsterName": "Argiope"
    },
    {
      "location": "mjolnir_11",
      "quantity": 170,
      "monsterName": "Argiope"
    },
    {
      "location": "mosk_fild02",
      "quantity": 42,
      "monsterName": "Argiope"
    }
  ],
  1100: [
    {
      "location": "prt_maze01",
      "quantity": 3,
      "monsterName": "Argos"
    },
    {
      "location": "mjolnir_10",
      "quantity": 194,
      "monsterName": "Argos"
    },
    {
      "location": "mjolnir_11",
      "quantity": 45,
      "monsterName": "Argos"
    },
    {
      "location": "moc_fild03",
      "quantity": 23,
      "monsterName": "Argos"
    },
    {
      "location": "moc_fild13",
      "quantity": 15,
      "monsterName": "Argos"
    }
  ],
  1214: [
    {
      "location": "prt_maze01",
      "quantity": 2,
      "monsterName": "Choco"
    },
    {
      "location": "prt_fild03",
      "quantity": 1,
      "monsterName": "Choco"
    },
    {
      "location": "um_fild02",
      "quantity": 8,
      "monsterName": "Choco"
    },
    {
      "location": "um_fild04",
      "quantity": 2,
      "monsterName": "Choco"
    }
  ],
  1018: [
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Creamy"
    },
    {
      "location": "gef_fild05",
      "quantity": 143,
      "monsterName": "Creamy"
    },
    {
      "location": "mjolnir_01",
      "quantity": 23,
      "monsterName": "Creamy"
    },
    {
      "location": "mjolnir_06",
      "quantity": 30,
      "monsterName": "Creamy"
    },
    {
      "location": "pay_fild07",
      "quantity": 26,
      "monsterName": "Creamy"
    },
    {
      "location": "prt_fild02",
      "quantity": 40,
      "monsterName": "Creamy"
    }
  ],
  1092: [
    {
      "location": "prt_maze01",
      "quantity": 1,
      "monsterName": "Vagabond Wolf"
    },
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Vagabond Wolf"
    }
  ],
  1243: [
    {
      "location": "prt_maze02",
      "quantity": 1,
      "monsterName": "Sasquatch"
    },
    {
      "location": "xmas_fild01",
      "quantity": 9,
      "monsterName": "Sasquatch"
    }
  ],
  1101: [
    {
      "location": "prt_maze03",
      "quantity": 25,
      "monsterName": "Baphomet Jr."
    }
  ],
  1215: [
    {
      "location": "prt_maze03",
      "quantity": 20,
      "monsterName": "Stem Worm"
    },
    {
      "location": "lhz_fild01",
      "quantity": 45,
      "monsterName": "Stem Worm"
    },
    {
      "location": "lhz_fild02",
      "quantity": 100,
      "monsterName": "Stem Worm"
    },
    {
      "location": "lhz_fild03",
      "quantity": 20,
      "monsterName": "Stem Worm"
    }
  ],
  1093: [
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Eclipse"
    },
    {
      "location": "prt_fild02",
      "quantity": 1,
      "monsterName": "Eclipse"
    }
  ],
  1090: [
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Mastering"
    },
    {
      "location": "xmas_dun01",
      "quantity": 1,
      "monsterName": "Mastering"
    },
    {
      "location": "pay_fild04",
      "quantity": 1,
      "monsterName": "Mastering"
    },
    {
      "location": "yuno_fild04",
      "quantity": 1,
      "monsterName": "Mastering"
    }
  ],
  1088: [
    {
      "location": "prt_maze03",
      "quantity": 1,
      "monsterName": "Vocal"
    },
    {
      "location": "prt_fild04",
      "quantity": 1,
      "monsterName": "Vocal"
    },
    {
      "location": "prt_fild07",
      "quantity": 1,
      "monsterName": "Vocal"
    }
  ],
  1048: [
    {
      "location": "prt_sewb1",
      "quantity": 106,
      "monsterName": "Thief Bug Egg"
    },
    {
      "location": "prt_sewb2",
      "quantity": 20,
      "monsterName": "Thief Bug Egg"
    },
    {
      "location": "prt_sewb3",
      "quantity": 10,
      "monsterName": "Thief Bug Egg"
    },
    {
      "location": "prt_sewb4",
      "quantity": 10,
      "monsterName": "Thief Bug Egg"
    },
    {
      "location": "gef_fild05",
      "quantity": 10,
      "monsterName": "Thief Bug Egg"
    },
    {
      "location": "prt_fild05",
      "quantity": 42,
      "monsterName": "Thief Bug Egg"
    }
  ],
  1053: [
    {
      "location": "prt_sewb2",
      "quantity": 10,
      "monsterName": "Thief Bug Female"
    },
    {
      "location": "prt_sewb3",
      "quantity": 65,
      "monsterName": "Thief Bug Female"
    },
    {
      "location": "prt_sewb4",
      "quantity": 20,
      "monsterName": "Thief Bug Female"
    }
  ],
  1054: [
    {
      "location": "prt_sewb3",
      "quantity": 65,
      "monsterName": "Thief Bug Male"
    },
    {
      "location": "prt_sewb4",
      "quantity": 70,
      "monsterName": "Thief Bug Male"
    }
  ],
  1086: [
    {
      "location": "prt_sewb4",
      "quantity": 1,
      "monsterName": "Golden Thief Bug"
    }
  ],
  1771: [
    {
      "location": "ra_san01",
      "quantity": 82,
      "monsterName": "Vanberk"
    },
    {
      "location": "ra_san02",
      "quantity": 38,
      "monsterName": "Vanberk"
    }
  ],
  1772: [
    {
      "location": "ra_san01",
      "quantity": 36,
      "monsterName": "Isilla"
    },
    {
      "location": "ra_san02",
      "quantity": 110,
      "monsterName": "Isilla"
    },
    {
      "location": "ra_san05",
      "quantity": 10,
      "monsterName": "Isilla"
    }
  ],
  1632: [
    {
      "location": "ra_san01",
      "quantity": 10,
      "monsterName": "Gremlin"
    },
    {
      "location": "ra_san02",
      "quantity": 12,
      "monsterName": "Gremlin"
    },
    {
      "location": "ra_san03",
      "quantity": 7,
      "monsterName": "Gremlin"
    }
  ],
  1633: [
    {
      "location": "ra_san01",
      "quantity": 6,
      "monsterName": "Beholder"
    },
    {
      "location": "ra_san02",
      "quantity": 12,
      "monsterName": "Beholder"
    },
    {
      "location": "ra_san03",
      "quantity": 7,
      "monsterName": "Beholder"
    }
  ],
  1773: [
    {
      "location": "ra_san01",
      "quantity": 6,
      "monsterName": "Hodremlin"
    },
    {
      "location": "ra_san02",
      "quantity": 3,
      "monsterName": "Hodremlin"
    },
    {
      "location": "ra_san03",
      "quantity": 86,
      "monsterName": "Hodremlin"
    },
    {
      "location": "ra_san04",
      "quantity": 10,
      "monsterName": "Hodremlin"
    },
    {
      "location": "ra_san05",
      "quantity": 21,
      "monsterName": "Hodremlin"
    }
  ],
  1774: [
    {
      "location": "ra_san02",
      "quantity": 2,
      "monsterName": "Seeker"
    },
    {
      "location": "ra_san03",
      "quantity": 57,
      "monsterName": "Seeker"
    },
    {
      "location": "ra_san04",
      "quantity": 10,
      "monsterName": "Seeker"
    },
    {
      "location": "ra_san05",
      "quantity": 21,
      "monsterName": "Seeker"
    }
  ],
  1770: [
    {
      "location": "ra_san04",
      "quantity": 62,
      "monsterName": "Echio"
    },
    {
      "location": "ra_san05",
      "quantity": 31,
      "monsterName": "Echio"
    }
  ],
  1769: [
    {
      "location": "ra_san04",
      "quantity": 20,
      "monsterName": "Agav"
    },
    {
      "location": "ra_san05",
      "quantity": 84,
      "monsterName": "Agav"
    }
  ],
  1768: [
    {
      "location": "ra_san05",
      "quantity": 1,
      "monsterName": "Gloom Under Night"
    }
  ],
  3741: [
    {
      "location": "rockmi1",
      "quantity": 1,
      "monsterName": "Spider Chariot"
    }
  ],
  3633: [
    {
      "location": "slabw01",
      "quantity": 1,
      "monsterName": "Venomous Chimera"
    }
  ],
  20361: [
    {
      "location": "sp_rudus",
      "quantity": 30,
      "monsterName": "Dolor"
    }
  ],
  20365: [
    {
      "location": "sp_rudus",
      "quantity": 30,
      "monsterName": "Twin Caput"
    }
  ],
  20356: [
    {
      "location": "sp_rudus2",
      "quantity": 40,
      "monsterName": "High Hunter Bellare"
    }
  ],
  20358: [
    {
      "location": "sp_rudus2",
      "quantity": 37,
      "monsterName": "High Hunter Sanare"
    }
  ],
  20359: [
    {
      "location": "sp_rudus2",
      "quantity": 58,
      "monsterName": "Plaga"
    }
  ],
  20362: [
    {
      "location": "sp_rudus2",
      "quantity": 45,
      "monsterName": "Mutant Dolor"
    },
    {
      "location": "sp_rudus3",
      "quantity": 60,
      "monsterName": "Mutant Dolor"
    }
  ],
  20381: [
    {
      "location": "sp_rudus2",
      "quantity": 1,
      "monsterName": "R48-85-Bestia"
    }
  ],
  20360: [
    {
      "location": "sp_rudus3",
      "quantity": 53,
      "monsterName": "Mutant Plaga"
    }
  ],
  20364: [
    {
      "location": "sp_rudus3",
      "quantity": 65,
      "monsterName": "Mutant Venenum"
    }
  ],
  20366: [
    {
      "location": "sp_rudus3",
      "quantity": 65,
      "monsterName": "Mutant Twin Caput"
    }
  ],
  2415: [
    {
      "location": "teg_dun01",
      "quantity": 20,
      "monsterName": "Knight Seyren"
    }
  ],
  2416: [
    {
      "location": "teg_dun01",
      "quantity": 15,
      "monsterName": "Assassin Eremes"
    }
  ],
  2417: [
    {
      "location": "teg_dun01",
      "quantity": 15,
      "monsterName": "Blacksmith Howard"
    }
  ],
  2418: [
    {
      "location": "teg_dun01",
      "quantity": 35,
      "monsterName": "Hunter Cecil"
    }
  ],
  2419: [
    {
      "location": "teg_dun01",
      "quantity": 30,
      "monsterName": "Wizard Kathryne"
    }
  ],
  2420: [
    {
      "location": "teg_dun01",
      "quantity": 20,
      "monsterName": "Priest Margaretha"
    }
  ],
  2441: [
    {
      "location": "teg_dun01",
      "quantity": 1,
      "monsterName": "The Last One"
    }
  ],
  2421: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Crusader Egnigem"
    }
  ],
  2422: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Rogue Wickebine"
    }
  ],
  2423: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Alchemist Armeyer"
    }
  ],
  2424: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Bard Kavach"
    }
  ],
  2425: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Dancer Josephina"
    }
  ],
  2426: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Sage Laurell"
    }
  ],
  2427: [
    {
      "location": "teg_dun02",
      "quantity": 15,
      "monsterName": "Monk Errende"
    }
  ],
  2442: [
    {
      "location": "teg_dun02",
      "quantity": 1,
      "monsterName": "King of the Alley"
    }
  ],
  1703: [
    {
      "location": "tha_t01",
      "quantity": 4,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t07",
      "quantity": 7,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t08",
      "quantity": 5,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t09",
      "quantity": 20,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t10",
      "quantity": 5,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t11",
      "quantity": 5,
      "monsterName": "Lady Solace"
    },
    {
      "location": "tha_t12",
      "quantity": 5,
      "monsterName": "Lady Solace"
    }
  ],
  1698: [
    {
      "location": "tha_t02",
      "quantity": 10,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t03",
      "quantity": 80,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t04",
      "quantity": 20,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t05",
      "quantity": 40,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t06",
      "quantity": 40,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t07",
      "quantity": 10,
      "monsterName": "Death Word"
    },
    {
      "location": "tha_t08",
      "quantity": 10,
      "monsterName": "Death Word"
    }
  ],
  1702: [
    {
      "location": "tha_t02",
      "quantity": 4,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t07",
      "quantity": 15,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t08",
      "quantity": 20,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t09",
      "quantity": 5,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t10",
      "quantity": 20,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t11",
      "quantity": 5,
      "monsterName": "Baroness of Retribution"
    },
    {
      "location": "tha_t12",
      "quantity": 5,
      "monsterName": "Baroness of Retribution"
    }
  ],
  1701: [
    {
      "location": "tha_t03",
      "quantity": 4,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t07",
      "quantity": 7,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t08",
      "quantity": 5,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t09",
      "quantity": 5,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t10",
      "quantity": 5,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t11",
      "quantity": 20,
      "monsterName": "Mistress of Shelter"
    },
    {
      "location": "tha_t12",
      "quantity": 5,
      "monsterName": "Mistress of Shelter"
    }
  ],
  1700: [
    {
      "location": "tha_t04",
      "quantity": 4,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t07",
      "quantity": 7,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t08",
      "quantity": 5,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t09",
      "quantity": 5,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t10",
      "quantity": 5,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t11",
      "quantity": 5,
      "monsterName": "Dame of Sentinel"
    },
    {
      "location": "tha_t12",
      "quantity": 13,
      "monsterName": "Dame of Sentinel"
    }
  ],
  1707: [
    {
      "location": "tha_t05",
      "quantity": 2,
      "monsterName": "Dolor of Thanatos"
    },
    {
      "location": "tha_t09",
      "quantity": 1,
      "monsterName": "Dolor of Thanatos"
    }
  ],
  1706: [
    {
      "location": "tha_t06",
      "quantity": 2,
      "monsterName": "Maero of Thanatos"
    },
    {
      "location": "tha_t10",
      "quantity": 1,
      "monsterName": "Maero of Thanatos"
    }
  ],
  1705: [
    {
      "location": "tha_t07",
      "quantity": 2,
      "monsterName": "Despero of Thanatos"
    },
    {
      "location": "tha_t11",
      "quantity": 1,
      "monsterName": "Despero of Thanatos"
    }
  ],
  1704: [
    {
      "location": "tha_t08",
      "quantity": 2,
      "monsterName": "Odium of Thanatos"
    }
  ],
  1712: [
    {
      "location": "tha_t09",
      "quantity": 3,
      "monsterName": "Dolor of Thanatos"
    }
  ],
  1711: [
    {
      "location": "tha_t10",
      "quantity": 3,
      "monsterName": "Maero of Thanatos"
    }
  ],
  1710: [
    {
      "location": "tha_t11",
      "quantity": 3,
      "monsterName": "Despero of Thanatos"
    }
  ],
  1709: [
    {
      "location": "tha_t12",
      "quantity": 4,
      "monsterName": "Odium of Thanatos"
    }
  ],
  1833: [
    {
      "location": "thor_v01",
      "quantity": 49,
      "monsterName": "Kasa"
    },
    {
      "location": "thor_v03",
      "quantity": 44,
      "monsterName": "Kasa"
    }
  ],
  1837: [
    {
      "location": "thor_v01",
      "quantity": 27,
      "monsterName": "Imp"
    },
    {
      "location": "thor_v02",
      "quantity": 10,
      "monsterName": "Imp"
    }
  ],
  1836: [
    {
      "location": "thor_v01",
      "quantity": 11,
      "monsterName": "Magmaring"
    },
    {
      "location": "thor_v02",
      "quantity": 10,
      "monsterName": "Magmaring"
    },
    {
      "location": "ve_fild03",
      "quantity": 141,
      "monsterName": "Magmaring"
    }
  ],
  1831: [
    {
      "location": "thor_v01",
      "quantity": 7,
      "monsterName": "Salamander"
    },
    {
      "location": "thor_v02",
      "quantity": 1,
      "monsterName": "Salamander"
    },
    {
      "location": "thor_v03",
      "quantity": 66,
      "monsterName": "Salamander"
    }
  ],
  1830: [
    {
      "location": "thor_v01",
      "quantity": 5,
      "monsterName": "Bow Guardian"
    },
    {
      "location": "thor_v01",
      "quantity": 5,
      "monsterName": "Bow Guardian"
    },
    {
      "location": "thor_v02",
      "quantity": 1,
      "monsterName": "Bow Guardian"
    },
    {
      "location": "thor_v03",
      "quantity": 11,
      "monsterName": "Bow Guardian"
    },
    {
      "location": "thor_v03",
      "quantity": 5,
      "monsterName": "Bow Guardian"
    }
  ],
  1829: [
    {
      "location": "thor_v01",
      "quantity": 5,
      "monsterName": "Sword Guardian"
    },
    {
      "location": "thor_v01",
      "quantity": 5,
      "monsterName": "Sword Guardian"
    },
    {
      "location": "thor_v02",
      "quantity": 1,
      "monsterName": "Sword Guardian"
    },
    {
      "location": "thor_v03",
      "quantity": 11,
      "monsterName": "Sword Guardian"
    },
    {
      "location": "thor_v03",
      "quantity": 5,
      "monsterName": "Sword Guardian"
    }
  ],
  1839: [
    {
      "location": "thor_v01",
      "quantity": 1,
      "monsterName": "Byrogue"
    },
    {
      "location": "thor_v03",
      "quantity": 5,
      "monsterName": "Byrogue"
    }
  ],
  1838: [
    {
      "location": "thor_v02",
      "quantity": 55,
      "monsterName": "Knocker"
    }
  ],
  1832: [
    {
      "location": "thor_v03",
      "quantity": 1,
      "monsterName": "Ifrit"
    }
  ],
  1071: [
    {
      "location": "treasure01",
      "quantity": 56,
      "monsterName": "Pirate Skeleton"
    },
    {
      "location": "treasure02",
      "quantity": 40,
      "monsterName": "Pirate Skeleton"
    }
  ],
  1112: [
    {
      "location": "treasure02",
      "quantity": 1,
      "monsterName": "Drake"
    }
  ],
  1321: [
    {
      "location": "tur_dun01",
      "quantity": 25,
      "monsterName": "Dragon Tail"
    }
  ],
  1322: [
    {
      "location": "tur_dun01",
      "quantity": 25,
      "monsterName": "Spring Rabbit"
    }
  ],
  1314: [
    {
      "location": "tur_dun01",
      "quantity": 10,
      "monsterName": "Permeter"
    },
    {
      "location": "tur_dun02",
      "quantity": 41,
      "monsterName": "Permeter"
    },
    {
      "location": "tur_dun03",
      "quantity": 15,
      "monsterName": "Permeter"
    },
    {
      "location": "tur_dun04",
      "quantity": 4,
      "monsterName": "Permeter"
    },
    {
      "location": "tur_dun05",
      "quantity": 4,
      "monsterName": "Permeter"
    }
  ],
  1316: [
    {
      "location": "tur_dun02",
      "quantity": 41,
      "monsterName": "Solider"
    }
  ],
  1319: [
    {
      "location": "tur_dun02",
      "quantity": 20,
      "monsterName": "Freezer"
    },
    {
      "location": "tur_dun03",
      "quantity": 40,
      "monsterName": "Freezer"
    },
    {
      "location": "tur_dun04",
      "quantity": 15,
      "monsterName": "Freezer"
    },
    {
      "location": "tur_dun05",
      "quantity": 7,
      "monsterName": "Freezer"
    }
  ],
  1315: [
    {
      "location": "tur_dun03",
      "quantity": 35,
      "monsterName": "Assaulter"
    },
    {
      "location": "tur_dun04",
      "quantity": 42,
      "monsterName": "Assaulter"
    },
    {
      "location": "tur_dun05",
      "quantity": 1,
      "monsterName": "Assaulter"
    }
  ],
  1318: [
    {
      "location": "tur_dun03",
      "quantity": 10,
      "monsterName": "Heater"
    },
    {
      "location": "tur_dun04",
      "quantity": 33,
      "monsterName": "Heater"
    }
  ],
  1312: [
    {
      "location": "tur_dun04",
      "quantity": 1,
      "monsterName": "Turtle General"
    }
  ],
  3800: [
    {
      "location": "tur_d04_i",
      "quantity": 16,
      "monsterName": "Ominous Permeter"
    }
  ],
  3801: [
    {
      "location": "tur_d04_i",
      "quantity": 36,
      "monsterName": "Ominous Freezer"
    }
  ],
  3799: [
    {
      "location": "tur_d04_i",
      "quantity": 16,
      "monsterName": "Ominous Assulter"
    }
  ],
  3802: [
    {
      "location": "tur_d04_i",
      "quantity": 16,
      "monsterName": "Ominous Solider"
    }
  ],
  3803: [
    {
      "location": "tur_d04_i",
      "quantity": 36,
      "monsterName": "Ominous Heater"
    }
  ],
  1265: [
    {
      "location": "xmas_dun01",
      "quantity": 49,
      "monsterName": "Cookie"
    },
    {
      "location": "xmas_dun02",
      "quantity": 28,
      "monsterName": "Cookie"
    }
  ],
  1246: [
    {
      "location": "xmas_dun01",
      "quantity": 49,
      "monsterName": "Christmas Cookie"
    },
    {
      "location": "xmas_dun02",
      "quantity": 28,
      "monsterName": "Christmas Cookie"
    }
  ],
  1242: [
    {
      "location": "xmas_dun01",
      "quantity": 24,
      "monsterName": "Marin"
    },
    {
      "location": "xmas_fild01",
      "quantity": 65,
      "monsterName": "Marin"
    },
    {
      "location": "pay_fild04",
      "quantity": 32,
      "monsterName": "Marin"
    }
  ],
  1113: [
    {
      "location": "xmas_dun01",
      "quantity": 12,
      "monsterName": "Drops"
    },
    {
      "location": "moc_fild07",
      "quantity": 214,
      "monsterName": "Drops"
    },
    {
      "location": "moc_fild12",
      "quantity": 39,
      "monsterName": "Drops"
    },
    {
      "location": "pay_fild04",
      "quantity": 21,
      "monsterName": "Drops"
    }
  ],
  1249: [
    {
      "location": "xmas_dun01",
      "quantity": 6,
      "monsterName": "Myst Case"
    },
    {
      "location": "xmas_dun02",
      "quantity": 70,
      "monsterName": "Myst Case"
    }
  ],
  1250: [
    {
      "location": "xmas_dun01",
      "quantity": 1,
      "monsterName": "Chepet"
    }
  ],
  1096: [
    {
      "location": "xmas_dun01",
      "quantity": 1,
      "monsterName": "Angeling"
    },
    {
      "location": "pay_fild04",
      "quantity": 1,
      "monsterName": "Angeling"
    },
    {
      "location": "yuno_fild03",
      "quantity": 1,
      "monsterName": "Angeling"
    }
  ],
  1248: [
    {
      "location": "xmas_dun02",
      "quantity": 49,
      "monsterName": "Cruiser"
    }
  ],
  1251: [
    {
      "location": "xmas_dun02",
      "quantity": 1,
      "monsterName": "Stormy Knight"
    }
  ],
  1400: [
    {
      "location": "ama_fild01",
      "quantity": 72,
      "monsterName": "Karakasa"
    }
  ],
  1406: [
    {
      "location": "ama_fild01",
      "quantity": 57,
      "monsterName": "Kapha"
    }
  ],
  20649: [
    {
      "location": "ba_lost",
      "quantity": 50,
      "monsterName": "Pitaya"
    }
  ],
  20650: [
    {
      "location": "ba_lost",
      "quantity": 50,
      "monsterName": "Pitaya"
    }
  ],
  20651: [
    {
      "location": "ba_lost",
      "quantity": 50,
      "monsterName": "Pitaya"
    }
  ],
  20652: [
    {
      "location": "ba_lost",
      "quantity": 50,
      "monsterName": "Pitaya"
    }
  ],
  20653: [
    {
      "location": "ba_lost",
      "quantity": 30,
      "monsterName": "Pitaya"
    }
  ],
  20648: [
    {
      "location": "ba_lost",
      "quantity": 1,
      "monsterName": "Boss Pitaya"
    }
  ],
  20640: [
    {
      "location": "ba_maison",
      "quantity": 5,
      "monsterName": "Omega Cleaner"
    }
  ],
  20679: [
    {
      "location": "ba_maison",
      "quantity": 15,
      "monsterName": "Guardian Parts"
    }
  ],
  1994: [
    {
      "location": "bif_fild01",
      "quantity": 29,
      "monsterName": "Luciola Vespa"
    },
    {
      "location": "bif_fild02",
      "quantity": 27,
      "monsterName": "Luciola Vespa"
    },
    {
      "location": "spl_fild02",
      "quantity": 27,
      "monsterName": "Luciola Vespa"
    },
    {
      "location": "spl_fild03",
      "quantity": 74,
      "monsterName": "Luciola Vespa"
    }
  ],
  1992: [
    {
      "location": "bif_fild01",
      "quantity": 17,
      "monsterName": "Cornus"
    },
    {
      "location": "bif_fild02",
      "quantity": 16,
      "monsterName": "Cornus"
    },
    {
      "location": "spl_fild01",
      "quantity": 49,
      "monsterName": "Cornus"
    },
    {
      "location": "spl_fild03",
      "quantity": 52,
      "monsterName": "Cornus"
    }
  ],
  2137: [
    {
      "location": "bif_fild01",
      "quantity": 58,
      "monsterName": "Miming"
    },
    {
      "location": "bif_fild02",
      "quantity": 33,
      "monsterName": "Miming"
    }
  ],
  2136: [
    {
      "location": "bif_fild01",
      "quantity": 34,
      "monsterName": "Little Fatum"
    },
    {
      "location": "bif_fild02",
      "quantity": 55,
      "monsterName": "Little Fatum"
    }
  ],
  2132: [
    {
      "location": "bif_fild01",
      "quantity": 5,
      "monsterName": "Pom Spider"
    },
    {
      "location": "bif_fild02",
      "quantity": 5,
      "monsterName": "Pom Spider"
    }
  ],
  2074: [
    {
      "location": "bra_fild01",
      "quantity": 50,
      "monsterName": "Curupira"
    }
  ],
  2071: [
    {
      "location": "bra_fild01",
      "quantity": 40,
      "monsterName": "Headless Mule"
    }
  ],
  2072: [
    {
      "location": "bra_fild01",
      "quantity": 55,
      "monsterName": "Jaguar"
    }
  ],
  2073: [
    {
      "location": "bra_fild01",
      "quantity": 60,
      "monsterName": "Toucan"
    }
  ],
  1687: [
    {
      "location": "cmd_fild01",
      "quantity": 202,
      "monsterName": "Grove"
    }
  ],
  1118: [
    {
      "location": "cmd_fild01",
      "quantity": 67,
      "monsterName": "Flora"
    },
    {
      "location": "cmd_fild03",
      "quantity": 64,
      "monsterName": "Flora"
    },
    {
      "location": "gef_fild08",
      "quantity": 37,
      "monsterName": "Flora"
    },
    {
      "location": "mjolnir_07",
      "quantity": 34,
      "monsterName": "Flora"
    },
    {
      "location": "mjolnir_08",
      "quantity": 36,
      "monsterName": "Flora"
    },
    {
      "location": "mjolnir_10",
      "quantity": 41,
      "monsterName": "Flora"
    },
    {
      "location": "mjolnir_11",
      "quantity": 45,
      "monsterName": "Flora"
    }
  ],
  1317: [
    {
      "location": "cmd_fild02",
      "quantity": 162,
      "monsterName": "Seal"
    }
  ],
  1391: [
    {
      "location": "cmd_fild02",
      "quantity": 40,
      "monsterName": "Galapago"
    },
    {
      "location": "cmd_fild04",
      "quantity": 37,
      "monsterName": "Galapago"
    }
  ],
  1313: [
    {
      "location": "cmd_fild02",
      "quantity": 1,
      "monsterName": "Mobster"
    }
  ],
  1271: [
    {
      "location": "cmd_fild03",
      "quantity": 194,
      "monsterName": "Alligator"
    }
  ],
  1262: [
    {
      "location": "cmd_fild03",
      "quantity": 5,
      "monsterName": "Mutant Dragonoid"
    }
  ],
  1089: [
    {
      "location": "cmd_fild03",
      "quantity": 1,
      "monsterName": "Toad"
    },
    {
      "location": "gef_fild01",
      "quantity": 1,
      "monsterName": "Toad"
    }
  ],
  1323: [
    {
      "location": "cmd_fild04",
      "quantity": 149,
      "monsterName": "Sea Otter"
    }
  ],
  1040: [
    {
      "location": "cmd_fild06",
      "quantity": 165,
      "monsterName": "Golem"
    },
    {
      "location": "cmd_fild08",
      "quantity": 2,
      "monsterName": "Golem"
    }
  ],
  1058: [
    {
      "location": "cmd_fild06",
      "quantity": 55,
      "monsterName": "Metaller"
    },
    {
      "location": "cmd_fild09",
      "quantity": 155,
      "monsterName": "Metaller"
    },
    {
      "location": "moc_fild13",
      "quantity": 15,
      "monsterName": "Metaller"
    },
    {
      "location": "prt_fild09",
      "quantity": 91,
      "monsterName": "Metaller"
    }
  ],
  1254: [
    {
      "location": "cmd_fild07",
      "quantity": 116,
      "monsterName": "Raggler"
    }
  ],
  2151: [
    {
      "location": "dew_fild01",
      "quantity": 100,
      "monsterName": "Alnoldi"
    }
  ],
  2153: [
    {
      "location": "dew_fild01",
      "quantity": 16,
      "monsterName": "Cendrawasih"
    }
  ],
  1987: [
    {
      "location": "dic_fild01",
      "quantity": 60,
      "monsterName": "Centipede"
    },
    {
      "location": "dic_fild02",
      "quantity": 38,
      "monsterName": "Centipede"
    },
    {
      "location": "man_fild01",
      "quantity": 2,
      "monsterName": "Centipede"
    },
    {
      "location": "man_fild02",
      "quantity": 52,
      "monsterName": "Centipede"
    },
    {
      "location": "man_fild03",
      "quantity": 33,
      "monsterName": "Centipede"
    }
  ],
  1999: [
    {
      "location": "dic_fild01",
      "quantity": 30,
      "monsterName": "Centipede Larva"
    },
    {
      "location": "dic_fild02",
      "quantity": 10,
      "monsterName": "Centipede Larva"
    },
    {
      "location": "man_fild01",
      "quantity": 42,
      "monsterName": "Centipede Larva"
    }
  ],
  1986: [
    {
      "location": "dic_fild01",
      "quantity": 25,
      "monsterName": "Tatacho"
    },
    {
      "location": "dic_fild02",
      "quantity": 27,
      "monsterName": "Tatacho"
    },
    {
      "location": "man_fild02",
      "quantity": 37,
      "monsterName": "Tatacho"
    },
    {
      "location": "man_fild03",
      "quantity": 33,
      "monsterName": "Tatacho"
    }
  ],
  2092: [
    {
      "location": "dic_fild01",
      "quantity": 20,
      "monsterName": "Dolomedes"
    },
    {
      "location": "dic_fild02",
      "quantity": 87,
      "monsterName": "Dolomedes"
    }
  ],
  2024: [
    {
      "location": "dic_fild02",
      "quantity": 3,
      "monsterName": "Bradium Golem"
    },
    {
      "location": "man_fild02",
      "quantity": 75,
      "monsterName": "Bradium Golem"
    }
  ],
  2363: [
    {
      "location": "ecl_fild01",
      "quantity": 73,
      "monsterName": "Menblatt"
    }
  ],
  2364: [
    {
      "location": "ecl_fild01",
      "quantity": 73,
      "monsterName": "Petal"
    }
  ],
  1378: [
    {
      "location": "ein_fild04",
      "quantity": 18,
      "monsterName": "Demon Pungus"
    },
    {
      "location": "ein_fild05",
      "quantity": 15,
      "monsterName": "Demon Pungus"
    },
    {
      "location": "lhz_fild02",
      "quantity": 15,
      "monsterName": "Demon Pungus"
    },
    {
      "location": "lhz_fild03",
      "quantity": 15,
      "monsterName": "Demon Pungus"
    }
  ],
  1628: [
    {
      "location": "ein_fild06",
      "quantity": 100,
      "monsterName": "Holden"
    },
    {
      "location": "ein_fild07",
      "quantity": 12,
      "monsterName": "Holden"
    }
  ],
  1094: [
    {
      "location": "gef_fild01",
      "quantity": 28,
      "monsterName": "Ambernite"
    },
    {
      "location": "prt_fild00",
      "quantity": 65,
      "monsterName": "Ambernite"
    },
    {
      "location": "prt_fild04",
      "quantity": 111,
      "monsterName": "Ambernite"
    }
  ],
  1033: [
    {
      "location": "gef_fild02",
      "quantity": 24,
      "monsterName": "Elder Willow"
    },
    {
      "location": "mjolnir_02",
      "quantity": 154,
      "monsterName": "Elder Willow"
    },
    {
      "location": "pay_fild09",
      "quantity": 25,
      "monsterName": "Elder Willow"
    },
    {
      "location": "prt_fild10",
      "quantity": 157,
      "monsterName": "Elder Willow"
    }
  ],
  1273: [
    {
      "location": "gef_fild03",
      "quantity": 160,
      "monsterName": "Orc Lady"
    },
    {
      "location": "gef_fild10",
      "quantity": 55,
      "monsterName": "Orc Lady"
    }
  ],
  1023: [
    {
      "location": "gef_fild03",
      "quantity": 73,
      "monsterName": "Orc Warrior"
    },
    {
      "location": "gef_fild10",
      "quantity": 179,
      "monsterName": "Orc Warrior"
    }
  ],
  1686: [
    {
      "location": "gef_fild03",
      "quantity": 24,
      "monsterName": "Orc Baby"
    },
    {
      "location": "gef_fild10",
      "quantity": 27,
      "monsterName": "Orc Baby"
    }
  ],
  1087: [
    {
      "location": "gef_fild03",
      "quantity": 1,
      "monsterName": "Orc Hero"
    }
  ],
  1155: [
    {
      "location": "gef_fild06",
      "quantity": 158,
      "monsterName": "Petite"
    }
  ],
  1156: [
    {
      "location": "gef_fild08",
      "quantity": 163,
      "monsterName": "Petite"
    }
  ],
  1190: [
    {
      "location": "gef_fild10",
      "quantity": 1,
      "monsterName": "Orc Lord"
    }
  ],
  1122: [
    {
      "location": "gef_fild11",
      "quantity": 58,
      "monsterName": "Goblin"
    },
    {
      "location": "prt_fild11",
      "quantity": 10,
      "monsterName": "Goblin"
    }
  ],
  1123: [
    {
      "location": "gef_fild11",
      "quantity": 58,
      "monsterName": "Goblin"
    },
    {
      "location": "prt_fild11",
      "quantity": 10,
      "monsterName": "Goblin"
    }
  ],
  1124: [
    {
      "location": "gef_fild11",
      "quantity": 58,
      "monsterName": "Goblin"
    },
    {
      "location": "prt_fild11",
      "quantity": 10,
      "monsterName": "Goblin"
    }
  ],
  1125: [
    {
      "location": "gef_fild11",
      "quantity": 58,
      "monsterName": "Goblin"
    },
    {
      "location": "prt_fild11",
      "quantity": 10,
      "monsterName": "Goblin"
    }
  ],
  1299: [
    {
      "location": "gef_fild11",
      "quantity": 1,
      "monsterName": "Goblin Leader"
    }
  ],
  1409: [
    {
      "location": "gon_fild01",
      "quantity": 70,
      "monsterName": "Dumpling Child"
    }
  ],
  1368: [
    {
      "location": "hu_fild01",
      "quantity": 10,
      "monsterName": "Geographer"
    },
    {
      "location": "hu_fild02",
      "quantity": 37,
      "monsterName": "Geographer"
    },
    {
      "location": "hu_fild04",
      "quantity": 30,
      "monsterName": "Geographer"
    },
    {
      "location": "lou_fild01",
      "quantity": 28,
      "monsterName": "Geographer"
    },
    {
      "location": "mosk_fild02",
      "quantity": 7,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild01",
      "quantity": 75,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild04",
      "quantity": 36,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild06",
      "quantity": 29,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild08",
      "quantity": 36,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild09",
      "quantity": 42,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild11",
      "quantity": 55,
      "monsterName": "Geographer"
    },
    {
      "location": "yuno_fild12",
      "quantity": 68,
      "monsterName": "Geographer"
    }
  ],
  1259: [
    {
      "location": "hu_fild02",
      "quantity": 3,
      "monsterName": "Gryphon"
    }
  ],
  21537: [
    {
      "location": "jor_back3",
      "quantity": 1,
      "monsterName": "--ja--"
    }
  ],
  1162: [
    {
      "location": "lhz_fild01",
      "quantity": 170,
      "monsterName": "Rafflesia"
    },
    {
      "location": "lhz_fild02",
      "quantity": 20,
      "monsterName": "Rafflesia"
    },
    {
      "location": "lhz_fild03",
      "quantity": 20,
      "monsterName": "Rafflesia"
    }
  ],
  1515: [
    {
      "location": "xmas_fild01",
      "quantity": 1,
      "monsterName": "Garm Baby"
    }
  ],
  1252: [
    {
      "location": "xmas_fild01",
      "quantity": 1,
      "monsterName": "Garm"
    }
  ],
  2313: [
    {
      "location": "ma_fild01",
      "quantity": 67,
      "monsterName": "Tikbalang"
    }
  ],
  2316: [
    {
      "location": "ma_fild01",
      "quantity": 40,
      "monsterName": "Jejeling"
    },
    {
      "location": "ma_fild02",
      "quantity": 27,
      "monsterName": "Jejeling"
    }
  ],
  2309: [
    {
      "location": "ma_fild02",
      "quantity": 54,
      "monsterName": "Bungisngis"
    }
  ],
  2310: [
    {
      "location": "ma_fild02",
      "quantity": 34,
      "monsterName": "Engkanto"
    }
  ],
  2312: [
    {
      "location": "ma_fild02",
      "quantity": 41,
      "monsterName": "Mangkukulam"
    }
  ],
  1988: [
    {
      "location": "man_fild01",
      "quantity": 148,
      "monsterName": "Nepenthes"
    }
  ],
  1989: [
    {
      "location": "man_fild01",
      "quantity": 14,
      "monsterName": "Hillslion"
    },
    {
      "location": "man_fild03",
      "quantity": 33,
      "monsterName": "Hillslion"
    }
  ],
  1990: [
    {
      "location": "man_fild03",
      "quantity": 1,
      "monsterName": "Hardrock Mammoth"
    }
  ],
  1380: [
    {
      "location": "mjolnir_03",
      "quantity": 37,
      "monsterName": "Driller"
    },
    {
      "location": "mjolnir_04",
      "quantity": 162,
      "monsterName": "Driller"
    },
    {
      "location": "mjolnir_05",
      "quantity": 44,
      "monsterName": "Driller"
    }
  ],
  1494: [
    {
      "location": "mjolnir_07",
      "quantity": 34,
      "monsterName": "Beetle King"
    },
    {
      "location": "mjolnir_08",
      "quantity": 169,
      "monsterName": "Beetle King"
    },
    {
      "location": "mjolnir_10",
      "quantity": 41,
      "monsterName": "Beetle King"
    },
    {
      "location": "pay_fild10",
      "quantity": 64,
      "monsterName": "Beetle King"
    }
  ],
  1167: [
    {
      "location": "mjolnir_09",
      "quantity": 159,
      "monsterName": "Savage Babe"
    },
    {
      "location": "prt_fild00",
      "quantity": 26,
      "monsterName": "Savage Babe"
    },
    {
      "location": "prt_fild07",
      "quantity": 67,
      "monsterName": "Savage Babe"
    }
  ],
  1010: [
    {
      "location": "mjolnir_09",
      "quantity": 34,
      "monsterName": "Willow"
    },
    {
      "location": "pay_fild01",
      "quantity": 181,
      "monsterName": "Willow"
    },
    {
      "location": "pay_fild03",
      "quantity": 25,
      "monsterName": "Willow"
    }
  ],
  1004: [
    {
      "location": "mjolnir_09",
      "quantity": 34,
      "monsterName": "Hornet"
    },
    {
      "location": "prt_fild05",
      "quantity": 199,
      "monsterName": "Hornet"
    }
  ],
  1019: [
    {
      "location": "moc_fild01",
      "quantity": 93,
      "monsterName": "Peco Peco"
    },
    {
      "location": "moc_fild02",
      "quantity": 153,
      "monsterName": "Peco Peco"
    }
  ],
  1055: [
    {
      "location": "moc_fild01",
      "quantity": 202,
      "monsterName": "Muka"
    },
    {
      "location": "moc_fild02",
      "quantity": 58,
      "monsterName": "Muka"
    }
  ],
  1047: [
    {
      "location": "moc_fild01",
      "quantity": 31,
      "monsterName": "Peco Peco Egg"
    },
    {
      "location": "moc_fild02",
      "quantity": 11,
      "monsterName": "Peco Peco Egg"
    },
    {
      "location": "moc_fild07",
      "quantity": 15,
      "monsterName": "Peco Peco Egg"
    },
    {
      "location": "moc_fild12",
      "quantity": 45,
      "monsterName": "Peco Peco Egg"
    }
  ],
  1050: [
    {
      "location": "moc_fild07",
      "quantity": 23,
      "monsterName": "Picky"
    },
    {
      "location": "moc_fild12",
      "quantity": 65,
      "monsterName": "Picky"
    }
  ],
  1049: [
    {
      "location": "moc_fild07",
      "quantity": 15,
      "monsterName": "Picky"
    },
    {
      "location": "moc_fild12",
      "quantity": 65,
      "monsterName": "Picky"
    }
  ],
  1107: [
    {
      "location": "moc_fild11",
      "quantity": 137,
      "monsterName": "Baby Desert Wolf"
    },
    {
      "location": "moc_fild18",
      "quantity": 34,
      "monsterName": "Baby Desert Wolf"
    },
    {
      "location": "ra_fild01",
      "quantity": 22,
      "monsterName": "Baby Desert Wolf"
    },
    {
      "location": "ra_fild08",
      "quantity": 15,
      "monsterName": "Baby Desert Wolf"
    },
    {
      "location": "ra_fild12",
      "quantity": 24,
      "monsterName": "Baby Desert Wolf"
    }
  ],
  1009: [
    {
      "location": "moc_fild11",
      "quantity": 137,
      "monsterName": "Condor"
    },
    {
      "location": "moc_fild12",
      "quantity": 39,
      "monsterName": "Condor"
    },
    {
      "location": "moc_fild18",
      "quantity": 34,
      "monsterName": "Condor"
    }
  ],
  1001: [
    {
      "location": "moc_fild11",
      "quantity": 41,
      "monsterName": "Scorpion"
    },
    {
      "location": "moc_fild18",
      "quantity": 160,
      "monsterName": "Scorpion"
    }
  ],
  1138: [
    {
      "location": "moc_fild13",
      "quantity": 15,
      "monsterName": "Magnolia"
    },
    {
      "location": "prt_fild09",
      "quantity": 212,
      "monsterName": "Magnolia"
    }
  ],
  1165: [
    {
      "location": "moc_fild16",
      "quantity": 130,
      "monsterName": "Sandman"
    },
    {
      "location": "moc_fild17",
      "quantity": 39,
      "monsterName": "Sandman"
    }
  ],
  1127: [
    {
      "location": "moc_fild16",
      "quantity": 30,
      "monsterName": "Hode"
    },
    {
      "location": "moc_fild17",
      "quantity": 170,
      "monsterName": "Hode"
    }
  ],
  1119: [
    {
      "location": "moc_fild16",
      "quantity": 10,
      "monsterName": "Frilldora"
    },
    {
      "location": "moc_fild17",
      "quantity": 13,
      "monsterName": "Frilldora"
    }
  ],
  1159: [
    {
      "location": "moc_fild17",
      "quantity": 1,
      "monsterName": "Phreeoni"
    }
  ],
  1091: [
    {
      "location": "moc_fild18",
      "quantity": 1,
      "monsterName": "Dragon Fly"
    }
  ],
  1918: [
    {
      "location": "moc_fild20",
      "quantity": 1,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild21",
      "quantity": 79,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild22",
      "quantity": 73,
      "monsterName": "Incarnation of Morocc"
    }
  ],
  1919: [
    {
      "location": "moc_fild20",
      "quantity": 1,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild21",
      "quantity": 79,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild22",
      "quantity": 73,
      "monsterName": "Incarnation of Morocc"
    }
  ],
  1920: [
    {
      "location": "moc_fild20",
      "quantity": 1,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild21",
      "quantity": 79,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild22",
      "quantity": 73,
      "monsterName": "Incarnation of Morocc"
    }
  ],
  1921: [
    {
      "location": "moc_fild20",
      "quantity": 1,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild21",
      "quantity": 58,
      "monsterName": "Incarnation of Morocc"
    },
    {
      "location": "moc_fild22",
      "quantity": 50,
      "monsterName": "Incarnation of Morocc"
    }
  ],
  1917: [
    {
      "location": "moc_fild22",
      "quantity": 1,
      "monsterName": "Wounded Morocc"
    }
  ],
  1509: [
    {
      "location": "niflheim",
      "quantity": 35,
      "monsterName": "Lude"
    },
    {
      "location": "nif_fild02",
      "quantity": 10,
      "monsterName": "Lude"
    }
  ],
  1508: [
    {
      "location": "niflheim",
      "quantity": 35,
      "monsterName": "Quve"
    },
    {
      "location": "nif_fild01",
      "quantity": 33,
      "monsterName": "Quve"
    }
  ],
  1503: [
    {
      "location": "niflheim",
      "quantity": 17,
      "monsterName": "Gibbet"
    },
    {
      "location": "nif_fild01",
      "quantity": 11,
      "monsterName": "Gibbet"
    },
    {
      "location": "nif_fild02",
      "quantity": 20,
      "monsterName": "Gibbet"
    }
  ],
  1510: [
    {
      "location": "niflheim",
      "quantity": 17,
      "monsterName": "Heirozoist"
    },
    {
      "location": "nif_fild01",
      "quantity": 11,
      "monsterName": "Heirozoist"
    },
    {
      "location": "nif_fild02",
      "quantity": 10,
      "monsterName": "Heirozoist"
    }
  ],
  1504: [
    {
      "location": "niflheim",
      "quantity": 8,
      "monsterName": "Dullahan"
    },
    {
      "location": "nif_fild01",
      "quantity": 22,
      "monsterName": "Dullahan"
    },
    {
      "location": "nif_fild02",
      "quantity": 10,
      "monsterName": "Dullahan"
    }
  ],
  1506: [
    {
      "location": "nif_fild01",
      "quantity": 56,
      "monsterName": "Disguise"
    }
  ],
  1505: [
    {
      "location": "nif_fild02",
      "quantity": 21,
      "monsterName": "Loli Ruri"
    }
  ],
  1507: [
    {
      "location": "nif_fild02",
      "quantity": 11,
      "monsterName": "Bloody Murderer"
    }
  ],
  1024: [
    {
      "location": "pay_fild02",
      "quantity": 30,
      "monsterName": "Wormtail"
    },
    {
      "location": "pay_fild06",
      "quantity": 140,
      "monsterName": "Wormtail"
    },
    {
      "location": "pay_fild08",
      "quantity": 31,
      "monsterName": "Wormtail"
    }
  ],
  1582: [
    {
      "location": "pay_fild04",
      "quantity": 1,
      "monsterName": "Deviling"
    },
    {
      "location": "yuno_fild03",
      "quantity": 1,
      "monsterName": "Deviling"
    }
  ],
  1126: [
    {
      "location": "prt_fild11",
      "quantity": 60,
      "monsterName": "Goblin"
    }
  ],
  1392: [
    {
      "location": "prt_fild11",
      "quantity": 50,
      "monsterName": "Rotar Zairo"
    }
  ],
  1258: [
    {
      "location": "prt_fild11",
      "quantity": 50,
      "monsterName": "Goblin Archer"
    }
  ],
  1280: [
    {
      "location": "prt_fild11",
      "quantity": 30,
      "monsterName": "Goblin Steamrider"
    }
  ],
  1308: [
    {
      "location": "prt_fild11",
      "quantity": 1,
      "monsterName": "Panzer Goblin"
    }
  ],
  1106: [
    {
      "location": "ra_fild01",
      "quantity": 145,
      "monsterName": "Desert Wolf"
    },
    {
      "location": "ra_fild04",
      "quantity": 23,
      "monsterName": "Desert Wolf"
    }
  ],
  1680: [
    {
      "location": "ra_fild03",
      "quantity": 154,
      "monsterName": "Hill Wind"
    },
    {
      "location": "ra_fild04",
      "quantity": 155,
      "monsterName": "Hill Wind"
    },
    {
      "location": "ra_fild08",
      "quantity": 31,
      "monsterName": "Hill Wind"
    }
  ],
  1030: [
    {
      "location": "ra_fild03",
      "quantity": 23,
      "monsterName": "Anacondaq"
    },
    {
      "location": "ra_fild08",
      "quantity": 159,
      "monsterName": "Anacondaq"
    }
  ],
  1133: [
    {
      "location": "ra_fild05",
      "quantity": 81,
      "monsterName": "Kobold"
    },
    {
      "location": "ra_fild06",
      "quantity": 49,
      "monsterName": "Kobold"
    }
  ],
  1134: [
    {
      "location": "ra_fild05",
      "quantity": 81,
      "monsterName": "Kobold"
    },
    {
      "location": "ra_fild06",
      "quantity": 49,
      "monsterName": "Kobold"
    }
  ],
  1135: [
    {
      "location": "ra_fild05",
      "quantity": 81,
      "monsterName": "Kobold"
    },
    {
      "location": "ra_fild06",
      "quantity": 49,
      "monsterName": "Kobold"
    }
  ],
  1282: [
    {
      "location": "ra_fild06",
      "quantity": 87,
      "monsterName": "Kobold Archer"
    }
  ],
  1993: [
    {
      "location": "spl_fild01",
      "quantity": 68,
      "monsterName": "Naga"
    },
    {
      "location": "spl_fild03",
      "quantity": 42,
      "monsterName": "Naga"
    }
  ],
  1995: [
    {
      "location": "spl_fild02",
      "quantity": 135,
      "monsterName": "Pinguicula"
    }
  ],
  1991: [
    {
      "location": "spl_fild03",
      "quantity": 2,
      "monsterName": "Tendrilion"
    }
  ],
  1493: [
    {
      "location": "um_fild01",
      "quantity": 97,
      "monsterName": "Dryad"
    }
  ],
  1495: [
    {
      "location": "um_fild01",
      "quantity": 40,
      "monsterName": "Stone Shooter"
    },
    {
      "location": "um_fild02",
      "quantity": 25,
      "monsterName": "Stone Shooter"
    },
    {
      "location": "um_fild03",
      "quantity": 30,
      "monsterName": "Stone Shooter"
    },
    {
      "location": "um_fild04",
      "quantity": 19,
      "monsterName": "Stone Shooter"
    }
  ],
  1498: [
    {
      "location": "um_fild01",
      "quantity": 16,
      "monsterName": "Wootan Shooter"
    },
    {
      "location": "um_fild02",
      "quantity": 17,
      "monsterName": "Wootan Shooter"
    },
    {
      "location": "um_fild03",
      "quantity": 20,
      "monsterName": "Wootan Shooter"
    },
    {
      "location": "um_fild04",
      "quantity": 6,
      "monsterName": "Wootan Shooter"
    }
  ],
  1499: [
    {
      "location": "um_fild01",
      "quantity": 16,
      "monsterName": "Wootan Fighter"
    },
    {
      "location": "um_fild02",
      "quantity": 68,
      "monsterName": "Wootan Fighter"
    },
    {
      "location": "um_fild03",
      "quantity": 20,
      "monsterName": "Wootan Fighter"
    },
    {
      "location": "um_fild04",
      "quantity": 6,
      "monsterName": "Wootan Fighter"
    }
  ],
  1497: [
    {
      "location": "um_fild01",
      "quantity": 16,
      "monsterName": "Wooden Golem"
    },
    {
      "location": "um_fild04",
      "quantity": 12,
      "monsterName": "Wooden Golem"
    }
  ],
  1500: [
    {
      "location": "um_fild03",
      "quantity": 121,
      "monsterName": "Parasite"
    }
  ],
  1261: [
    {
      "location": "um_fild04",
      "quantity": 38,
      "monsterName": "Wild Rose"
    }
  ],
  1783: [
    {
      "location": "ve_fild01",
      "quantity": 60,
      "monsterName": "Galion"
    },
    {
      "location": "ve_fild02",
      "quantity": 13,
      "monsterName": "Galion"
    },
    {
      "location": "ve_fild04",
      "quantity": 22,
      "monsterName": "Galion"
    }
  ],
  1784: [
    {
      "location": "ve_fild01",
      "quantity": 34,
      "monsterName": "Stapo"
    },
    {
      "location": "ve_fild07",
      "quantity": 128,
      "monsterName": "Stapo"
    }
  ],
  1781: [
    {
      "location": "ve_fild01",
      "quantity": 34,
      "monsterName": "Drosera"
    },
    {
      "location": "ve_fild02",
      "quantity": 177,
      "monsterName": "Drosera"
    },
    {
      "location": "ve_fild03",
      "quantity": 38,
      "monsterName": "Drosera"
    },
    {
      "location": "ve_fild04",
      "quantity": 55,
      "monsterName": "Drosera"
    },
    {
      "location": "ve_fild07",
      "quantity": 64,
      "monsterName": "Drosera"
    }
  ],
  1386: [
    {
      "location": "yuno_fild02",
      "quantity": 185,
      "monsterName": "Sleeper"
    },
    {
      "location": "yuno_fild03",
      "quantity": 46,
      "monsterName": "Sleeper"
    },
    {
      "location": "yuno_fild06",
      "quantity": 117,
      "monsterName": "Sleeper"
    },
    {
      "location": "yuno_fild09",
      "quantity": 42,
      "monsterName": "Sleeper"
    }
  ],
  1369: [
    {
      "location": "yuno_fild02",
      "quantity": 50,
      "monsterName": "Grand Peco"
    },
    {
      "location": "yuno_fild07",
      "quantity": 30,
      "monsterName": "Grand Peco"
    },
    {
      "location": "yuno_fild08",
      "quantity": 157,
      "monsterName": "Grand Peco"
    },
    {
      "location": "yuno_fild09",
      "quantity": 182,
      "monsterName": "Grand Peco"
    }
  ],
  1376: [
    {
      "location": "yuno_fild02",
      "quantity": 50,
      "monsterName": "Harpy"
    },
    {
      "location": "yuno_fild03",
      "quantity": 174,
      "monsterName": "Harpy"
    },
    {
      "location": "yuno_fild04",
      "quantity": 133,
      "monsterName": "Harpy"
    },
    {
      "location": "yuno_fild07",
      "quantity": 50,
      "monsterName": "Harpy"
    }
  ],
  1372: [
    {
      "location": "yuno_fild03",
      "quantity": 46,
      "monsterName": "Goat"
    },
    {
      "location": "yuno_fild04",
      "quantity": 36,
      "monsterName": "Goat"
    },
    {
      "location": "yuno_fild07",
      "quantity": 90,
      "monsterName": "Goat"
    },
    {
      "location": "yuno_fild08",
      "quantity": 36,
      "monsterName": "Goat"
    },
    {
      "location": "yuno_fild11",
      "quantity": 139,
      "monsterName": "Goat"
    }
  ],
  1388: [
    {
      "location": "yuno_fild04",
      "quantity": 1,
      "monsterName": "Arc Angeling"
    }
  ]
};
